/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per GeneratorResume behavior specified since ES2015:
        // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
        // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next method, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable != null) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    throw new TypeError(typeof iterable + " is not iterable");
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  typeof module === "object" ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
 var LZString=function(){var r=String.fromCharCode,o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",n="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$",e={};function t(r,o){if(!e[r]){e[r]={};for(var n=0;n<r.length;n++)e[r][r.charAt(n)]=n}return e[r][o]}var i={compressToBase64:function(r){if(null==r)return"";var n=i._compress(r,6,function(r){return o.charAt(r)});switch(n.length%4){default:case 0:return n;case 1:return n+"===";case 2:return n+"==";case 3:return n+"="}},decompressFromBase64:function(r){return null==r?"":""==r?null:i._decompress(r.length,32,function(n){return t(o,r.charAt(n))})},compressToUTF16:function(o){return null==o?"":i._compress(o,15,function(o){return r(o+32)})+" "},decompressFromUTF16:function(r){return null==r?"":""==r?null:i._decompress(r.length,16384,function(o){return r.charCodeAt(o)-32})},compressToUint8Array:function(r){for(var o=i.compress(r),n=new Uint8Array(2*o.length),e=0,t=o.length;e<t;e++){var s=o.charCodeAt(e);n[2*e]=s>>>8,n[2*e+1]=s%256}return n},decompressFromUint8Array:function(o){if(null==o)return i.decompress(o);for(var n=new Array(o.length/2),e=0,t=n.length;e<t;e++)n[e]=256*o[2*e]+o[2*e+1];var s=[];return n.forEach(function(o){s.push(r(o))}),i.decompress(s.join(""))},compressToEncodedURIComponent:function(r){return null==r?"":i._compress(r,6,function(r){return n.charAt(r)})},decompressFromEncodedURIComponent:function(r){return null==r?"":""==r?null:(r=r.replace(/ /g,"+"),i._decompress(r.length,32,function(o){return t(n,r.charAt(o))}))},compress:function(o){return i._compress(o,16,function(o){return r(o)})},_compress:function(r,o,n){if(null==r)return"";var e,t,i,s={},u={},a="",p="",c="",l=2,f=3,h=2,d=[],m=0,v=0;for(i=0;i<r.length;i+=1)if(a=r.charAt(i),Object.prototype.hasOwnProperty.call(s,a)||(s[a]=f++,u[a]=!0),p=c+a,Object.prototype.hasOwnProperty.call(s,p))c=p;else{if(Object.prototype.hasOwnProperty.call(u,c)){if(c.charCodeAt(0)<256){for(e=0;e<h;e++)m<<=1,v==o-1?(v=0,d.push(n(m)),m=0):v++;for(t=c.charCodeAt(0),e=0;e<8;e++)m=m<<1|1&t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t>>=1}else{for(t=1,e=0;e<h;e++)m=m<<1|t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t=0;for(t=c.charCodeAt(0),e=0;e<16;e++)m=m<<1|1&t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t>>=1}0==--l&&(l=Math.pow(2,h),h++),delete u[c]}else for(t=s[c],e=0;e<h;e++)m=m<<1|1&t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t>>=1;0==--l&&(l=Math.pow(2,h),h++),s[p]=f++,c=String(a)}if(""!==c){if(Object.prototype.hasOwnProperty.call(u,c)){if(c.charCodeAt(0)<256){for(e=0;e<h;e++)m<<=1,v==o-1?(v=0,d.push(n(m)),m=0):v++;for(t=c.charCodeAt(0),e=0;e<8;e++)m=m<<1|1&t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t>>=1}else{for(t=1,e=0;e<h;e++)m=m<<1|t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t=0;for(t=c.charCodeAt(0),e=0;e<16;e++)m=m<<1|1&t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t>>=1}0==--l&&(l=Math.pow(2,h),h++),delete u[c]}else for(t=s[c],e=0;e<h;e++)m=m<<1|1&t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t>>=1;0==--l&&(l=Math.pow(2,h),h++)}for(t=2,e=0;e<h;e++)m=m<<1|1&t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t>>=1;for(;;){if(m<<=1,v==o-1){d.push(n(m));break}v++}return d.join("")},decompress:function(r){return null==r?"":""==r?null:i._decompress(r.length,32768,function(o){return r.charCodeAt(o)})},_decompress:function(o,n,e){var t,i,s,u,a,p,c,l=[],f=4,h=4,d=3,m="",v=[],g={val:e(0),position:n,index:1};for(t=0;t<3;t+=1)l[t]=t;for(s=0,a=Math.pow(2,2),p=1;p!=a;)u=g.val&g.position,g.position>>=1,0==g.position&&(g.position=n,g.val=e(g.index++)),s|=(u>0?1:0)*p,p<<=1;switch(s){case 0:for(s=0,a=Math.pow(2,8),p=1;p!=a;)u=g.val&g.position,g.position>>=1,0==g.position&&(g.position=n,g.val=e(g.index++)),s|=(u>0?1:0)*p,p<<=1;c=r(s);break;case 1:for(s=0,a=Math.pow(2,16),p=1;p!=a;)u=g.val&g.position,g.position>>=1,0==g.position&&(g.position=n,g.val=e(g.index++)),s|=(u>0?1:0)*p,p<<=1;c=r(s);break;case 2:return""}for(l[3]=c,i=c,v.push(c);;){if(g.index>o)return"";for(s=0,a=Math.pow(2,d),p=1;p!=a;)u=g.val&g.position,g.position>>=1,0==g.position&&(g.position=n,g.val=e(g.index++)),s|=(u>0?1:0)*p,p<<=1;switch(c=s){case 0:for(s=0,a=Math.pow(2,8),p=1;p!=a;)u=g.val&g.position,g.position>>=1,0==g.position&&(g.position=n,g.val=e(g.index++)),s|=(u>0?1:0)*p,p<<=1;l[h++]=r(s),c=h-1,f--;break;case 1:for(s=0,a=Math.pow(2,16),p=1;p!=a;)u=g.val&g.position,g.position>>=1,0==g.position&&(g.position=n,g.val=e(g.index++)),s|=(u>0?1:0)*p,p<<=1;l[h++]=r(s),c=h-1,f--;break;case 2:return v.join("")}if(0==f&&(f=Math.pow(2,d),d++),l[c])m=l[c];else{if(c!==h)return null;m=i+i.charAt(0)}v.push(m),l[h++]=i+m.charAt(0),i=m,0==--f&&(f=Math.pow(2,d),d++)}}};return i}();"function"==typeof define&&define.amd?define(function(){return LZString}):"undefined"!=typeof module&&null!=module?module.exports=LZString:"undefined"!=typeof angular&&null!=angular&&angular.module("LZString",[]).factory("LZString",function(){return LZString}); /**
 * Reusable Compass + Tilt controls for solar calculators.
 *
 * Provides two factory functions that create interactive SVG-based
 * azimuth (compass) and tilt (roof pitch) controls inside any
 * container element. Both the simple cost calculator and the roof
 * sizing tool use these same controls.
 *
 * Dependencies:
 *   - Font Awesome (for cardinal-direction labels are rendered as SVG text)
 *   - jQuery + jQuery UI (for the tilt slider)
 *   - solar-calculator-formulas.js (for getFriendlyAzimuthName)
 *
 * Usage:
 *   var compass = createCompass(document.getElementById('my-compass'), {
 *       azimuth: 180,
 *       onChange: function(azimuthDeg) { console.log(azimuthDeg); }
 *   });
 *   compass.setAzimuth(90);  // programmatic update
 *
 *   var tilt = createTiltSlider(document.getElementById('my-tilt'), {
 *       tilt: 30,
 *       onChange: function(tiltDeg) { console.log(tiltDeg); }
 *   });
 *   tilt.setTilt(45);        // programmatic update
 */

(function(root) {
    'use strict';

    // ---- Cardinal direction names (15° snap) ---------------------------
    function getDirectionName(azimuth) {
        var n = ((Math.round(azimuth / 15) * 15) % 360 + 360) % 360;
        var names = {
            0: 'N', 15: 'NNE', 30: 'NNE', 45: 'NE', 60: 'ENE', 75: 'ENE',
            90: 'E', 105: 'ESE', 120: 'ESE', 135: 'SE', 150: 'SSE', 165: 'SSE',
            180: 'S', 195: 'SSW', 210: 'SSW', 225: 'SW', 240: 'WSW', 255: 'WSW',
            270: 'W', 285: 'WNW', 300: 'WNW', 315: 'NW', 330: 'NNW', 345: 'NNW'
        };
        return names[n] || 'N';
    }

    // ---- Compass SVG geometry helpers ----------------------------------
    function compassHandleX(azimuth) {
        return (100 + 75 * Math.sin(azimuth * Math.PI / 180)).toFixed(2);
    }
    function compassHandleY(azimuth) {
        return (100 - 75 * Math.cos(azimuth * Math.PI / 180)).toFixed(2);
    }

    // ---- Tilt SVG geometry helpers -------------------------------------
    function tiltLineX2(degrees) {
        var rad = degrees * Math.PI / 180;
        return (20 + 65 * Math.cos(rad)).toFixed(2);
    }
    function tiltLineY2(degrees) {
        var rad = degrees * Math.PI / 180;
        return (70 - 65 * Math.sin(rad)).toFixed(2);
    }
    function tiltArcPath(degrees) {
        if (degrees <= 0) return '';
        var rad = degrees * Math.PI / 180, r = 24;
        var ex = (20 + r * Math.cos(rad)).toFixed(2);
        var ey = (70 - r * Math.sin(rad)).toFixed(2);
        return 'M ' + (20 + r) + ',70 A ' + r + ',' + r + ' 0 0,0 ' + ex + ',' + ey;
    }

    // =====================================================================
    // bindCompassControl(container, options)
    // =====================================================================
    // Binds interaction to EXISTING compass markup (non-destructive).
    // Expected descendants in container:
    //   - svg element
    //   - rotating inner group (.ct-compass-inner or #compass-inner)
    //   - handle circle (.ct-compass-handle or #compass-handle)
    // Returns:
    //   { setAzimuth(deg), getAzimuth(), getDirectionName(), destroy() }
    // =====================================================================
    root.bindCompassControl = function(container, options) {
        if (!container) throw new Error('bindCompassControl: container element required');
        options = options || {};

        var azimuth  = options.azimuth != null ? options.azimuth : 180;
        var size     = options.size || null;
        var onChange = options.onChange || function() {};

        var svg = options.svg || container.querySelector('svg');
        var innerG = options.innerG
            || container.querySelector('.ct-compass-inner')
            || container.querySelector('#compass-inner')
            || container.querySelector('g[id$="-inner"]');
        var handle = options.handle
            || container.querySelector('.ct-compass-handle')
            || container.querySelector('#compass-handle')
            || container.querySelector('circle[id$="-handle"]');

        if (!svg || !innerG || !handle) {
            throw new Error('bindCompassControl: expected svg/inner/handle markup is missing');
        }

        if (size) {
            svg.style.width = size + 'px';
            svg.style.height = size + 'px';
        }

        var dragging = false;

        function angleFromEvent(clientX, clientY) {
            var rect = svg.getBoundingClientRect();
            var scaleX = 200 / rect.width;
            var scaleY = 200 / rect.height;
            var x = (clientX - rect.left) * scaleX - 100;
            var y = (clientY - rect.top) * scaleY - 100;
            if (Math.sqrt(x * x + y * y) < 40) return null;
            var angle = Math.atan2(x, -y) * 180 / Math.PI;
            if (angle < 0) angle += 360;
            return Math.round(angle / 15) * 15 % 360;
        }

        function updateVisual(deg) {
            azimuth = deg;
            innerG.setAttribute('transform', 'rotate(' + deg + ', 100, 100)');
            handle.setAttribute('cx', compassHandleX(deg));
            handle.setAttribute('cy', compassHandleY(deg));
        }

        function onMouseDown(e) {
            var a = angleFromEvent(e.clientX, e.clientY);
            if (a !== null) { dragging = true; updateVisual(a); onChange(a); }
            e.preventDefault();
        }

        function onMouseMove(e) {
            if (!dragging) return;
            if (!container.contains(svg)) { dragging = false; return; }
            var rect = svg.getBoundingClientRect();
            var x = (e.clientX - rect.left) * (200 / rect.width) - 100;
            var y = (e.clientY - rect.top) * (200 / rect.height) - 100;
            var angle = Math.atan2(x, -y) * 180 / Math.PI;
            if (angle < 0) angle += 360;
            var snapped = Math.round(angle / 15) * 15 % 360;
            updateVisual(snapped);
            onChange(snapped);
        }

        function onMouseUp() { dragging = false; }

        function onTouchStart(e) {
            var t = e.touches[0];
            var a = angleFromEvent(t.clientX, t.clientY);
            if (a !== null) { dragging = true; updateVisual(a); onChange(a); }
            e.preventDefault();
        }

        function onTouchMove(e) {
            if (!dragging) return;
            if (!container.contains(svg)) { dragging = false; return; }
            var t = e.touches[0];
            var a = angleFromEvent(t.clientX, t.clientY);
            if (a !== null) { updateVisual(a); onChange(a); }
            e.preventDefault();
        }

        function onTouchEnd() { dragging = false; }

        svg.addEventListener('mousedown', onMouseDown);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);

        svg.addEventListener('touchstart', onTouchStart, { passive: false });
        svg.addEventListener('touchmove', onTouchMove, { passive: false });
        svg.addEventListener('touchend', onTouchEnd);

        updateVisual(azimuth);

        return {
            setAzimuth: function(deg) { updateVisual(deg); },
            getAzimuth: function() { return azimuth; },
            getDirectionName: function() { return getDirectionName(azimuth); },
            destroy: function() {
                svg.removeEventListener('mousedown', onMouseDown);
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', onMouseUp);
                svg.removeEventListener('touchstart', onTouchStart);
                svg.removeEventListener('touchmove', onTouchMove);
                svg.removeEventListener('touchend', onTouchEnd);
            }
        };
    };

    // =====================================================================
    // bindTiltSliderControl(container, options)
    // =====================================================================
    // Binds interaction to EXISTING tilt markup (non-destructive).
    // Expected descendants in container:
    //   - line element (.ct-tilt-line or #tilt-line)
    //   - path element (.ct-tilt-arc or #tilt-arc)
    //   - slider element (.ct-tilt-slider-ui or #tilt-slider)
    // Returns:
    //   { setTilt(deg), getTilt(), destroy() }
    // =====================================================================
    root.bindTiltSliderControl = function(container, options) {
        if (!container) throw new Error('bindTiltSliderControl: container element required');
        options = options || {};

        var tilt = options.tilt != null ? options.tilt : 30;
        var onChange = options.onChange || function() {};

        var lineEl = options.lineEl || container.querySelector('.ct-tilt-line') || container.querySelector('#tilt-line');
        var arcEl = options.arcEl || container.querySelector('.ct-tilt-arc') || container.querySelector('#tilt-arc');
        var sliderEl = options.sliderEl || container.querySelector('.ct-tilt-slider-ui') || container.querySelector('#tilt-slider');

        if (!lineEl || !arcEl || !sliderEl) {
            throw new Error('bindTiltSliderControl: expected line/arc/slider markup is missing');
        }

        function updateTiltVisual(degrees) {
            lineEl.setAttribute('x2', tiltLineX2(degrees));
            lineEl.setAttribute('y2', tiltLineY2(degrees));
            arcEl.setAttribute('d', tiltArcPath(degrees));
        }

        updateTiltVisual(tilt);

        if (typeof $ !== 'undefined' && $.fn.slider) {
            var $slider = $(sliderEl);
            if ($slider.hasClass('ui-slider')) {
                try { $slider.slider('destroy'); } catch (e) {}
            }

            $slider.slider({
                min: 0,
                max: 70,
                step: 5,
                value: tilt,
                range: 'min',
                slide: function(event, ui) {
                    tilt = ui.value;
                    updateTiltVisual(ui.value);
                    onChange(ui.value);
                },
                change: function(event, ui) {
                    tilt = ui.value;
                    updateTiltVisual(ui.value);
                    onChange(ui.value);
                }
            });
        }

        return {
            setTilt: function(deg) {
                tilt = deg;
                if (typeof $ !== 'undefined' && $.fn.slider) {
                    $(sliderEl).slider('value', deg);
                }
                updateTiltVisual(deg);
            },
            getTilt: function() { return tilt; },
            destroy: function() {
                if (typeof $ !== 'undefined' && $.fn.slider) {
                    var $slider = $(sliderEl);
                    if ($slider.hasClass('ui-slider')) {
                        try { $slider.slider('destroy'); } catch (e) {}
                    }
                }
            }
        };
    };

    // =====================================================================
    // createCompass(container, options)
    // =====================================================================
    // Options:
    //   azimuth   — initial azimuth in degrees (default 180 = south)
    //   size      — width/height in px (default 160)
    //   onChange  — callback(azimuthDeg) called when user drags the handle
    // Returns:
    //   { setAzimuth(deg), getAzimuth(), destroy() }
    // =====================================================================
    root.createCompass = function(container, options) {
        if (!container) throw new Error('createCompass: container element required');
        options = options || {};
        var azimuth    = options.azimuth != null ? options.azimuth : 180;
        var size       = options.size || 160;
        var onChange   = options.onChange || function() {};
        var uid        = 'ct-compass-' + (++createCompass._uid);

        // Build SVG
        var svgNS = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(svgNS, 'svg');
        svg.setAttribute('viewBox', '0 0 200 200');
        svg.setAttribute('xmlns', svgNS);
        svg.classList.add('ct-compass-svg');
        svg.id = uid;
        svg.style.width = size + 'px';
        svg.style.height = size + 'px';

        function h(tag, attrs) {
            var el = document.createElementNS(svgNS, tag);
            for (var k in attrs) el.setAttribute(k, attrs[k]);
            return el;
        }

        // Track
        svg.appendChild(h('circle', { cx:100, cy:100, r:75, fill:'none', 'class':'ct-compass-track' }));
        // Tick marks
        [0,90,180,270].forEach(function(a) {
            var r = a * Math.PI / 180;
            var x1 = (100 + 85 * Math.sin(r)).toFixed(1);
            var y1 = (100 - 85 * Math.cos(r)).toFixed(1);
            var x2 = (100 + 93 * Math.sin(r)).toFixed(1);
            var y2 = (100 - 93 * Math.cos(r)).toFixed(1);
            svg.appendChild(h('line', { x1:x1, y1:y1, x2:x2, y2:y2, stroke:'#b0bac6', 'stroke-width':'1.5', 'stroke-linecap':'round' }));
        });
        // Labels
        svg.appendChild(h('text', { x:100, y:14, 'text-anchor':'middle', 'dominant-baseline':'middle', 'class':'ct-compass-label' }));
        svg.lastChild.textContent = 'N';
        svg.appendChild(h('text', { x:188, y:100, 'text-anchor':'middle', 'dominant-baseline':'middle', 'class':'ct-compass-label' }));
        svg.lastChild.textContent = 'E';
        svg.appendChild(h('text', { x:100, y:188, 'text-anchor':'middle', 'dominant-baseline':'middle', 'class':'ct-compass-label' }));
        svg.lastChild.textContent = 'S';
        svg.appendChild(h('text', { x:12, y:100, 'text-anchor':'middle', 'dominant-baseline':'middle', 'class':'ct-compass-label' }));
        svg.lastChild.textContent = 'W';

        // Inner rotating group
        var innerG = h('g', { id: uid + '-inner', transform: 'rotate(' + azimuth + ', 100, 100)' });
        innerG.appendChild(h('rect', { x:64, y:100, width:72, height:24, fill:'#e8ecf2' }));
        innerG.appendChild(h('rect', { x:64, y:76, width:72, height:24, fill:'#2d4a7a' }));
        [82,100,118].forEach(function(cx) {
            innerG.appendChild(h('line', { x1:cx, y1:76, x2:cx, y2:100, stroke:'#fff', 'stroke-width':'1' }));
        });
        innerG.appendChild(h('line', { x1:64, y1:88, x2:136, y2:88, stroke:'#fff', 'stroke-width':'1' }));
        innerG.appendChild(h('rect', { x:64, y:76, width:72, height:48, rx:2, fill:'none', stroke:'#9aa5b4', 'stroke-width':'1.5' }));
        innerG.appendChild(h('line', { x1:64, y1:100, x2:136, y2:100, stroke:'#9aa5b4', 'stroke-width':'1.5' }));
        innerG.appendChild(h('line', { x1:100, y1:76, x2:100, y2:42, stroke:'#e45f31', 'stroke-width':'2', 'stroke-linecap':'round' }));
        innerG.appendChild(h('polygon', { points:'100,36 95,45 105,45', fill:'#e45f31' }));
        svg.appendChild(innerG);

        // Draggable handle
        var handle = h('circle', { id: uid + '-handle', 'class':'ct-compass-handle', cx:compassHandleX(azimuth), cy:compassHandleY(azimuth), r:9 });
        svg.appendChild(handle);

        container.innerHTML = '';
        container.appendChild(svg);

        var binding = root.bindCompassControl(container, {
            azimuth: azimuth,
            size: size,
            onChange: onChange,
            svg: svg,
            innerG: innerG,
            handle: handle
        });

        return {
            setAzimuth: binding.setAzimuth,
            getAzimuth: binding.getAzimuth,
            getDirectionName: binding.getDirectionName,
            destroy: function() {
                binding.destroy();
                container.innerHTML = '';
            }
        };
    };
    createCompass._uid = 0;

    // =====================================================================
    // createTiltSlider(container, options)
    // =====================================================================
    // Options:
    //   tilt      — initial tilt in degrees (default 30)
    //   onChange  — callback(tiltDeg) called when slider changes
    // Requires jQuery + jQuery UI.
    // Returns:
    //   { setTilt(deg), getTilt(), destroy() }
    // =====================================================================
    root.createTiltSlider = function(container, options) {
        if (!container) throw new Error('createTiltSlider: container element required');
        options = options || {};
        var tilt      = options.tilt != null ? options.tilt : 30;
        var onChange  = options.onChange || function() {};
        var uid       = 'ct-tilt-' + (++createTiltSlider._uid);

        // Build wrapper
        container.innerHTML = '';
        var wrap = document.createElement('div');
        wrap.className = 'ct-tilt-wrap';

        // SVG diagram
        var svgNS = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(svgNS, 'svg');
        svg.setAttribute('viewBox', '0 0 150 80');
        svg.classList.add('ct-tilt-svg');
        svg.id = uid + '-svg';

        function h(tag, attrs) {
            var el = document.createElementNS(svgNS, tag);
            for (var k in attrs) el.setAttribute(k, attrs[k]);
            return el;
        }

        svg.appendChild(h('line', { x1:20, y1:70, x2:140, y2:70, stroke:'#b0bac6', 'stroke-width':'2.5', 'stroke-linecap':'round' }));
        svg.appendChild(h('path', { id: uid + '-arc', d: tiltArcPath(tilt), stroke:'#e45f31', 'stroke-width':'1.5', fill:'none', 'stroke-linecap':'round' }));
        svg.appendChild(h('line', { id: uid + '-line', x1:20, y1:70, x2: tiltLineX2(tilt), y2: tiltLineY2(tilt), stroke:'#e45f31', 'stroke-width':'3', 'stroke-linecap':'round' }));

        wrap.appendChild(svg);

        // jQuery UI slider
        var sliderDiv = document.createElement('div');
        sliderDiv.id = uid + '-slider';
        sliderDiv.className = 'ct-tilt-slider-ui';
        wrap.appendChild(sliderDiv);

        // Scale labels
        var scale = document.createElement('div');
        scale.className = 'ct-tilt-scale';
        scale.innerHTML = '<span>0\u00b0</span><span>35\u00b0</span><span>70\u00b0</span>';
        wrap.appendChild(scale);

        container.appendChild(wrap);

        var binding = root.bindTiltSliderControl(container, {
            tilt: tilt,
            onChange: onChange,
            lineEl: svg.querySelector('#' + uid + '-line'),
            arcEl: svg.querySelector('#' + uid + '-arc'),
            sliderEl: sliderDiv
        });

        return {
            setTilt: binding.setTilt,
            getTilt: binding.getTilt,
            destroy: function() {
                binding.destroy();
                container.innerHTML = '';
            }
        };
    };
    createTiltSlider._uid = 0;

})(window);
 function formatPrice(number) {
  if (isNaN(number)) {
    throw new Error("Invalid number");
  }

  const formattedNumber = number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  return "&euro;" + formattedNumber;
}

function calculateHorizontalLength(hypotenuseLength, angleInDegrees) {
  // Convert the angle from degrees to radians
  var angleInRadians = (angleInDegrees * Math.PI) / 180;

  // Calculate the horizontal length (adjacent side)
  var horizontalLength = hypotenuseLength * Math.cos(angleInRadians);

  return horizontalLength;
}

function getFriendlyAzimuthName(azimuth) {
  const azimuthToName = {
    270: "W (270)",
    247.5: "WSW (247.5)",
    225: "SW (225)",
    202.5: "SSW (202.5)",
    180: "S (180)",
    157.5: "SSE (157.5)",
    135: "SE (135)",
    112.5: "ESE (112.5)",
    90: "E (90)",
  };
  return azimuthToName[azimuth] || azimuth;
}

function calculateArrayKwp(panelWp, panelCount) {
  const arrayKwp = (panelWp / 1000) * panelCount;
  return arrayKwp;
}

// JS mirror of getCountyCorrectionVsDublin() in sitewide-variables.php.
// Returns the county's annual-yield deviation (%) relative to Dublin — the
// reference county for azimuthTiltData — so the value feeds straight into
// calculateAnnualGeneration()'s countyEffectPercent. Dublin returns 0.
// Requires the `countyKwhPerKwp` global emitted by sitewide-variables.php.
// Unknown/empty county names return 0 (no correction).
function getCountyCorrectionVsDublin(countyName) {
  if (
    typeof countyKwhPerKwp === "undefined" ||
    countyKwhPerKwp == null ||
    !countyName ||
    countyKwhPerKwp[countyName] == null ||
    countyKwhPerKwp["Dublin"] == null
  ) {
    return 0;
  }
  const countyValue = countyKwhPerKwp[countyName];
  const dublinValue = countyKwhPerKwp["Dublin"];
  return ((countyValue - dublinValue) / dublinValue) * 100;
}

// Retrieve AnnualGenerationPerKwp for any azimuth/tilt using bilinear interpolation
// across the PVGIS 15°×5° grid (azimuth 0–345°, tilt 0–90°).
// Exact grid matches return the exact stored value; intermediate values are interpolated.
// Azimuth wraps correctly (e.g. between 345° and 0°).
function getAnnualGenerationPerKwp(azimuth, tilt) {
  // Normalise inputs to valid grid range.
  azimuth = ((azimuth % 360) + 360) % 360;
  tilt    = Math.max(0, Math.min(90, tilt));

  const AZIMUTH_STEP = 15;
  const TILT_STEP    = 5;

  // Build a keyed lookup index once and cache it on the function object.
  if (!getAnnualGenerationPerKwp._index) {
    const idx = {};
    for (const entry of azimuthTiltData) {
      idx[entry.azimuth + '_' + entry.tilt] = entry.AnnualGenerationPerKwp;
    }
    getAnnualGenerationPerKwp._index = idx;
  }
  const idx = getAnnualGenerationPerKwp._index;

  // Identify the four surrounding grid-cell corners (azimuth wraps 345→0).
  const az0 = Math.floor(azimuth / AZIMUTH_STEP) * AZIMUTH_STEP;
  const az1 = (az0 + AZIMUTH_STEP) % 360;
  const t0  = Math.floor(tilt / TILT_STEP) * TILT_STEP;
  const t1  = Math.min(90, t0 + TILT_STEP);

  const v00 = idx[az0 + '_' + t0];
  const v10 = idx[az1 + '_' + t0];
  const v01 = idx[az0 + '_' + t1];
  const v11 = idx[az1 + '_' + t1];

  if (v00 == null || v10 == null || v01 == null || v11 == null) {
    return null;
  }

  // Fractional positions within the cell [0, 1].
  const ta = (azimuth - az0) / AZIMUTH_STEP;
  const tt = t0 === t1 ? 0 : (tilt - t0) / TILT_STEP;

  // Interpolate across azimuth at each tilt boundary, then across tilt.
  const row0 = v00 * (1 - ta) + v10 * ta;
  const row1 = v01 * (1 - ta) + v11 * ta;
  return row0 * (1 - tt) + row1 * tt;
}

function getChangeDueToAzimuthTilt(baseAzimuth, baseTilt, newAzimuth, newTilt) {
  var baseProduction = getAnnualGenerationPerKwp(baseAzimuth, baseTilt);

  var newProduction = getAnnualGenerationPerKwp(newAzimuth, newTilt);

  return newProduction / baseProduction;
}

function calculateAnnualGeneration(
  arrayKwp,
  roofAzimuth,
  roofSlope,
  countyEffectPercent,
  inverterKwAC
) {
  // inverterKwAC === null (or omitted) means "inverter clipping not applicable"
  // (e.g. commercial/farm systems with properly-sized inverters).
  // Domestic callers must pass defaultInverterKwAC explicitly.
  var clippingLoss = (inverterKwAC !== undefined && inverterKwAC !== null)
    ? calculateInverterClippingLossPercent(arrayKwp, inverterKwAC)
    : 0;

  const annualGenerationInKwh =
    arrayKwp *
    getAnnualGenerationPerKwp(roofAzimuth, roofSlope) *
    (1 + countyEffectPercent / 100) *
    (1 - clippingLoss / 100);

  return annualGenerationInKwh;
}

function calculateNdmgGrantValue(arrayKwp) {
  let grantValue = 0;

  if (arrayKwp < 1 || arrayKwp > 1000) {
    grantValue = 0; // no grant if under 1kWp or over 1000 kWp
  } else if (arrayKwp >= 1 && arrayKwp <= 2) {
    grantValue = arrayKwp * ndmgGrantTiers.rate1to2;
  } else if (arrayKwp > 2 && arrayKwp <= 4) {
    grantValue = calculateNdmgGrantValue(2) + (arrayKwp - 2) * ndmgGrantTiers.rate2to4;
  } else if (arrayKwp > 4 && arrayKwp <= 6) {
    grantValue = ndmgGrantTiers.fixed4to6;
  } else if (arrayKwp > 6 && arrayKwp <= 20) {
    grantValue = calculateNdmgGrantValue(6) + (arrayKwp - 6) * ndmgGrantTiers.rate6to20;
  } else if (arrayKwp > 20 && arrayKwp <= 200) {
    grantValue = calculateNdmgGrantValue(20) + (arrayKwp - 20) * ndmgGrantTiers.rate20to200;
  } else if (arrayKwp > 200 && arrayKwp <= 1000) {
    grantValue = calculateNdmgGrantValue(200) + (arrayKwp - 200) * ndmgGrantTiers.rate200to1k;
  } else {
    grantValue = 0;
  }

  return grantValue;
}

function ndmgGrantDescription(arrayKwp) {
  if (arrayKwp < 1 || arrayKwp > 1000) {
    return "No grant for systems under 1 kWp or over 1,000 kWp";
  } else {
    return "";
  }
}


function calculateDomesticGrantValue(arrayKwp) {
  let grantValue = 0;
  // UpdateOnGrantChange

  if (arrayKwp > 0 && arrayKwp <= 2) {
    grantValue = arrayKwp * domesticGrantTiers.rate0to2;
  } else if (arrayKwp > 2 && arrayKwp <= 4) {
    grantValue = calculateDomesticGrantValue(2) + (arrayKwp - 2) * domesticGrantTiers.rate2to4;
  } else {
    grantValue = domesticGrantTiers.maxGrant;
  }

  return grantValue;
}

function domesticGrantDescription(arrayKwp) {
  // UpdateOnGrantChange
  let description = "2026 grant: ";

  if (arrayKwp > 0 && arrayKwp <= 2) {
    description += `&euro;${domesticGrantTiers.rate0to2} per kWp for the first 2 kWp`;
  } else if (arrayKwp > 2 && arrayKwp <= 4) {
    description += `&euro;${domesticGrantTiers.rate0to2} per kWp for the first 2 kWp, then &euro;${domesticGrantTiers.rate2to4} per kWp above that`;
  } else {
    description += `This is the maximum grant value (&euro;${domesticGrantTiers.maxGrant.toLocaleString('en')} for systems 4kWp or above)`;
  }

  return description;
}
//This calculator below is currently not used. It is the placeholder for 2027 grant values.
// UpdateOnGrantChange: When 2027 grant values are confirmed (typically announced autumn 2026),
// update the values here. Until then they default to the same as the current year (2026).
// Also update $domesticGrantTiers2026 (rename to 2027) in sitewide-variables.php.
function calculateDomesticGrantValueNextYear(arrayKwp) {
  // UpdateOnGrantChange
  let grantValue = 0;

  if (arrayKwp > 0 && arrayKwp <= 2) {
    grantValue = arrayKwp * domesticGrantTiers.rate0to2; // same as 2026 until 2027 values announced
  } else if (arrayKwp > 2 && arrayKwp <= 4) {
    grantValue = calculateDomesticGrantValueNextYear(2) + (arrayKwp - 2) * domesticGrantTiers.rate2to4; // same as 2026 until 2027 values announced
  } else {
    grantValue = domesticGrantTiers.maxGrant; // same as 2026 until 2027 values announced
  }

  return grantValue;
}

// UpdateOnGrantChange: when 2027 grant values are confirmed, update the description strings below.
function domesticGrantDescriptionNextYear(arrayKwp) {
  // UpdateOnGrantChange
  let description = "2027 grant: ";

  if (arrayKwp > 0 && arrayKwp <= 2) {
    description += "Full details of this grant have not yet been released"; // update Autumn 2026
  } else if (arrayKwp > 2 && arrayKwp <= 4) {
    description += "Full details of this grant have not yet been released"; // update Autumn 2026
  } else {
    description += "Full details of this grant have not yet been released"; // update Autumn 2026
  }

  return description;
}

function animateTotalStyle(totalClassName) {
  const subtotalElements = document.querySelectorAll("." + totalClassName);

  subtotalElements.forEach((element) => {
    // Save the original background color
    const originalColor = element.style.backgroundColor;

    // Apply new background color and transition
    element.style.transition = "background-color 0.5s ease-in-out";
    element.style.backgroundColor = "#fddb41"; // @brandColor2

    // After a delay, revert to the original background color
    setTimeout(() => {
      element.style.backgroundColor = originalColor;
    }, 500); // Change this value to match the transition duration
  });
}

// toggle advanced modes ****************************

function toggleAdvancedMode() {
  var toggleSwitch = document.getElementById("toggleAdvancedModeSwitch");
  var form = toggleSwitch.closest("form"); // Find the parent form of the checkbox
  var advancedOptions = form.querySelectorAll(".advancedOption");

  if (toggleSwitch.classList.contains("on")) {
    advancedOptions.forEach(function (element) {
      element.style.transition = "opacity 0.5s ease-in-out";
      element.style.opacity = "0";
      setTimeout(function () {
        element.style.display = "none";
      }, 500);
    });
  } else {
    var batteryKwhInput = form.querySelector("#batteryKwh");
    var batterySelected = batteryKwhInput && parseFloat(batteryKwhInput.value) > 0;
    advancedOptions.forEach(function (element) {
      // Battery-specific advanced rows only show when a battery is also selected
      if (element.classList.contains("batteryAdvancedOption") && !batterySelected) {
        return;
      }
      element.style.opacity = "0";
      element.style.display = "table-row";
      setTimeout(function () {
        element.style.transition = "opacity 0.5s ease-in-out";
        element.style.opacity = "1";
      }, 100);
    });
  }

  // Toggle the "on" class at the end
  toggleSwitch.classList.toggle("on");
}

// Function to toggle the switch and call its onclick event
function toggleSwitchAndClick() {
  var toggleSwitch = document.getElementById("toggleAdvancedModeSwitch");
  if (toggleSwitch) {
    toggleSwitch.click(); // Trigger the click event on the switch
  }
}

function turnOnAdvancedMode(event) {
  var toggleSwitch = document.getElementById("toggleAdvancedModeSwitch");
  if (!toggleSwitch.classList.contains("on")) {
    toggleSwitch.click(); // Trigger the click event on the switch
  }
  return false; // Prevent the default link behavior
}

// end of toggle advanced modes ****************************


// ============================================================
//  Consolidated calculator formulas (task 2.9)
// ------------------------------------------------------------
//  Per-calculator JS files should be thin controllers: read
//  form → call shared function → write DOM. No inline math.
//  These functions are the single source of truth for the
//  formulas they implement (per language).
//  Where a PHP equivalent exists, the file/function is named
//  in the comment. Keep names and signatures identical across
//  the two languages.
// ============================================================

// CO2 saved from solar generation (kg).
//   annualGenerationInKwh × co2SavingPerkWh
function calculateAnnualCo2Saved(annualGenerationInKwh, co2SavingPerkWh) {
  return annualGenerationInKwh * co2SavingPerkWh;
}

// Annual savings from solar = generation × blended price (self-consumed at day rate, exported at FIT).
// All rates are in cents/kWh; the trailing /100 converts cents to euros.
function calculateAnnualBillSavings(annualGenerationInKwh, daytimeRateCentsKwh, feedinTariffCentsKwh, selfConsumptionPercentage) {
  var selfFraction = selfConsumptionPercentage / 100;
  var exportFraction = 1 - selfFraction;
  return (annualGenerationInKwh * (daytimeRateCentsKwh * selfFraction + feedinTariffCentsKwh * exportFraction)) / 100;
}

// Roof area covered by one panel (m²), including the spacing gap on two sides.
// Mirrors PHP roofAreaCovered() in includes/solar-calculator-formulas.php (per-panel form).
function calculateRoofAreaPerPanel(panelWidthInMm, panelHeightInMm, panelSpacingInMm) {
  return (panelHeightInMm + panelSpacingInMm) / 1000 * (panelWidthInMm + panelSpacingInMm) / 1000;
}

// Inverter clipping loss percentage (0–10) based on the Inverter Loading Ratio (ILR = arrayKwp / inverterKwAC).
// Piecewise linear curve anchored to OpenSolar empirical data:
//   ILR ≤ 1.10 → 0% loss
//   ILR = 1.48 (7.4 kWp / 5 kW) → 1% loss
//   ILR = 2.04 (10.2 kWp / 5 kW) → 5.8% loss
//   ILR > 2.04 → continues at same slope, capped at 10%
// Mirrors PHP calculateInverterClippingLossPercent() in includes/solar-calculator-formulas.php.
function calculateInverterClippingLossPercent(arrayKwp, inverterKwAC) {
  if (inverterKwAC === undefined || inverterKwAC === null) {
    inverterKwAC = defaultInverterKwAC;
  }

  var ilr = arrayKwp / inverterKwAC;

  if (ilr <= 1.10) {
    return 0.0;
  } else if (ilr <= 1.48) {
    // 0% at ILR 1.10 → 1% at ILR 1.48
    return (ilr - 1.10) / (1.48 - 1.10) * 1.0;
  } else if (ilr <= 2.04) {
    // 1% at ILR 1.48 → 5.8% at ILR 2.04
    return 1.0 + (ilr - 1.48) / (2.04 - 1.48) * (5.8 - 1.0);
  } else {
    // Continue slope beyond 2.04, capped at 10%
    var uncapped = 5.8 + (ilr - 2.04) / (2.04 - 1.48) * (5.8 - 1.0);
    return Math.min(10.0, uncapped);
  }
}

// Simplified annual production estimate from panel count.
// Mirrors PHP annualProductionInKwh() in includes/solar-calculator-formulas.php.
// Depends on JS globals examplePanelWp, averageAnnualUnitsPerKwp, and defaultInverterKwAC (echoed by sitewide-variables.php).
function calculateSimpleAnnualProductionKwh(panelCount) {
  var arrayKwp = panelCount * examplePanelWp / 1000;
  var clippingLoss = calculateInverterClippingLossPercent(arrayKwp, defaultInverterKwAC);
  return arrayKwp * averageAnnualUnitsPerKwp * (1 - clippingLoss / 100);
}

// Bilinear-interpolation helper for the MCS self-consumption lookup. Returns
// [lowerIndex, fractionalWeight] for `value` along an axis whose bands have
// `bandEdges` as their lower edges. Interpolation anchors are the band
// midpoints. Mirrors PHP mcsSelfConsumptionFractionalIndex().
function mcsSelfConsumptionFractionalIndex(value, bandEdges, allowExtrapolation) {
  var n = bandEdges.length;
  var midpoints = [];
  for (var i = 0; i < n; i++) {
    if (i + 1 < n) {
      midpoints.push((bandEdges[i] + bandEdges[i + 1]) / 2.0);
    } else {
      var width = i > 0 ? bandEdges[i] - bandEdges[i - 1] : 1;
      midpoints.push(bandEdges[i] + width / 2.0);
    }
  }
  // Below the first / above the last midpoint: clamp (weight 0) by default, or
  // linearly extrapolate off the two nearest cells when allowExtrapolation is set
  // (weight < 0 or > 1). The MCS tables stop at ~6,000 kWh generation / 5,500 kWh
  // demand; extrapolation lets us cover the larger Irish systems we actually sell.
  if (value <= midpoints[0]) {
    if (allowExtrapolation && n > 1) {
      return [0, (value - midpoints[0]) / (midpoints[1] - midpoints[0])];
    }
    return [0, 0.0];
  }
  if (value >= midpoints[n - 1]) {
    if (allowExtrapolation && n > 1) {
      return [n - 2, (value - midpoints[n - 2]) / (midpoints[n - 1] - midpoints[n - 2])];
    }
    return [n - 1, 0.0];
  }
  for (var j = 0; j < n - 1; j++) {
    if (value >= midpoints[j] && value < midpoints[j + 1]) {
      return [j, (value - midpoints[j]) / (midpoints[j + 1] - midpoints[j])];
    }
  }
  return [n - 1, 0.0];
}

// Self-consumption percentage (0–95) using the MCS MGD-003 lookup tables
// (Issue 2.0, April 2022) with trilinear interpolation across the demand,
// PV-generation and battery axes.
//   annualPvKwh     — annual solar generation, kWh
//   annualDemandKwh — house annual electricity demand, kWh
//   batteryKwh      — usable battery capacity, kWh (0 for no battery)
//   archetype       — occupancy archetype, default 'in_half_day'
// Returns a Number percentage in [0, 95].
//
// We use the raw lookup (no §4.6.8 -10pp PV-only adjustment) because it tracks
// our OpenSolar reference quotes more closely for the Irish market.
//
// Depends on JS globals: mcsSelfConsumptionLookup, mcsSelfConsumptionLookupDemandBands,
// mcsSelfConsumptionLookupPvRows, mcsSelfConsumptionLookupBatteryCols (echoed by
// sitewide-variables.php).
// Mirrors PHP mcsSelfConsumptionPercent() in includes/solar-calculator-formulas.php.
function calculateMcsSelfConsumptionPercent(annualPvKwh, annualDemandKwh, batteryKwh, archetype) {
  if (!archetype || !mcsSelfConsumptionLookup[archetype]) {
    archetype = 'in_half_day';
  }

  var demand  = Math.max(1500, Math.min(8000, Number(annualDemandKwh)));
  var gen     = Math.max(0,    Math.min(9500, Number(annualPvKwh)));
  var battery = Math.max(0,    Math.min(15.0, Number(batteryKwh)));

  // Demand and generation extrapolate beyond the table edges; battery plateaus
  // (a bigger battery adds little once daytime surplus is already captured), so
  // it clamps.
  var di = mcsSelfConsumptionFractionalIndex(demand,  mcsSelfConsumptionLookupDemandBands, true);
  var gi = mcsSelfConsumptionFractionalIndex(gen,     mcsSelfConsumptionLookupPvRows, true);
  var bi = mcsSelfConsumptionFractionalIndex(battery, mcsSelfConsumptionLookupBatteryCols, false);

  var dIdx = di[0], dW = di[1];
  var gIdx = gi[0], gW = gi[1];
  var bIdx = bi[0], bW = bi[1];

  var dNext = Math.min(dIdx + 1, mcsSelfConsumptionLookupDemandBands.length - 1);
  var gNext = Math.min(gIdx + 1, mcsSelfConsumptionLookupPvRows.length - 1);
  var bNext = Math.min(bIdx + 1, mcsSelfConsumptionLookupBatteryCols.length - 1);

  var tbl = mcsSelfConsumptionLookup[archetype];
  var dLow  = mcsSelfConsumptionLookupDemandBands[dIdx];
  var dHigh = mcsSelfConsumptionLookupDemandBands[dNext];

  var c000 = tbl[dLow][gIdx][bIdx],     c001 = tbl[dLow][gIdx][bNext];
  var c010 = tbl[dLow][gNext][bIdx],    c011 = tbl[dLow][gNext][bNext];
  var c100 = tbl[dHigh][gIdx][bIdx],    c101 = tbl[dHigh][gIdx][bNext];
  var c110 = tbl[dHigh][gNext][bIdx],   c111 = tbl[dHigh][gNext][bNext];

  // Trilinear blend (battery → PV → demand).
  var c00 = c000 * (1 - bW) + c001 * bW;
  var c01 = c010 * (1 - bW) + c011 * bW;
  var c10 = c100 * (1 - bW) + c101 * bW;
  var c11 = c110 * (1 - bW) + c111 * bW;

  var c0 = c00 * (1 - gW) + c01 * gW;
  var c1 = c10 * (1 - gW) + c11 * gW;

  var result = c0 * (1 - dW) + c1 * dW;
  return Math.min(95.0, Math.max(0.0, result));
}

// Battery: usable energy delivered per full cycle (kWh).
//   batteryCapacity × cycleDepth(%) × roundTripEfficiency(0–1 fraction) / 100
function calculateBatteryUsableEnergyPerCycle(batteryCapacity, cycleDepthPercent, roundTripEfficiencyFraction) {
  return (batteryCapacity * cycleDepthPercent * roundTripEfficiencyFraction) / 100;
}

// Battery: kWh removed from the surplus PV pool (or bought at night rate) per cycle, before RTE losses.
// This is the kWh you DON'T export (or DO buy at night) — i.e. what the export/night credit applies to.
//   batteryCapacity × cycleDepth(%) / 100
function calculateBatteryStoredEnergyPerCycle(batteryCapacity, cycleDepthPercent) {
  return (batteryCapacity * cycleDepthPercent) / 100;
}

// Battery: annual savings from cycling solar through the battery (€).
// Energy balance for one cycle:
//   without battery → export X kWh at exportRate
//   with battery    → import (X × RTE) kWh less at dayRate; export 0
// Net per-cycle benefit = (X × RTE × dayRate − X × exportRate). /100 converts cents → €.
function calculateBatterySavingsFromSolarPerYear(batteryCapacity, cycleDepthPercent, roundTripEfficiencyFraction, solarChargesPerYear, dayRateCents, exportRateCents) {
  var storedPerCycle    = calculateBatteryStoredEnergyPerCycle(batteryCapacity, cycleDepthPercent);
  var deliveredPerCycle = calculateBatteryUsableEnergyPerCycle(batteryCapacity, cycleDepthPercent, roundTripEfficiencyFraction);
  return (solarChargesPerYear * (deliveredPerCycle * dayRateCents - storedPerCycle * exportRateCents)) / 100;
}

// Battery: annual savings from charging at night rate then using during the day (€).
// Energy balance for one cycle:
//   without arbitrage → buy (X × RTE) kWh at dayRate in the morning
//   with arbitrage    → buy X kWh at nightRate overnight, deliver (X × RTE) at dayRate avoided
// Net per-cycle benefit = (X × RTE × dayRate − X × nightRate). /100 converts cents → €.
function calculateBatterySavingsFromNightRatePerYear(batteryCapacity, cycleDepthPercent, roundTripEfficiencyFraction, nightRateChargesPerYear, dayRateCents, nightRateCents) {
  var storedPerCycle    = calculateBatteryStoredEnergyPerCycle(batteryCapacity, cycleDepthPercent);
  var deliveredPerCycle = calculateBatteryUsableEnergyPerCycle(batteryCapacity, cycleDepthPercent, roundTripEfficiencyFraction);
  return (nightRateChargesPerYear * (deliveredPerCycle * dayRateCents - storedPerCycle * nightRateCents)) / 100;
}

// Battery: how many solar charges per year are physically possible given the
// surplus PV available to be stored. Used as a sanity backstop on user input —
// stops impossible scenarios (e.g. 320 cycles on 8 panels + 15 kWh battery).
//   surplusPv = generation × (1 − baselineSelfConsumptionFraction)
//   maxCycles = surplusPv ÷ storedPerCycle
function calculateMaxSolarChargesPerYear(annualGenerationKwh, baselineSelfConsumptionPercent, batteryCapacity, cycleDepthPercent) {
  var storedPerCycle = calculateBatteryStoredEnergyPerCycle(batteryCapacity, cycleDepthPercent);
  if (storedPerCycle <= 0) return 0;
  var surplusKwh = annualGenerationKwh * (1 - baselineSelfConsumptionPercent / 100);
  return Math.max(0, surplusKwh / storedPerCycle);
}

// ============================================================
//  Demand-bounded self-consumption + battery savings (V2 model).
//  Used by the roof sizing tool, the main domestic solar calculator and the
//  simple cost calculator. The older cycle-based calculateBatterySavingsFrom*
//  PerYear helpers above are retained for the standalone battery savings
//  calculator and are intentionally left unchanged.
//  PHP twins live in includes/solar-calculator-formulas.php.
// ============================================================

// Self-consumed solar (kWh/yr), bounded by what the house can physically use.
// Two caps apply on top of the MCS lookup:
//   1. The annual MCS lookup % of generation (demand- and battery-aware), and
//   2. A seasonal import floor: even a perfect battery cannot move summer surplus
//      into winter, so the most solar a house can self-consume is its annual
//      demand minus the irreducible winter import (calculateSeasonalMinimumGridImportKwh).
// Without (2) an oversized system on a modest house looks like it self-consumes
// nearly 100% of demand (import → 0), which is unrealistic for Irish winters.
// DO NOT REMOVE the floor: a range sweep showed extrapolation alone yields
// import = 0 whenever demand ≈ generation with a large battery (e.g. 7,000 kWh
// demand, 15 kWh battery) — a real config we sell. The floor is the only thing
// preventing that physically-impossible result.
function calculateSelfConsumedSolarKwh(annualGenerationKwh, annualDemandKwh, batteryKwh, azimuthDeg, archetype) {
  var genForLookup = Math.min(annualGenerationKwh, 9500);
  var scPct = calculateMcsSelfConsumptionPercent(genForLookup, annualDemandKwh, batteryKwh, archetype);
  var mcsSelfConsumed = (scPct / 100) * genForLookup;

  var seasonalMinImport = calculateSeasonalMinimumGridImportKwh(annualGenerationKwh, annualDemandKwh, azimuthDeg);
  var maxSelfConsumable = Math.max(0, annualDemandKwh - seasonalMinImport);

  return Math.min(mcsSelfConsumed, maxSelfConsumable);
}

// Picks the monthly generation shape for the azimuth nearest the panel's actual
// bearing, from the 8 compass directions in monthlyOutputByAzimuth (N=0 … NW=315).
// Falls back to the south-facing monthData if the by-azimuth global is missing.
function nearestAzimuthMonthlyShape(azimuthDeg) {
  if (typeof monthlyOutputByAzimuth === 'undefined' || !monthlyOutputByAzimuth) {
    return (typeof monthData !== 'undefined' && monthData) ? monthData : null;
  }
  if (azimuthDeg == null || isNaN(azimuthDeg)) azimuthDeg = 180; // default south
  var norm = ((Number(azimuthDeg) % 360) + 360) % 360;
  var keys = Object.keys(monthlyOutputByAzimuth);
  var best = keys[0], bestDist = 999;
  for (var i = 0; i < keys.length; i++) {
    var key = Number(keys[i]);
    var dist = Math.abs(norm - key);
    if (dist > 180) dist = 360 - dist; // circular distance
    if (dist < bestDist) { bestDist = dist; best = keys[i]; }
  }
  return monthlyOutputByAzimuth[best];
}

// Minimum annual grid import (kWh) that solar physically cannot avoid, derived
// from the monthly generation shape for the nearest panel azimuth (PVGIS Dublin
// reference). On days where a month's average daily generation is below average
// daily demand, the shortfall must be imported no matter how big the battery is,
// because summer generation cannot be stored for winter. Summed over the year
// this is the irreducible seasonal import floor the annual MCS lookup cannot
// represent. The azimuth matters a lot: an east/west array puts far less of its
// output into winter than a south array, so it needs a higher winter import.
//   minImport = Σ_months daysInMonth × max(0, dailyDemand − dailyGeneration)
function calculateSeasonalMinimumGridImportKwh(annualGenerationKwh, annualDemandKwh, azimuthDeg) {
  var shape = nearestAzimuthMonthlyShape(azimuthDeg);
  if (!shape || !shape.length) return 0;
  var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  var annualPerKwp = 0;
  for (var i = 0; i < shape.length; i++) {
    annualPerKwp += shape[i].dailyOutputPerKwp * daysInMonth[i];
  }
  if (annualPerKwp <= 0) return 0;
  var totalDays = 0;
  for (var d = 0; d < daysInMonth.length; d++) totalDays += daysInMonth[d];
  var dailyDemand = annualDemandKwh / totalDays;
  var minImport = 0;
  for (var m = 0; m < shape.length; m++) {
    var dailyGeneration = annualGenerationKwh * shape[m].dailyOutputPerKwp / annualPerKwp;
    minImport += Math.max(0, dailyDemand - dailyGeneration) * daysInMonth[m];
  }
  return minImport;
}

// Extra solar kept at home because the battery stores daytime surplus (kWh/yr):
// self-consumption with the battery minus self-consumption without it.
function calculateBatterySolarUpliftKwh(annualGenerationKwh, annualDemandKwh, batteryKwh, azimuthDeg, archetype) {
  var withoutBattery = calculateSelfConsumedSolarKwh(annualGenerationKwh, annualDemandKwh, 0, azimuthDeg, archetype);
  var withBattery    = calculateSelfConsumedSolarKwh(annualGenerationKwh, annualDemandKwh, batteryKwh, azimuthDeg, archetype);
  return Math.max(0, withBattery - withoutBattery);
}

// Savings from the battery storing excess daytime solar (€/yr). Each uplifted
// kWh avoids a day-rate import that would otherwise have been an export, so it
// is worth (dayRate − exportRate); floored at zero.
function calculateBatterySavingsFromSolarUpliftPerYear(annualGenerationKwh, annualDemandKwh, batteryKwh, dayRateCents, exportRateCents, azimuthDeg, archetype) {
  var upliftKwh = calculateBatterySolarUpliftKwh(annualGenerationKwh, annualDemandKwh, batteryKwh, azimuthDeg, archetype);
  return upliftKwh * Math.max(0, dayRateCents - exportRateCents) / 100;
}

// Per-month grid import (kWh) that solar physically cannot avoid, as a 12-entry
// array (Jan…Dec). Same derivation as calculateSeasonalMinimumGridImportKwh but
// returned month-by-month rather than summed, so the night-arbitrage model can
// match each month's night charging against that month's real day-rate import.
// In summer monthly generation exceeds demand → residual ≈ 0; in winter it is
// large. Returns null if no monthly shape is available (callers fall back to an
// annual figure).
function calculateMonthlyResidualImportKwh(annualGenerationKwh, annualDemandKwh, azimuthDeg) {
  var shape = nearestAzimuthMonthlyShape(azimuthDeg);
  if (!shape || !shape.length) return null;
  var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  var annualPerKwp = 0;
  for (var i = 0; i < shape.length; i++) {
    annualPerKwp += shape[i].dailyOutputPerKwp * daysInMonth[i];
  }
  if (annualPerKwp <= 0) return null;
  var totalDays = 0;
  for (var d = 0; d < daysInMonth.length; d++) totalDays += daysInMonth[d];
  var out = [];
  for (var m = 0; m < shape.length; m++) {
    var monthGeneration = annualGenerationKwh * shape[m].dailyOutputPerKwp * daysInMonth[m] / annualPerKwp;
    var monthDemand     = annualDemandKwh * daysInMonth[m] / totalDays;
    out.push({ residual: Math.max(0, monthDemand - monthGeneration), days: daysInMonth[m], totalDays: totalDays });
  }
  return out;
}

// Night-rate arbitrage savings (€/yr). We assume the battery is charged from
// cheap night-rate grid power most nights (nightCyclesPerYear ≈ 330 — full 365
// less holidays etc. when it is already solar-full) and used by day. The benefit
// splits into two buckets:
//   A) energy that displaces grid power you would otherwise buy by day
//        → worth (dayRate − nightRate/RTE) per delivered kWh
//        → bounded MONTH-BY-MONTH by that month's residual day-rate import, so
//          winter (large import) absorbs night charging into bucket A while
//          summer (≈0 import) cannot — its night throughput spills into bucket B.
//   B) energy that frees battery space so daytime solar is exported instead
//        → worth (exportRate − nightRate) per stored kWh
//        → bounded by the solar actually available to export
// Each per-unit benefit is floored at zero, so a night rate that beats neither
// contributes nothing (a rational operator simply would not charge) — the total
// can never go negative.
function calculateBatterySavingsFromNightArbitragePerYear(annualGenerationKwh, annualDemandKwh, batteryKwh, dayRateCents, nightRateCents, exportRateCents, nightCyclesPerYear, cycleDepthPercent, roundTripEfficiencyPercent, azimuthDeg, archetype) {
  if (batteryKwh <= 0) return 0;
  var rteFraction = roundTripEfficiencyPercent / 100;
  var selfConsumedKwh   = calculateSelfConsumedSolarKwh(annualGenerationKwh, annualDemandKwh, batteryKwh, azimuthDeg, archetype);
  var nightDeliveredKwh = calculateBatteryUsableEnergyPerCycle(batteryKwh, cycleDepthPercent, rteFraction) * nightCyclesPerYear;

  // Bucket A: night charging that displaces day-rate import, matched per month
  // so summer night throughput (no daytime import to displace) is not credited
  // at the day rate. Falls back to an annual cap if no monthly shape is present.
  var monthly = calculateMonthlyResidualImportKwh(annualGenerationKwh, annualDemandKwh, azimuthDeg);
  var scenarioADelivered = 0;
  if (monthly && monthly.length) {
    var totalDays = monthly[0].totalDays;
    for (var m = 0; m < monthly.length; m++) {
      var monthNightDelivered = nightDeliveredKwh * monthly[m].days / totalDays;
      scenarioADelivered += Math.min(monthNightDelivered, monthly[m].residual);
    }
  } else {
    var residualImportKwh = Math.max(0, annualDemandKwh - selfConsumedKwh);
    scenarioADelivered = Math.min(nightDeliveredKwh, residualImportKwh);
  }

  // Bucket B: remaining throughput, bounded by the solar actually available to export.
  var exportedSolarKwh   = Math.max(0, annualGenerationKwh - selfConsumedKwh);
  var scenarioBDelivered = Math.max(0, nightDeliveredKwh - scenarioADelivered);
  var scenarioBStored    = Math.min(rteFraction > 0 ? scenarioBDelivered / rteFraction : 0, exportedSolarKwh);

  var benefitA = Math.max(0, dayRateCents - (rteFraction > 0 ? nightRateCents / rteFraction : Infinity));
  var benefitB = Math.max(0, exportRateCents - nightRateCents);

  return (scenarioADelivered * benefitA + scenarioBStored * benefitB) / 100;
}

// Battery: time-to-warranty-end in years — whichever limit is hit first (calendar or cycle count).
function calculateBatteryEndOfWarrantyInYears(batteryWarrantyYears, batteryWarrantyCycles, cyclesPerYear) {
  return Math.min(batteryWarrantyYears, batteryWarrantyCycles / cyclesPerYear);
}

// EV: per-month daily generation for the user's actual roof, in kWh/day.
// dailyOutputPerKwp is the south-facing/30° reference baseline (monthData);
// azimuthTiltChangeRatio rescales it for the user's azimuth and tilt.
function calculateEvDailyGenerationKwh(dailyOutputPerKwp, arrayKwp, azimuthTiltChangeRatio) {
  return dailyOutputPerKwp * arrayKwp * azimuthTiltChangeRatio;
}

// EV: convert a daily kWh figure into kms of range, given the EV's energy consumption.
function calculateEvDailyRangeKms(dailyKwh, evConsumptionKwhPer100Km) {
  var kmsPerKwh = 100 / evConsumptionKwhPer100Km;
  return dailyKwh * kmsPerKwh;
}

// NDMG: solar array area (m²) for a given panel count and panel dimensions, including spacing.
function calculateArrayArea(panelWidthInMm, panelHeightInMm, panelSpacingInMm, panelCount) {
  return calculateRoofAreaPerPanel(panelWidthInMm, panelHeightInMm, panelSpacingInMm) * panelCount;
}
 /* =========================================================================
 * Roof Tool v1
 * -------------------------------------------------------------------------
 * Workflow:
 *   1. User locates property via Eircode/address (Geocoder).
 *   2. User clicks roof corners. First two clicks define the BASELINE (gutter).
 *      Subsequent clicks define remaining corners. Closing click on first
 *      point finalises the polygon.
 *   3. Polygon is projected to a local metric Cartesian frame aligned to
 *      the baseline (baseline lies on Y=0, runs along +X).
 *   4. Y axis is stretched by 1/cos(pitch) to recover true sloped lengths.
 *   5. Polygon is inset by the keep-out margin via Turf.
 *   6. Panels are grid-packed (both orientations tried) above the baseline.
 *   7. Panels are un-stretched and projected back to LatLng for display.
 * =======================================================================*/

// ---- Globals -------------------------------------------------------------
let map;
let geocoder;
let autocomplete = null; // Google Places Autocomplete widget
let clickPoints = []; // Array of google.maps.LatLng
let pointMarkers = []; // Visual markers for each click
let previewPolyline = null; // Live polyline while drawing
let roofPolygon = null; // Final closed polygon
let panelRectangles = []; // Drawn panel rectangles on map
let clickListener = null;
let gutterLine = null; // Teal polyline for the gutter edge (P1â†’P2)
let gutterLabel = null; // Floating text label at the gutter midpoint

// ---- Basemap imagery switcher ---------------------------------------------
// Azure Maps uses a shosolar-calc-lived token fetched from the server-side endpoint.
// The token is cached in memory and auto-refreshed before expiry â€” no shared
// key appears in the rendered HTML.
const AZURE_MAPS_CLIENT_ID = window.SC_CONFIG.azureMapsClientId;
const AZURE_MAPS_TOKEN_ENDPOINT = window.SC_CONFIG.azureMapsTokenEndpoint;
var CARDINALS = [
  "N",
  "NNE",
  "NE",
  "ENE",
  "E",
  "ESE",
  "SE",
  "SSE",
  "S",
  "SSW",
  "SW",
  "WSW",
  "W",
  "WNW",
  "NW",
  "NNW",
];
let currentBasemap = "azure"; // 'google' | 'esri' | 'azure' â€” default to Bing (Azure) as it's sharpest
let basemapControlEl = null;
let basemapOffsetResizeBound = false;

// ---- Azure Maps token manager --------------------------------------------
let _azureMapToken = null; // cached JWT
let _azureMapTokenExpiresOn = null; // Date object from expiresOn.value
let _azureMapTokenPromise = null; // deduplicates concurrent fetch attempts
let _azureMapTokenRefreshTimer = null; // setTimeout handle for auto-refresh

async function _fetchAzureMapToken() {
  const resp = await fetch(AZURE_MAPS_TOKEN_ENDPOINT);
  if (!resp.ok)
    throw new Error("Azure Maps token endpoint returned " + resp.status);
  const data = await resp.json();
  _azureMapToken = data.token;
  _azureMapTokenExpiresOn = new Date(data.expiresOn.value);
  // Debug: verify token format (JWT starts with "eyJ", is ~1300-1800 chars)
  if (_azureMapToken) {
    console.log(
      "Azure Maps token received: length=" +
        _azureMapToken.length +
        ", preview=" +
        _azureMapToken.substring(0, 30) +
        "...",
    );
  } else {
    console.warn(
      "Azure Maps token is empty/undefined â€” check token endpoint response",
    );
  }
  _scheduleTokenRefresh();
  return _azureMapToken;
}

function _scheduleTokenRefresh() {
  if (_azureMapTokenRefreshTimer) clearTimeout(_azureMapTokenRefreshTimer);
  if (!_azureMapTokenExpiresOn) return;
  const msUntilExpiry = _azureMapTokenExpiresOn.getTime() - Date.now();
  const refreshIn = msUntilExpiry - 120000; // 2 minutes before expiry
  if (refreshIn > 0) {
    _azureMapTokenRefreshTimer = setTimeout(function () {
      _fetchAzureMapToken().catch(function (e) {
        console.warn("Azure Maps token refresh failed", e);
      });
    }, refreshIn);
  }
}

async function ensureAzureMapToken() {
  // Return cached token if still valid (with 1-minute safety buffer)
  if (
    _azureMapToken &&
    _azureMapTokenExpiresOn &&
    Date.now() < _azureMapTokenExpiresOn.getTime() - 60000
  ) {
    return _azureMapToken;
  }
  // Deduplicate concurrent fetch attempts
  if (!_azureMapTokenPromise) {
    _azureMapTokenPromise = _fetchAzureMapToken().finally(function () {
      _azureMapTokenPromise = null;
    });
  }
  return _azureMapTokenPromise;
}

function getAzureMapTokenSync() {
  // Synchronous accessor for the tile URL builder.
  // Token should already be cached â€” if not, tiles will 401 and retry later.
  return _azureMapToken || "";
}

// ---- Multi-section management --------------------------------------------
const SECTION_COLORS = [
  "#FF8C00",
  "#27ae60",
  "#8e44ad",
  "#2980b9",
  "#e74c3c",
  "#16a085",
];
let sections = []; // all committed roof sections
let editingSectionId = null; // id of the section whose settings are currently active on the map
const ADJUST_INPUT_IDS = [
  "pitch",
  "margin",
  "panelWp",
  "panelW",
  "panelH",
  "panelGap",
  "orientation",
];
const DEFAULT_PANEL_WP = window.SC_CONFIG.defaultPanelWp;
const DEFAULT_PANEL_WIDTH_MM = window.SC_CONFIG.defaultPanelWidthMm;
const DEFAULT_PANEL_HEIGHT_MM = window.SC_CONFIG.defaultPanelHeightMm;
const DEFAULT_PANEL_GAP_MM = window.SC_CONFIG.defaultPanelGapMm;
const DEFAULT_ROOF_PITCH_DEG = window.SC_CONFIG.defaultRoofPitchDeg;
const DEFAULT_PANEL_MARGIN_M = window.SC_CONFIG.defaultPanelMarginM;
const CO2_SAVING_PER_KWH = window.SC_CONFIG.co2SavingPerKwh;
const MAX_ROOF_AREA_M2 = 10000; // Maximum roof footprint area in mÂ² â€” reject larger selections to avoid performance / memory issues

const STATE = {
  IDLE: 0,
  NEED_BASELINE_END: 1,
  NEED_CORNERS: 2,
  CLOSED: 3,
};
let state = STATE.IDLE;
let hasLocated = false; // true once the user has geocoded an address
let inputMode = "map"; // 'map' | 'manual' â€” which input mode is active
let manualSections = []; // manual-mode sections (non-geometry)
let manualNextLabel = 0; // counter for auto-labelling manual sections

// ---- Mode switching ------------------------------------------------------
function switchMode(mode) {
  if (mode === inputMode) return;
  inputMode = mode;

  const mapPanel = document.getElementById("rtMapPanel");
  const manualPanel = document.getElementById("rtManualPanel");
  const mapCard = document.getElementById("rtModeMap");
  const manualCard = document.getElementById("rtModeManual");

  if (mode === "manual") {
    // Clear map-drawn sections and reset drawing state
    resetAllSectionsAndDrawing();
    if (mapPanel) mapPanel.style.display = "none";
    if (manualPanel) manualPanel.style.display = "";
    if (mapCard) {
      mapCard.classList.remove("is-active");
      mapCard.setAttribute("aria-checked", "false");
    }
    if (manualCard) {
      manualCard.classList.add("is-active");
      manualCard.setAttribute("aria-checked", "true");
    }
    // Hide map-specific controls
    const overlay = document.getElementById("rtOverlay");
    if (overlay) overlay.style.display = "none";
    // Populate county dropdown if empty
    populateCountyDropdown();
    // Start with one default manual section
    if (manualSections.length === 0) addManualSection();
    updateManualSummary();
    updateInstructionForManual();
  } else {
    // Clear manual sections from both arrays
    manualSections = [];
    manualNextLabel = 0;
    sections = sections.filter((s) => s.source !== "manual");
    renderManualSections();
    updateManualSummary();
    if (mapPanel) mapPanel.style.display = "";
    if (manualPanel) manualPanel.style.display = "none";
    if (mapCard) {
      mapCard.classList.add("is-active");
      mapCard.setAttribute("aria-checked", "true");
    }
    if (manualCard) {
      manualCard.classList.remove("is-active");
      manualCard.setAttribute("aria-checked", "false");
    }
    const overlay = document.getElementById("rtOverlay");
    if (overlay) overlay.style.display = "";
    updateInstruction();
  }

  // Reset all results displays
  document.getElementById("totalPanelCount").textContent = "\u2026";
  document.getElementById("totalSystemSize").textContent = "\u2026";
  const suffixEl = document.getElementById("totalSectionCountSuffix");
  if (suffixEl) suffixEl.textContent = "";
  document.getElementById("totalAnnualKwh").textContent = "\u2014";
  document.getElementById("totalAnnualCo2").textContent = "\u2014";
  document.getElementById("totalAnnualBillSavings").textContent = "\u2014";
  document.getElementById("totalPriceAfterGrant").textContent = "\u2014";
  runFinancials();
}

function updateInstructionForManual() {
  const el = document.getElementById("instruction");
  const pill = document.getElementById("rtPill");
  const search = document.getElementById("rtPillSearch");
  const currentAddr = document.getElementById("rtCurrentAddress");
  if (search) search.style.display = "none";
  if (currentAddr) currentAddr.style.display = "none";
  if (pill) pill.style.display = "";
  if (el)
    el.innerHTML =
      "Enter your panel counts and roof orientations below, then see your results on the right.";
}

// ---- Mode toggle card click handlers ------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  const mapCard = document.getElementById("rtModeMap");
  const manualCard = document.getElementById("rtModeManual");
  if (mapCard)
    mapCard.addEventListener("click", function () {
      switchMode("map");
    });
  if (manualCard)
    manualCard.addEventListener("click", function () {
      switchMode("manual");
    });
  // Keyboard accessibility
  if (mapCard)
    mapCard.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        switchMode("map");
      }
    });
  if (manualCard)
    manualCard.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        switchMode("manual");
      }
    });
});

// ---- Per-item value rows (collapsible "value + chevron" -> edit field) ----
const RT_ITEM_IDS = [
  "pitch",
  "margin",
  "orientation",
  "panelWp",
  "panelW",
  "panelH",
  "panelGap",
  "solar-calc-annualUsage",
  "solar-calc-daytimeRate",
  "solar-calc-nightRate",
  "solar-calc-feedinTariff",
];

function rtFormatItemValue(id, el) {
  const v = el.value;
  switch (id) {
    case "pitch":
      return v + "\u00b0";
    case "margin":
      return v + " m";
    case "orientation":
      return (
        el.options[el.selectedIndex].dataset.short ||
        el.options[el.selectedIndex].text
      );
    case "panelWp":
      return v + " Wp";
    case "panelW":
    case "panelH":
    case "panelGap":
      return v + " mm";
    case "solar-calc-annualUsage":
      return (Number(v) ? Number(v).toLocaleString() : v) + " kWh";
    case "solar-calc-daytimeRate":
    case "solar-calc-nightRate":
    case "solar-calc-feedinTariff":
      return v + "c / unit";
    default:
      return v;
  }
}

function rtSyncItemValue(id) {
  const el = document.getElementById(id);
  const out = document.getElementById(id + "Value");
  if (el && out) out.textContent = rtFormatItemValue(id, el);
  // Also update summary span for panel wattage
  if (id === "panelWp") {
    const summarySpan = document.getElementById("summaryPanelWpValue");
    if (summarySpan) summarySpan.textContent = rtFormatItemValue(id, el);
  }
}

function rtSyncAllItemValues() {
  RT_ITEM_IDS.forEach(rtSyncItemValue);
}

function rtCompass16LabelFromAzimuth(azimuthDeg) {
  if (azimuthDeg == null || isNaN(azimuthDeg)) return "";
  const normalized = (((Math.round(azimuthDeg / 15) * 15) % 360) + 360) % 360;
  const names = {
    0: "N",
    15: "NNE",
    30: "NNE",
    45: "NE",
    60: "ENE",
    75: "ENE",
    90: "E",
    105: "ESE",
    120: "ESE",
    135: "SE",
    150: "SSE",
    165: "SSE",
    180: "S",
    195: "SSW",
    210: "SSW",
    225: "SW",
    240: "WSW",
    255: "WSW",
    270: "W",
    285: "WNW",
    300: "WNW",
    315: "NW",
    330: "NNW",
    345: "NNW",
  };
  return names[normalized] || "N";
}

function rtFormatAzimuthForDisplay(azimuthDeg) {
  if (azimuthDeg == null || isNaN(azimuthDeg)) return "\u2014";
  const rounded = Math.round(azimuthDeg);
  return rtCompass16LabelFromAzimuth(azimuthDeg) + " (" + rounded + "\u00b0)";
}

function rtCompassHandleX(azimuthDeg) {
  return (100 + 75 * Math.sin((azimuthDeg * Math.PI) / 180)).toFixed(2);
}

function rtCompassHandleY(azimuthDeg) {
  return (100 - 75 * Math.cos((azimuthDeg * Math.PI) / 180)).toFixed(2);
}

function rtTiltLineX2(degrees) {
  var rad = (degrees * Math.PI) / 180;
  return (20 + 65 * Math.cos(rad)).toFixed(2);
}

function rtTiltLineY2(degrees) {
  var rad = (degrees * Math.PI) / 180;
  return (70 - 65 * Math.sin(rad)).toFixed(2);
}

function rtTiltArcPath(degrees) {
  if (degrees <= 0) return "";
  var rad = (degrees * Math.PI) / 180;
  var r = 24;
  var ex = (20 + r * Math.cos(rad)).toFixed(2);
  var ey = (70 - r * Math.sin(rad)).toFixed(2);
  return "M " + (20 + r) + ",70 A " + r + "," + r + " 0 0,0 " + ex + "," + ey;
}

function rtTiltDescriptorFromDegrees(degrees) {
  if (degrees === 0) return "Flat";
  if (degrees <= 15) return "Very Shallow";
  if (degrees <= 25) return "Shallow";
  if (degrees <= 35) return "Standard";
  if (degrees <= 45) return "Steep";
  return "Very Steep";
}

function rtHexToRgba(hex, alpha) {
  if (!hex) return "rgba(228,95,49," + alpha + ")";
  var clean = String(hex).replace("#", "");
  if (clean.length === 3)
    clean = clean
      .split("")
      .map(function (ch) {
        return ch + ch;
      })
      .join("");
  if (clean.length !== 6) return "rgba(228,95,49," + alpha + ")";
  var r = parseInt(clean.substring(0, 2), 16);
  var g = parseInt(clean.substring(2, 4), 16);
  var b = parseInt(clean.substring(4, 6), 16);
  return "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
}

function rtManualCompassMarkup(azimuthDeg) {
  return (
    '<svg class="compass-svg ct-compass-svg" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">' +
    '<circle cx="100" cy="100" r="75" fill="none" class="compass-track ct-compass-track"/>' +
    '<line x1="100" y1="26" x2="100" y2="34" stroke="#b0bac6" stroke-width="1.5" stroke-linecap="round"/>' +
    '<line x1="174" y1="100" x2="166" y2="100" stroke="#b0bac6" stroke-width="1.5" stroke-linecap="round"/>' +
    '<line x1="100" y1="174" x2="100" y2="166" stroke="#b0bac6" stroke-width="1.5" stroke-linecap="round"/>' +
    '<line x1="26" y1="100" x2="34" y2="100" stroke="#b0bac6" stroke-width="1.5" stroke-linecap="round"/>' +
    '<text x="100" y="14" text-anchor="middle" dominant-baseline="middle" class="compass-label ct-compass-label">N</text>' +
    '<text x="188" y="100" text-anchor="middle" dominant-baseline="middle" class="compass-label ct-compass-label">E</text>' +
    '<text x="100" y="188" text-anchor="middle" dominant-baseline="middle" class="compass-label ct-compass-label">S</text>' +
    '<text x="12" y="100" text-anchor="middle" dominant-baseline="middle" class="compass-label ct-compass-label">W</text>' +
    '<g class="ct-compass-inner" transform="rotate(' +
    azimuthDeg +
    ', 100, 100)">' +
    '<rect x="64" y="100" width="72" height="24" fill="#e8ecf2"/>' +
    '<rect x="64" y="76" width="72" height="24" fill="#2d4a7a"/>' +
    '<line x1="82" y1="76" x2="82" y2="100" stroke="#fff" stroke-width="1"/>' +
    '<line x1="100" y1="76" x2="100" y2="100" stroke="#fff" stroke-width="1"/>' +
    '<line x1="118" y1="76" x2="118" y2="100" stroke="#fff" stroke-width="1"/>' +
    '<line x1="64" y1="88" x2="136" y2="88" stroke="#fff" stroke-width="1"/>' +
    '<rect x="64" y="76" width="72" height="48" rx="2" fill="none" stroke="#9aa5b4" stroke-width="1.5"/>' +
    '<line x1="64" y1="100" x2="136" y2="100" stroke="#9aa5b4" stroke-width="1.5"/>' +
    '<line x1="100" y1="76" x2="100" y2="42" stroke="#e45f31" stroke-width="2" stroke-linecap="round"/>' +
    '<polygon points="100,36 95,45 105,45" fill="#e45f31"/>' +
    "</g>" +
    '<circle class="compass-handle ct-compass-handle" cx="' +
    rtCompassHandleX(azimuthDeg) +
    '" cy="' +
    rtCompassHandleY(azimuthDeg) +
    '" r="9"/>' +
    "</svg>"
  );
}

function rtManualTiltMarkup(tiltDeg) {
  return (
    '<svg class="tilt-svg ct-tilt-svg" viewBox="0 0 150 80" xmlns="http://www.w3.org/2000/svg">' +
    '<line x1="20" y1="70" x2="140" y2="70" stroke="#b0bac6" stroke-width="2.5" stroke-linecap="round"/>' +
    '<path class="ct-tilt-arc" d="' +
    rtTiltArcPath(tiltDeg) +
    '" stroke="#e45f31" stroke-width="1.5" fill="none" stroke-linecap="round"/>' +
    '<line class="ct-tilt-line" x1="20" y1="70" x2="' +
    rtTiltLineX2(tiltDeg) +
    '" y2="' +
    rtTiltLineY2(tiltDeg) +
    '" stroke="#e45f31" stroke-width="3" stroke-linecap="round"/>' +
    "</svg>" +
    '<div class="ct-tilt-slider-ui"></div>' +
    '<div class="ct-tilt-scale"><span>0\u00b0</span><span>35\u00b0</span><span>70\u00b0</span></div>'
  );
}

// Backward-compatible alias retained for older call sites.
function rtCompass8LabelFromAzimuth(azimuthDeg) {
  return rtCompass16LabelFromAzimuth(azimuthDeg);
}
RT_ITEM_IDS.forEach((id) => {
  const el = document.getElementById(id);
  if (!el) return;
  el.addEventListener("input", () => rtSyncItemValue(id));
  el.addEventListener("change", () => rtSyncItemValue(id));
});
rtSyncAllItemValues();
// Re-sync after Chrome restores form state on tab duplication / back-forward cache
window.addEventListener("pageshow", rtSyncAllItemValues);

// ---- Number-input stepper buttons (+/âˆ’) ----------------------------------
function rtInitSteppers() {
  document
    .querySelectorAll(".solar-calc-field--stepper")
    .forEach(function (input) {
      // Already wrapped? skip
      if (input.parentNode.classList.contains("solar-calc-stepper")) return;

      var step =
        parseFloat(input.getAttribute("data-step-ui") || input.step) || 1;
      var min = input.hasAttribute("min") ? parseFloat(input.min) : -Infinity;
      var max = input.hasAttribute("max") ? parseFloat(input.max) : Infinity;
      var defaultVal = input.value; // store original default for reset

      // Outer group: [ stepper ] [ reset ]
      var group = document.createElement("div");
      group.className = "solar-calc-stepper-group";

      var wrap = document.createElement("div");
      wrap.className = "solar-calc-stepper";

      var btnDec = document.createElement("button");
      btnDec.type = "button";
      btnDec.className = "solar-calc-stepper__btn";
      btnDec.setAttribute("aria-label", "Decrease");
      btnDec.innerHTML =
        '<i class="fas fa-chevron-down" aria-hidden="true"></i>';

      var btnInc = document.createElement("button");
      btnInc.type = "button";
      btnInc.className = "solar-calc-stepper__btn";
      btnInc.setAttribute("aria-label", "Increase");
      btnInc.innerHTML = '<i class="fas fa-chevron-up" aria-hidden="true"></i>';

      var btnReset = document.createElement("button");
      btnReset.type = "button";
      btnReset.className = "solar-calc-stepper__reset";
      btnReset.setAttribute("aria-label", "Reset to default");
      btnReset.title = "Reset to default";
      btnReset.innerHTML = '<i class="fas fa-undo-alt" aria-hidden="true"></i>';

      function countDecimals(n) {
        return (String(n).split(".")[1] || "").length;
      }

      function isOnStep(val) {
        var d = Math.max(countDecimals(val), countDecimals(step));
        var factor = Math.pow(10, d);
        return Math.round(val * factor) % Math.round(step * factor) === 0;
      }

      function updateBtns() {
        var val = parseFloat(input.value) || 0;
        btnDec.disabled = val <= min;
        btnInc.disabled = val >= max;
      }

      function stepValue(delta) {
        var val = parseFloat(input.value) || 0;
        var d = Math.max(countDecimals(val), countDecimals(step));
        var factor = Math.pow(10, d);
        var newVal;

        if (!isOnStep(val)) {
          // Snap to nearest step boundary in the direction of travel
          if (delta > 0) {
            newVal = Math.ceil((val * factor) / (step * factor)) * step;
          } else {
            newVal = Math.floor((val * factor) / (step * factor)) * step;
          }
          newVal = Math.round(newVal * factor) / factor;
        } else {
          newVal = Math.round((val + delta) * factor) / factor;
        }

        newVal = Math.max(min, Math.min(max, newVal));
        input.value = newVal;
        updateBtns();
        input.dispatchEvent(
          new Event("input", {
            bubbles: true,
          }),
        );
        input.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );
      }

      btnDec.addEventListener("click", function () {
        stepValue(-step);
      });
      btnInc.addEventListener("click", function () {
        stepValue(step);
      });
      btnReset.addEventListener("click", function () {
        input.value = defaultVal;
        updateBtns();
        input.dispatchEvent(
          new Event("input", {
            bubbles: true,
          }),
        );
        input.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );
      });
      input.addEventListener("input", updateBtns);

      // Assemble: input's parent gets the group, group contains stepper + reset
      input.parentNode.insertBefore(group, input);
      group.appendChild(wrap);
      wrap.appendChild(btnDec);
      wrap.appendChild(input);
      wrap.appendChild(btnInc);
      group.appendChild(btnReset);
      updateBtns();
    });
}
rtInitSteppers();

// ---- Mobile Results / Adjust tabs ----------------------------------------
document.querySelectorAll(".solar-calc-tabs__btn").forEach((btn) => {
  btn.addEventListener("click", () => {
    const pane = btn.dataset.pane;
    document
      .querySelectorAll(".solar-calc-tabs__btn")
      .forEach((b) => b.classList.toggle("is-active", b === btn));
    const r = document.getElementById("rtPaneResults");
    const a = document.getElementById("rtPaneAdjust");
    if (r) r.classList.toggle("is-active", pane === "results");
    if (a) a.classList.toggle("is-active", pane === "adjust");
  });
});

// Undo is a drawing-only action. Returning to address search is handled by
// the clear/edit control in the current-address pill.
let searchingAgain = false;
let currentAddressLabel = "";
let currentEircode = ""; // Extracted from geocoder address_components (postal_code)
let currentAddressOnly = ""; // Address without Eircode — for survey form pre-population

function updateUndoButton() {
  const undo = document.getElementById("btnUndo");
  if (undo) {
    const canUndo = undoStack.length > 0;
    undo.disabled = !canUndo;
  }
}

// ---- Undo stack ----------------------------------------------------------
// Each entry is a full snapshot of drawing state + all settings.
const MAX_UNDO = 50;
let undoStack = [];

function captureState() {
  const snap = {
    clickPoints: clickPoints.map(
      (p) => new google.maps.LatLng(p.lat(), p.lng()),
    ),
    drawState: state,
    pitch: document.getElementById("pitch").value,
    margin: document.getElementById("margin").value,
    panelW: document.getElementById("panelW").value,
    panelH: document.getElementById("panelH").value,
    panelGap: document.getElementById("panelGap").value,
    orientation: document.getElementById("orientation").value,
    panelWp: document.getElementById("panelWp").value,
  };
  undoStack.push(snap);
  if (undoStack.length > MAX_UNDO) undoStack.shift();
  updateUndoButton();
}

function applySnapshot(snap) {
  // Restore form values (always)
  document.getElementById("pitch").value = snap.pitch;
  document.getElementById("margin").value = snap.margin;
  document.getElementById("panelW").value = snap.panelW;
  document.getElementById("panelH").value = snap.panelH;
  document.getElementById("panelGap").value = snap.panelGap;
  document.getElementById("orientation").value = snap.orientation;
  if (snap.panelWp != null)
    document.getElementById("panelWp").value = snap.panelWp;
  rtSyncAllItemValues();

  if (editingSectionId !== null && snap.drawState === STATE.CLOSED) {
    // Post-commit undo: only restore settings + recalculate panels.
    // The polygon and markers are owned by the committed section â€” don't touch them.
    clearPanels();
    state = STATE.CLOSED;
    map.setOptions({
      draggableCursor: null,
    });
    runCalculation();
  } else {
    // Pre-commit undo: full restore of all drawing visuals
    pointMarkers.forEach((m) => m.setMap(null));
    pointMarkers = [];
    if (previewPolyline) {
      previewPolyline.setMap(null);
      previewPolyline = null;
    }
    if (gutterLine) {
      gutterLine.setMap(null);
      gutterLine = null;
    }
    if (gutterLabel) {
      gutterLabel.setMap(null);
      gutterLabel = null;
    }
    if (roofPolygon) {
      roofPolygon.setMap(null);
      roofPolygon = null;
    }
    clearPanels();

    clickPoints = snap.clickPoints.map(
      (p) => new google.maps.LatLng(p.lat(), p.lng()),
    );
    clickPoints.forEach((pt, i) => {
      addPointMarker(pt, i + 1);
      if (i === 0 && snap.drawState !== STATE.IDLE) {
        pointMarkers[0].addListener("click", () => {
          if (state !== STATE.CLOSED && clickPoints.length >= 3) closePolygon();
        });
      }
    });

    state = snap.drawState;

    if (state === STATE.CLOSED) {
      roofPolygon = new google.maps.Polygon({
        paths: clickPoints,
        map: map,
        strokeColor: drawingColor(),
        strokeWeight: 2,
        fillColor: drawingColor(),
        fillOpacity: 0.25,
        clickable: false,
        zIndex: 1,
      });
      if (clickPoints.length >= 2) {
        gutterLine = new google.maps.Polyline({
          path: [clickPoints[0], clickPoints[1]],
          map: map,
          strokeColor: "#333333",
          strokeWeight: 4,
          strokeOpacity: 1,
          zIndex: 10,
        });
        // gutterLabel = makeGutterLabel();
      }
      map.setOptions({
        draggableCursor: null,
      });
      runCalculation();
    } else {
      updatePreview();
      map.setOptions({
        draggableCursor: "crosshair",
      });
      clearResultStats();
    }
  }

  updateInstruction();
  updateUndoButton();
}

// ---- Map init ------------------------------------------------------------
async function initMap() {
  // Fetch Azure Maps token before setting up basemaps.
  // If the endpoint is unreachable, fall back to Google satellite.
  try {
    await ensureAzureMapToken();
  } catch (e) {
    console.warn(
      "Azure Maps token unavailable, defaulting to Google satellite",
      e,
    );
    currentBasemap = "google";
  }

  map = new google.maps.Map(document.getElementById("map"), {
    center: {
      lat: 53.4129,
      lng: -8.2439,
    }, // Centre of Ireland
    zoom: 7,
    mapTypeId: "satellite",
    tilt: 0,
    rotateControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeControl: false,
    draggableCursor: "crosshair", // while drawing
    draggingCursor: "grabbing", // while panning
  });

  // Force tilt off whenever it might re-enable
  map.setTilt(0);

  // Register alternative imagery layers + on-map switcher
  setupBasemaps();
  addBasemapControl();
  setBasemap("azure"); // Default to Bing/Azure as it's sharpest

  geocoder = new google.maps.Geocoder();

  // ---- Places Autocomplete (live address search dropdown) ---------------
  const eircodeInput = document.getElementById("eircode");
  if (eircodeInput) {
    autocomplete = new google.maps.places.Autocomplete(eircodeInput, {
      componentRestrictions: { country: "ie" },
      types: ["address"],
      fields: ["address_components", "formatted_address", "geometry"],
    });

    autocomplete.addListener("place_changed", function () {
      const place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) {
        // No geometry from autocomplete — fall back to geocoding the typed text
        doGeocode();
        return;
      }

      map.setCenter(place.geometry.location);
      map.setZoom(21);
      hasLocated = true;
      searchingAgain = false;

      const formatted = place.formatted_address || eircodeInput.value.trim();
      let eircode = "";
      let addressOnly = formatted;
      if (place.address_components) {
        for (const comp of place.address_components) {
          if (comp.types.includes("postal_code")) {
            eircode = comp.long_name || comp.short_name || "";
            addressOnly = addressOnly
              .replace(new RegExp(
                ",?\\s*" + eircode.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\s*,?"
              ), "")
              .replace(/,\s*$/, "")
              .replace(/^\s*,/, "")
              .trim();
            break;
          }
        }
      }
      currentEircode = eircode;
      currentAddressLabel = formatted;
      currentAddressOnly = addressOnly;

      updateInstruction();
      updateUndoButton();
    });
  }

  clickListener = map.addListener("click", onMapClick);

  updateInstruction();
  updateUndoButton();
}

// ---- Basemap imagery layers ----------------------------------------------
// Keeps Google as the map "engine" (geocoding, drawing, geometry maths) but
// lets us swap the satellite TILES underneath to compare image quality.
function normaliseTile(coord, zoom) {
  const n = 1 << zoom; // tiles per axis at this zoom
  if (coord.y < 0 || coord.y >= n) return null;
  let x = coord.x % n;
  if (x < 0) x += n;
  return {
    x: x,
    y: coord.y,
  };
}

function setupBasemaps() {
  const ESRI_NATIVE_MAX_ZOOM = 19;
  const ESRI_DISPLAY_MAX_ZOOM = 22;
  const AZURE_NATIVE_MAX_ZOOM = 19;
  const AZURE_DISPLAY_MAX_ZOOM = 22;

  // Esri World Imagery â€” free, no key required.
  function esriTileUrl(x, y, z) {
    return (
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/" +
      z +
      "/" +
      y +
      "/" +
      x
    );
  }

  map.mapTypes.set("esri", {
    name: "Esri",
    tileSize: new google.maps.Size(256, 256),
    minZoom: 0,
    maxZoom: ESRI_DISPLAY_MAX_ZOOM,
    getTile: function (coord, zoom, ownerDocument) {
      const div = ownerDocument.createElement("div");
      div.style.width = "256px";
      div.style.height = "256px";
      div.style.overflow = "hidden";
      div.style.background = "#0a0a0a";

      // Esri can return no-data tiles beyond native zoom in some areas.
      // Overzoom by requesting a parent tile and cropping its sub-region.
      const sourceZoom = Math.min(zoom, ESRI_NATIVE_MAX_ZOOM);
      const downshift = zoom - sourceZoom;
      const factor = 1 << downshift;

      const sourceCoord = {
        x: Math.floor(coord.x / factor),
        y: Math.floor(coord.y / factor),
      };
      const t = normaliseTile(sourceCoord, sourceZoom);
      if (!t) return div;

      const img = ownerDocument.createElement("img");
      img.src = esriTileUrl(t.x, t.y, sourceZoom);
      img.width = 256 * factor;
      img.height = 256 * factor;
      img.style.position = "absolute";
      img.style.imageRendering = "auto";
      img.style.left = -(coord.x - sourceCoord.x * factor) * 256 + "px";
      img.style.top = -(coord.y - sourceCoord.y * factor) * 256 + "px";

      div.style.position = "relative";
      div.appendChild(img);
      return div;
    },
    releaseTile: function () {},
  });

  // Azure Maps satellite (Airbus/Maxar â€” the "Bing" comparison).
  // Authenticated with a shosolar-calc-lived Azure AD token (auto-refreshed).
  // Tiles are loaded via fetch() with the Authorization: Bearer header (the
  // standard Azure AD auth method), then converted to blob: URLs for <img>
  // display.  The &token= query parameter does NOT work for the Render tile
  // service â€” it requires the header approach.
  // Azure has no native tiles beyond ~zoom 19, so a plain ImageMapType either
  // goes blank or (when we return a parent tile URL) repeats the parent tile in
  // every child slot â€” the mosaic effect. To overzoom properly we must SCALE and
  // CROP the parent tile into each child slot, which ImageMapType can't do via a
  // URL alone. So we implement a custom MapType with getTile() that builds a
  // <div> showing the correct, magnified portion of the parent tile.
  function azureTileUrlNoAuth(x, y, z) {
    return (
      "https://atlas.microsoft.com/map/tile?api-version=2024-04-01" +
      "&tilesetId=microsoft.imagery" +
      "&zoom=" +
      z +
      "&x=" +
      x +
      "&y=" +
      y
    );
  }

  map.mapTypes.set("azure", {
    name: "Azure",
    tileSize: new google.maps.Size(256, 256),
    minZoom: 0,
    maxZoom: AZURE_DISPLAY_MAX_ZOOM,
    getTile: function (coord, zoom, ownerDocument) {
      const div = ownerDocument.createElement("div");
      div.style.width = "256px";
      div.style.height = "256px";
      div.style.overflow = "hidden";
      div.style.background = "#0a0a0a";

      // Clamp the fetch to Azure's native max zoom; magnify beyond that.
      const sourceZoom = Math.min(zoom, AZURE_NATIVE_MAX_ZOOM);
      const downshift = zoom - sourceZoom; // how many levels we overzoom
      const factor = 1 << downshift; // 2^downshift magnification

      const sourceCoord = {
        x: Math.floor(coord.x / factor),
        y: Math.floor(coord.y / factor),
      };
      const t = normaliseTile(sourceCoord, sourceZoom);
      if (!t) return div;

      const img = ownerDocument.createElement("img");
      img.width = 256 * factor; // scale the parent up
      img.height = 256 * factor;
      img.style.position = "absolute";
      img.style.imageRendering = "auto";
      // Offset so this child slot shows its sub-region of the parent tile.
      img.style.left = -(coord.x - sourceCoord.x * factor) * 256 + "px";
      img.style.top = -(coord.y - sourceCoord.y * factor) * 256 + "px";

      div.style.position = "relative";
      div.appendChild(img);

      // Fetch the tile with the Azure AD token in the Authorization header.
      // The &token= query parameter is NOT supported by the Render tile
      // service â€” the header approach is required for AAD auth.
      var url = azureTileUrlNoAuth(t.x, t.y, sourceZoom);
      var token = getAzureMapTokenSync();

      if (token) {
        fetch(url, {
          headers: {
            Authorization: "Bearer " + token,
            "x-ms-client-id": AZURE_MAPS_CLIENT_ID,
          },
        })
          .then(function (resp) {
            if (!resp.ok) throw new Error("HTTP " + resp.status);
            return resp.blob();
          })
          .then(function (blob) {
            var objectUrl = URL.createObjectURL(blob);
            img.src = objectUrl;
            // Stash for cleanup in releaseTile
            img._azureBlobUrl = objectUrl;
          })
          .catch(function (err) {
            console.warn(
              "Azure Maps tile fetch failed (" + url + "):",
              err.message,
            );
          });
      } else {
        console.warn("Azure Maps tile requested but no token available");
      }

      return div;
    },
    releaseTile: function (tile) {
      // Revoke blob URLs to prevent memory leaks.
      var imgs = tile.getElementsByTagName("img");
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i]._azureBlobUrl) {
          URL.revokeObjectURL(imgs[i]._azureBlobUrl);
          imgs[i]._azureBlobUrl = null;
        }
      }
    },
  });
}

function setBasemap(which) {
  const savedZoom = map.getZoom();
  currentBasemap = which;
  map.setMapTypeId(which === "google" ? "satellite" : which);
  // Switching map types can clamp the zoom to the new provider's maximum
  // (e.g. Google satellite at 20 vs Azure at 22). Re-apply the saved zoom
  // so the map stays as close as possible to where the user left it.
  if (savedZoom !== map.getZoom()) map.setZoom(savedZoom);
  document.querySelectorAll(".solar-calc-basemapCtrl__btn").forEach((b) => {
    b.classList.toggle("is-active", b.dataset.basemap === which);
    b.setAttribute(
      "aria-pressed",
      b.dataset.basemap === which ? "true" : "false",
    );
  });
}

function updateBasemapMobileOffset() {
  const mapRoot = document.querySelector(".solar-calc-map");
  const overlay = document.getElementById("rtOverlay");
  const search = document.getElementById("rtPillSearch");
  const currentAddr = document.getElementById("rtCurrentAddress");
  if (!mapRoot || !overlay) return;

  // Apply compact spacing on phone/tablet widths where overlay crowding occurs.
  if (!window.matchMedia("(max-width: 980px)").matches || !basemapControlEl) {
    mapRoot.style.setProperty("--solar-calc-basemap-offset", "0px");
    overlay.style.top = "";
    return;
  }

  const showingSearch = !!(search && search.style.display !== "none");
  const showingAddressChip = !!(
    currentAddr &&
    currentAddr.style.display !== "none" &&
    !showingSearch
  );

  // When the compact address chip is shown, it shares the top row with basemap tabs.
  // In that state, do not push the whole overlay down below the tabs.
  if (showingAddressChip) {
    mapRoot.style.setProperty("--solar-calc-basemap-offset", "0px");
    if (window.matchMedia("(min-width: 761px)").matches)
      overlay.style.top = "8px";
    return;
  }

  const MOBILE_SPACING_PX = 8;

  // Include control height + consistent breathing room so the search pill never overlaps it.
  const controlHeight = Math.ceil(
    basemapControlEl.getBoundingClientRect().height,
  );
  const offsetPx = controlHeight + MOBILE_SPACING_PX;

  // If control has not fully laid out yet, retry shortly (first paint race).
  if (controlHeight < 20) {
    setTimeout(updateBasemapMobileOffset, 60);
    return;
  }

  mapRoot.style.setProperty("--solar-calc-basemap-offset", offsetPx + "px");
  // For 761-980px where the CSS var rule is not active, set top directly.
  if (window.matchMedia("(min-width: 761px)").matches) {
    overlay.style.top = MOBILE_SPACING_PX + offsetPx + "px";
  }
}

function syncMapOverlayLayout() {
  const tight = window.matchMedia("(max-width: 980px)").matches;
  const overlay = document.getElementById("rtOverlay");
  const search = document.getElementById("rtPillSearch");
  const currentAddr = document.getElementById("rtCurrentAddress");
  const currentAddrValue = document.getElementById("rtCurrentAddressText");
  const currentAddrClear = document.getElementById("btnClearAddress");
  const pill = document.getElementById("rtPill");
  const text = document.getElementById("instruction");
  const input = document.getElementById("eircode");
  const findBtn = document.getElementById("btnGo");

  const MOBILE_SPACING_PX = 8;

  if (basemapControlEl) {
    basemapControlEl.style.top = tight ? MOBILE_SPACING_PX + "px" : "12px";
    basemapControlEl.style.left = tight ? MOBILE_SPACING_PX + "px" : "12px";
    basemapControlEl.style.padding = tight ? "1px" : "";
    basemapControlEl.style.borderRadius = tight ? "6px" : "";
    basemapControlEl
      .querySelectorAll(".solar-calc-basemapCtrl__btn")
      .forEach((btn) => {
        btn.style.padding = tight ? "5px 8px" : "";
        btn.style.fontSize = tight ? "11px" : "";
        btn.style.minHeight = tight ? "26px" : "";
        btn.style.lineHeight = tight ? "1" : "";
      });
  }

  if (!overlay) return;

  if (!tight) {
    overlay.style.left = "";
    overlay.style.right = "";
    overlay.style.transform = "";
    overlay.style.width = "";
    overlay.style.maxWidth = "";
    overlay.style.gap = "";
    overlay.style.top = "";
    if (search) search.style.padding = "";
    if (pill) pill.style.padding = "";
    if (pill) pill.style.marginTop = "";
    if (text) {
      text.style.fontSize = "";
      text.style.lineHeight = "";
    }
    if (input) {
      input.style.padding = "";
      input.style.fontSize = "";
    }
    if (findBtn) {
      findBtn.style.padding = "";
      findBtn.style.fontSize = "";
    }
    if (currentAddr) {
      currentAddr.style.alignSelf = "";
      currentAddr.style.maxWidth = "";
      currentAddr.style.padding = "";
      currentAddr.style.minHeight = "";
      currentAddr.style.borderRadius = "";
      currentAddr.style.position = "";
      currentAddr.style.right = "";
      currentAddr.style.top = "";
      currentAddr.style.zIndex = "";
    }
    if (currentAddrValue) {
      currentAddrValue.style.fontSize = "";
      currentAddrValue.style.lineHeight = "";
    }
    if (currentAddrClear) {
      currentAddrClear.style.width = "";
      currentAddrClear.style.height = "";
    }
    return;
  }

  overlay.style.left = MOBILE_SPACING_PX + "px";
  overlay.style.right = MOBILE_SPACING_PX + "px";
  overlay.style.transform = "none";
  overlay.style.width = "auto";
  overlay.style.maxWidth = "none";
  overlay.style.gap = MOBILE_SPACING_PX + "px";

  if (search) search.style.padding = "6px";
  if (pill) pill.style.padding = "8px 10px";
  if (text) {
    text.style.fontSize = "0.88rem";
    text.style.lineHeight = "1.3";
  }
  if (input) {
    input.style.padding = "8px 10px";
    input.style.fontSize = "0.9rem";
  }
  if (findBtn) {
    findBtn.style.padding = "8px 12px";
    findBtn.style.fontSize = "0.85rem";
  }

  const showingSearch = !!(search && search.style.display !== "none");
  if (currentAddr && !showingSearch) {
    const controlWidth = basemapControlEl
      ? Math.ceil(basemapControlEl.getBoundingClientRect().width)
      : 150;
    const controlHeight = basemapControlEl
      ? Math.ceil(basemapControlEl.getBoundingClientRect().height)
      : 30;
    const sideGap = MOBILE_SPACING_PX;

    // Place current address on the SAME top row, right of basemap tabs.
    currentAddr.style.position = "absolute";
    currentAddr.style.top = "0";
    currentAddr.style.right = "0";
    currentAddr.style.zIndex = "1";
    currentAddr.style.alignSelf = "auto";
    currentAddr.style.maxWidth =
      "calc(100% - " + (controlWidth + sideGap) + "px)";
    currentAddr.style.padding = "2px 8px";
    currentAddr.style.minHeight = "28px";
    currentAddr.style.borderRadius = "6px";

    // Keep guidance directly below the tallest item in that top row.
    if (pill) {
      const addressHeight = Math.ceil(
        currentAddr.getBoundingClientRect().height,
      );
      pill.style.marginTop =
        Math.max(controlHeight, addressHeight) + MOBILE_SPACING_PX + "px";
    }
  } else {
    if (currentAddr) {
      currentAddr.style.position = "";
      currentAddr.style.right = "";
      currentAddr.style.top = "";
      currentAddr.style.zIndex = "";
      currentAddr.style.alignSelf = "stretch";
      currentAddr.style.maxWidth = "";
    }
    if (pill) pill.style.marginTop = "";
  }
  if (currentAddrValue) {
    currentAddrValue.style.fontSize = "11px";
    currentAddrValue.style.lineHeight = "1";
  }
  if (currentAddrClear) {
    currentAddrClear.style.width = "20px";
    currentAddrClear.style.height = "20px";
  }
}

function addBasemapControl() {
  const azureReady = !!getAzureMapTokenSync();
  const ctrl = document.getElementById("rtBasemapCtrl");
  if (!ctrl) return;

  basemapControlEl = ctrl;

  const buttons = ctrl.querySelectorAll(".solar-calc-basemapCtrl__btn");
  buttons.forEach((btn) => {
    const basemapId = btn.dataset.basemap;
    if (!basemapId) return;

    if (basemapId === "azure" && !azureReady) {
      btn.disabled = true;
      btn.title = "Azure Maps token unavailable";
    } else {
      btn.disabled = false;
      btn.removeAttribute("title");
    }

    btn.addEventListener("click", () => {
      if (btn.disabled) return;
      setBasemap(basemapId);
    });
  });

  if (!azureReady && currentBasemap === "azure") {
    currentBasemap = "google";
  }
  setBasemap(currentBasemap);

  requestAnimationFrame(() => {
    syncMapOverlayLayout();
    updateBasemapMobileOffset();
  });
  setTimeout(() => {
    syncMapOverlayLayout();
    updateBasemapMobileOffset();
  }, 180);
  google.maps.event.addListenerOnce(map, "idle", () => {
    syncMapOverlayLayout();
    updateBasemapMobileOffset();
  });
  if (!basemapOffsetResizeBound) {
    window.addEventListener("resize", () => {
      syncMapOverlayLayout();
      updateBasemapMobileOffset();
    });
    basemapOffsetResizeBound = true;
  }
}

document.getElementById("eircode").addEventListener("keydown", (e) => {
  if (e.key === "Enter") doGeocode();
});

document.getElementById("btnGo").addEventListener("click", doGeocode);

function doGeocode() {
  const raw = document.getElementById("eircode").value.trim();
  if (!raw) return;
  const query = /ireland/i.test(raw) ? raw : raw + ", Ireland";

  geocoder.geocode(
    {
      address: query,
      componentRestrictions: {
        country: "IE",
      },
    },
    (results, status) => {
      if (status === "OK" && results[0]) {
        map.setCenter(results[0].geometry.location);
        map.setZoom(21);
        hasLocated = true;
        searchingAgain = false;

        // Parse address_components to split Eircode from address
        const formatted = results[0].formatted_address || raw;
        let eircode = "";
        let addressOnly = formatted;
        if (results[0].address_components) {
          for (const comp of results[0].address_components) {
            if (comp.types.includes("postal_code")) {
              eircode = comp.long_name || comp.short_name || "";
              // Strip the Eircode and any surrounding commas/whitespace
              addressOnly = addressOnly
                .replace(new RegExp(
                  ",?\\s*" + eircode.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\s*,?"
                ), "")
                .replace(/,\s*$/, "")
                .replace(/^\s*,/, "")
                .trim();
              break;
            }
          }
        }
        currentEircode = eircode;
        currentAddressLabel = formatted; // Full address including Eircode — for map overlay display
        currentAddressOnly = addressOnly; // Address without Eircode — for survey form

        updateInstruction();
        updateUndoButton();
      } else {
        alert("Could not find that location. Status: " + status);
      }
    },
  );
}

// ---- Drawing -------------------------------------------------------------
function onMapClick(e) {
  if (state === STATE.CLOSED) return;

  // Clear any oversized-area warning from a previous attempt
  const pill = document.getElementById("rtPill");
  if (pill) pill.classList.remove("solar-calc-pill--oversized");

  // Capture state BEFORE modifying anything (enables full undo)
  captureState();

  // Check if click is near the first point => close the polygon
  if (clickPoints.length >= 3) {
    const first = clickPoints[0];
    const distPx = pixelDistance(first, e.latLng);
    if (distPx < 15) {
      closePolygon();
      return;
    }
  }

  clickPoints.push(e.latLng);
  addPointMarker(e.latLng, clickPoints.length);
  // Make point #1 clickable to close the polygon (more reliable than the
  // pixel-distance snap above).
  if (clickPoints.length === 1) {
    const firstMarker = pointMarkers[0];
    firstMarker.addListener("click", () => {
      if (state !== STATE.CLOSED && clickPoints.length >= 3) closePolygon();
    });
  }
  updatePreview();
  advanceState();
}

function advanceState() {
  if (clickPoints.length === 1) state = STATE.NEED_BASELINE_END;
  else if (clickPoints.length === 2) state = STATE.NEED_CORNERS;
  else if (clickPoints.length >= 3) state = STATE.NEED_CORNERS;
  updateInstruction();
  updateUndoButton();
}

function updateInstruction() {
  const el = document.getElementById("instruction");
  const pill = document.getElementById("rtPill");
  const search = document.getElementById("rtPillSearch");
  const currentAddr = document.getElementById("rtCurrentAddress");
  const addrText = document.getElementById("rtCurrentAddressText");
  const undoBtn = document.getElementById("btnUndo");
  const cancelBtn = document.getElementById("btnCancelTrace");
  const addBtn = document.getElementById("btnAddSectionInline");

  if (pill) pill.classList.remove("solar-calc-pill--done");

  // The Eircode/address search is shown before a location has been chosen
  // (and nothing drawn yet), or whenever the user asks to change address.
  const showSearch =
    searchingAgain ||
    (!hasLocated && clickPoints.length === 0 && sections.length === 0);
  if (search) search.style.display = showSearch ? "" : "none";
  if (currentAddr)
    currentAddr.style.display = !showSearch && hasLocated ? "" : "none";
  if (addrText) {
    const fallback = document.getElementById("eircode").value.trim();
    addrText.textContent =
      currentAddressLabel || fallback || "Address selected";
  }

  const canUndo = undoStack.length > 0;
  const tracingNow =
    state === STATE.NEED_BASELINE_END || state === STATE.NEED_CORNERS;
  const canCancelDraft =
    !showSearch &&
    sections.length > 0 &&
    editingSectionId === null &&
    state !== STATE.CLOSED;
  const showAddInline =
    !showSearch &&
    !tracingNow &&
    state === STATE.CLOSED;
  if (undoBtn)
    undoBtn.style.display = !showSearch && tracingNow && canUndo ? "" : "none";
  if (cancelBtn) cancelBtn.style.display = canCancelDraft ? "" : "none";
  if (addBtn) addBtn.style.display = showAddInline ? "" : "none";
  // Hide the whole actions wrapper (not just the button) so its top margin
  // never leaves a gap at the bottom of the pill when no action is shown.
  const pillActions = document.getElementById("rtPillActions");
  if (pillActions) pillActions.style.display = showAddInline ? "" : "none";
  if (pill) pill.style.display = "";
  if (el) el.style.display = "";

  syncMapOverlayLayout();
  updateBasemapMobileOffset();

  if (showSearch) {
    el.innerHTML = hasLocated
      ? "Enter a new Eircode or address, then tap <strong>Find</strong>."
      : "Enter your Eircode or address above to find your home on the map. Please note this tool only works for locations in Ireland.";
    return;
  }

  switch (state) {
    case STATE.IDLE:
      // Same action-first guidance every time a new face begins, so the
      // journey reads identically for the first roof and every one after.
      el.innerHTML =
        "Click one corner of the roof&rsquo;s <strong>bottom edge</strong> (the gutter line) to start tracing a roof face.";
      break;
    case STATE.NEED_BASELINE_END:
      el.innerHTML =
        "Now click the other end of the <strong>bottom edge</strong> to set the baseline.";
      break;
    case STATE.NEED_CORNERS:
      el.innerHTML =
        "Click each remaining corner, then tap marker&nbsp;<strong>1</strong> to close the shape.";
      break;
    case STATE.CLOSED:
      if (pill) pill.classList.add("solar-calc-pill--done");
      el.innerHTML = "<strong>Done.</strong> <a href='#totalResultsSection' onclick=\"event.preventDefault(); document.getElementById('totalResultsSection').scrollIntoView({behavior:'smooth'});\">Click here to scroll to your results</a>";
      break;
  }
}

function addPointMarker(latLng, idx) {
  const gutterPt = idx <= 2;
  const title =
    idx === 1
      ? "1 â€“ Gutter start (bottom-edge / gutter line)"
      : idx === 2
        ? "2 â€“ Gutter end (bottom-edge / gutter line)"
        : idx + " â€“ Ridge corner (above the gutter, anywhere on the roof)";
  const m = new google.maps.Marker({
    position: latLng,
    map: map,
    title: title,
    label: {
      text: String(idx),
      color: "#fff",
      fontSize: "11px",
      fontWeight: "bold",
    },
    icon: {
      path: google.maps.SymbolPath.CIRCLE,
      scale: gutterPt ? 9 : 8,
      fillColor: gutterPt ? "#333333" : "#1a3d5c",
      fillOpacity: 1,
      strokeColor: "#fff",
      strokeWeight: gutterPt ? 2.5 : 2,
    },
    zIndex: 1000,
  });
  pointMarkers.push(m);
}

// Creates a teal SVG pill label positioned just outside the polygon at the gutter midpoint.
function makeGutterLabel() {
  const p1 = clickPoints[0],
    p2 = clickPoints[1];
  const midLat = (p1.lat() + p2.lat()) / 2;
  const midLng = (p1.lng() + p2.lng()) / 2;
  const cosLat = Math.cos((midLat * Math.PI) / 180);
  const OFFSET = 8; // metres outside the polygon
  let dlat, dlng;
  if (clickPoints.length >= 3) {
    // Move away from polygon centroid
    const n = clickPoints.length;
    const cLat = clickPoints.reduce((s, p) => s + p.lat(), 0) / n;
    const cLng = clickPoints.reduce((s, p) => s + p.lng(), 0) / n;
    const dLatM = (midLat - cLat) * 111111;
    const dLngM = (midLng - cLng) * 111111 * cosLat;
    const dist = Math.sqrt(dLatM * dLatM + dLngM * dLngM) || 1;
    dlat = ((dLatM / dist) * OFFSET) / 111111;
    dlng = ((dLngM / dist) * OFFSET) / (111111 * cosLat);
  } else {
    // Only 2 points yet â€” offset perpendicular to the line (90Â° CCW)
    const dLatM = (p2.lat() - p1.lat()) * 111111;
    const dLngM = (p2.lng() - p1.lng()) * 111111 * cosLat;
    const len = Math.sqrt(dLatM * dLatM + dLngM * dLngM) || 1;
    dlat = ((-dLngM / len) * OFFSET) / 111111;
    dlng = ((dLatM / len) * OFFSET) / (111111 * cosLat);
  }
  const pos = new google.maps.LatLng(midLat + dlat, midLng + dlng);
  const svg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="116" height="26">' +
    '<rect x="1" y="1" width="114" height="24" rx="6" fill="#0097a7" stroke="#fff" stroke-width="2"/>' +
    '<text x="58" y="17" text-anchor="middle" font-family="Arial,sans-serif" font-size="11" font-weight="700" fill="#fff">Bottom edge</text>' +
    "</svg>";
  return new google.maps.Marker({
    position: pos,
    map: map,
    icon: {
      url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(116, 26),
      anchor: new google.maps.Point(58, 13),
    },
    clickable: false,
    zIndex: 11,
  });
}

function updatePreview() {
  if (previewPolyline) {
    previewPolyline.setMap(null);
    previewPolyline = null;
  }
  if (gutterLine) {
    gutterLine.setMap(null);
    gutterLine = null;
  }
  if (gutterLabel) {
    gutterLabel.setMap(null);
    gutterLabel = null;
  }
  if (clickPoints.length < 2) return;

  // Gutter edge (P1â†’P2) â€” dark, thicker
  gutterLine = new google.maps.Polyline({
    path: [clickPoints[0], clickPoints[1]],
    map: map,
    strokeColor: "#333333",
    strokeWeight: 4,
    strokeOpacity: 1,
    zIndex: 10,
  });
  // gutterLabel = makeGutterLabel();

  // Remaining edges (P2 onwards)
  if (clickPoints.length >= 3) {
    previewPolyline = new google.maps.Polyline({
      path: clickPoints.slice(1),
      map: map,
      strokeColor: drawingColor(),
      strokeWeight: 2,
      strokeOpacity: 0.9,
    });
  }
}

function closePolygon() {
  if (previewPolyline) {
    previewPolyline.setMap(null);
    previewPolyline = null;
  }
  if (gutterLine) {
    gutterLine.setMap(null);
    gutterLine = null;
  }
  if (gutterLabel) {
    gutterLabel.setMap(null);
    gutterLabel = null;
  }

  roofPolygon = new google.maps.Polygon({
    paths: clickPoints,
    map: map,
    strokeColor: drawingColor(),
    strokeWeight: 2,
    fillColor: drawingColor(),
    fillOpacity: 0.25,
    clickable: false,
    zIndex: 1,
  });

  // Keep gutter edge and label visible on top of the closed polygon
  gutterLine = new google.maps.Polyline({
    path: [clickPoints[0], clickPoints[1]],
    map: map,
    strokeColor: "#333333",
    strokeWeight: 4,
    strokeOpacity: 1,
    zIndex: 10,
  });
  // gutterLabel = makeGutterLabel();

  state = STATE.CLOSED;
  updateInstruction();
  // Drawing finished â†’ back to normal hand cursor for panning
  map.setOptions({
    draggableCursor: null,
  });

  runCalculation();
}

// Approx pixel distance between two LatLngs at current zoom (for snap-to-close)
function pixelDistance(a, b) {
  const proj = map.getProjection();
  if (!proj) return Infinity;
  const scale = Math.pow(2, map.getZoom());
  const pa = proj.fromLatLngToPoint(a);
  const pb = proj.fromLatLngToPoint(b);
  const dx = (pa.x - pb.x) * scale;
  const dy = (pa.y - pb.y) * scale;
  return Math.sqrt(dx * dx + dy * dy);
}

// ---- Undo ----------------------------------------------------------------
document.getElementById("btnUndo").addEventListener("click", () => {
  if (undoStack.length > 0) {
    const snap = undoStack.pop();
    applySnapshot(snap);
    updateUndoButton();
  }
});

document
  .getElementById("btnCancelTrace")
  .addEventListener("click", cancelDraftSection);

// ---- Change address ------------------------------------------------------
// Re-open the address search so the user can re-locate without touching Undo.
document.getElementById("btnClearAddress").addEventListener("click", () => {
  resetAllSectionsAndDrawing();
  hasLocated = false;
  currentAddressLabel = "";
  currentEircode = "";
  currentAddressOnly = "";
  searchingAgain = true;
  updateInstruction();
  updateUndoButton();
  const eircodeEl = document.getElementById("eircode");
  if (eircodeEl) {
    eircodeEl.value = "";
    eircodeEl.focus();
  }
});

function clearResultStats() {
  document.getElementById("panelCount").innerText = "\u2014";
  document.getElementById("panelCountLabel").textContent = "Estimated panels";
  document.getElementById("statFootprint").innerText = "\u2014";
  document.getElementById("statSloped").innerText = "\u2014";
  document.getElementById("statUsable").innerText = "\u2014";
  document.getElementById("statOrientation").innerText = "\u2014";
  document.getElementById("statGrid").innerText = "\u2014";
  document.getElementById("statAzimuth").innerText = "\u2014";
  document.getElementById("statCounty").innerText = "\u2014";
  document.getElementById("statAnnualKwh").innerText = "\u2014";
  document.getElementById("statAnnualCo2").innerText = "\u2014";
  document.getElementById("warningBox").innerHTML = "";
  document.getElementById("debugPanel").textContent = "(no calculation yet)";
}

function clearPanels() {
  panelRectangles.forEach((p) => p.setMap(null));
  panelRectangles = [];
  // Also clear the active editing section's panel rectangles. The global
  // panelRectangles array and sec.mapObjs.panelRectangles can hold different
  // Polygon references after recalcSingleSection restores old global state,
  // so clearing only the global array leaves old panels still visible on the
  // map. This covers all recalculation paths (live-recalc, per-section
  // dropdown, undo) in one place.
  if (editingSectionId !== null) {
    const sec = sections.find((s) => s.id === editingSectionId);
    if (sec && sec.mapObjs.panelRectangles) {
      sec.mapObjs.panelRectangles.forEach((p) => p.setMap(null));
      sec.mapObjs.panelRectangles = [];
    }
  }
}

function resetAllSectionsAndDrawing() {
  sections.forEach((sec) => {
    if (sec.mapObjs.panelRectangles)
      sec.mapObjs.panelRectangles.forEach((p) => p.setMap(null));
    if (sec.mapObjs.pointMarkers)
      sec.mapObjs.pointMarkers.forEach((m) => m.setMap(null));
    if (sec.mapObjs.roofPolygon) sec.mapObjs.roofPolygon.setMap(null);
    if (sec.mapObjs.gutterLine) sec.mapObjs.gutterLine.setMap(null);
  });

  pointMarkers.forEach((m) => m.setMap(null));
  pointMarkers = [];
  if (previewPolyline) {
    previewPolyline.setMap(null);
    previewPolyline = null;
  }
  if (gutterLine) {
    gutterLine.setMap(null);
    gutterLine = null;
  }
  if (gutterLabel) {
    gutterLabel.setMap(null);
    gutterLabel = null;
  }
  if (roofPolygon) {
    roofPolygon.setMap(null);
    roofPolygon = null;
  }
  clearPanels();

  clickPoints = [];
  sections = [];
  manualSections = [];
  manualNextLabel = 0;
  editingSectionId = null;
  undoStack = [];
  state = STATE.IDLE;

  document.getElementById("btnAddSection").style.display = "none";
  document.getElementById("panelCountLabel").textContent = "Estimated panels";
  document.getElementById("totalPanelCount").textContent = "\u2026";
  document.getElementById("totalSystemSize").textContent = "\u2026";
  document.getElementById("totalAnnualKwh").textContent = "\u2014";
  document.getElementById("totalAnnualCo2").textContent = "\u2014";
  document.getElementById("totalAnnualBillSavings").textContent = "\u2014";
  document.getElementById("totalPriceAfterGrant").textContent = "\u2014";

  clearResultStats();
  updateUndoButton();
  updateActiveSectionHeading();
  renderSectionsPanel();
  if (map) {
    map.setOptions({
      draggableCursor: "crosshair",
    });
  }
}

function cancelDraftSection() {
  if (!(sections.length > 0 && editingSectionId === null)) return;

  pointMarkers.forEach((m) => m.setMap(null));
  pointMarkers = [];
  if (previewPolyline) {
    previewPolyline.setMap(null);
    previewPolyline = null;
  }
  if (gutterLine) {
    gutterLine.setMap(null);
    gutterLine = null;
  }
  if (gutterLabel) {
    gutterLabel.setMap(null);
    gutterLabel = null;
  }
  if (roofPolygon) {
    roofPolygon.setMap(null);
    roofPolygon = null;
  }
  clearPanels();

  clickPoints = [];
  undoStack = [];
  const last = sections[sections.length - 1];
  if (last) editSection(last.id);
  updateInstruction();
  updateUndoButton();
}

// ---- Section management --------------------------------------------------
function drawingColor() {
  return SECTION_COLORS[sections.length % SECTION_COLORS.length];
}

function commitOrUpdateSection(result) {
  if (editingSectionId !== null) {
    // Update existing section's panels and result (settings changed)
    const sec = sections.find((s) => s.id === editingSectionId);
    if (sec) {
      sec.mapObjs.panelRectangles = panelRectangles.slice(); // old refs cleared by clearPanels
      sec.result = result;
      sec.pitch = parseFloat(document.getElementById("pitch").value);
      sec.margin = parseFloat(document.getElementById("margin").value);
      sec.panelW = parseFloat(document.getElementById("panelW").value);
      sec.panelH = parseFloat(document.getElementById("panelH").value);
      sec.panelGap = parseFloat(document.getElementById("panelGap").value);
      sec.orientation = document.getElementById("orientation").value;
      sec.panelWp = parseFloat(document.getElementById("panelWp").value);
    }
  } else {
    // First commit for this drawing session
    const id = Date.now();
    sections.push({
      id,
      label: "Section " + String.fromCharCode(64 + sections.length + 1),
      color: drawingColor(),
      clickPoints: clickPoints.slice(),
      pitch: parseFloat(document.getElementById("pitch").value),
      margin: parseFloat(document.getElementById("margin").value),
      panelW: parseFloat(document.getElementById("panelW").value),
      panelH: parseFloat(document.getElementById("panelH").value),
      panelGap: parseFloat(document.getElementById("panelGap").value),
      orientation: document.getElementById("orientation").value,
      panelWp: parseFloat(document.getElementById("panelWp").value),
      result,
      mapObjs: {
        roofPolygon,
        pointMarkers: pointMarkers.slice(),
        panelRectangles: panelRectangles.slice(),
        gutterLine,
      },
    });
    editingSectionId = id;
    // Clear undo so the user can't undo past the commit point
    undoStack = [];
    updateUndoButton();
  }
  renderSectionsPanel();
  document.getElementById("btnAddSection").style.display = "block";
  // Update label to identify which section's stats are shown
  const activeSec = sections.find((s) => s.id === editingSectionId);
  document.getElementById("panelCountLabel").textContent =
    activeSec && sections.length > 1
      ? activeSec.label + " \u2014 Estimated panels"
      : "Estimated panels";
  updateActiveSectionHeading();
}

function updateActiveSectionHeading() {
  const hint = document.getElementById("activeSectionHint");
  if (editingSectionId !== null) {
    const sec = sections.find((s) => s.id === editingSectionId);
    const label = sec
      ? sec.label.replace("Section ", "section ")
      : "selected section";
    if (hint)
      hint.textContent = "These settings apply to the " + label + " only.";
  } else {
    if (hint)
      hint.textContent =
        "These settings apply to the section being drawn only.";
  }
}

function captureAdjustInputFocus() {
  const active = document.activeElement;
  if (!active || !active.id || ADJUST_INPUT_IDS.indexOf(active.id) === -1)
    return null;
  const snap = {
    id: active.id,
  };
  if (
    typeof active.selectionStart === "number" &&
    typeof active.selectionEnd === "number"
  ) {
    snap.start = active.selectionStart;
    snap.end = active.selectionEnd;
  }
  return snap;
}

function restoreAdjustInputFocus(snap) {
  if (!snap || !snap.id) return;
  const el = document.getElementById(snap.id);
  if (!el) return;
  el.focus({
    preventScroll: true,
  });
  if (
    typeof snap.start === "number" &&
    typeof snap.end === "number" &&
    typeof el.setSelectionRange === "function"
  ) {
    try {
      el.setSelectionRange(snap.start, snap.end);
    } catch (err) {
      // Number inputs can reject some caret restores depending on browser state.
    }
  }
}

// The shared #sectionEditor now stays permanently in #editorHome.
// Per-section accordion bodies get their own inline content via buildSectionBodyHTML().
// updateSharedEditorContext() (above) manages which values appear in the shared editor.
// No DOM movement between sections — each section's body has its own independent content.

// ---- Manual-mode section management -------------------------------------
function populateCountyDropdown() {
  const sel = document.getElementById("rtManualCounty");
  if (!sel || sel.options.length > 0) return;
  if (typeof countyKwhPerKwp === "undefined") return;
  const counties = Object.keys(countyKwhPerKwp).sort();
  counties.forEach((c) => {
    const opt = document.createElement("option");
    opt.value = c;
    opt.textContent = c;
    if (c === "Dublin") opt.selected = true;
    sel.appendChild(opt);
  });
  sel.addEventListener("change", recalcAllManualSections);
}

function addManualSection() {
  const id = Date.now() + Math.random();
  const label = "Section " + String.fromCharCode(65 + manualNextLabel);
  manualNextLabel++;
  const county = document.getElementById("rtManualCounty").value || "Dublin";
  const panelWp =
    parseFloat(document.getElementById("panelWp").value) || DEFAULT_PANEL_WP;
  const sec = {
    id,
    label,
    source: "manual",
    manualPanelCount: null, // blank — user must enter their own number
    manualAzimuth: 180,
    manualTilt: 30,
    county,
    panelWp,
    color: SECTION_COLORS[manualSections.length % SECTION_COLORS.length],
    result: null, // no yield until user enters a panel count
  };
  // No initial yield calculation — user hasn't entered panels yet
  manualSections.push(sec);
  // Also push into shared sections[] so runFinancials() + totals see it
  sections.push(sec);
  renderManualSections();
  updateManualSummary();
  renderSectionsPanel();

  // Scroll to the map so the user can start measuring
  var mapEl = document.getElementById("map");
  if (mapEl) mapEl.scrollIntoView({ behavior: "smooth", block: "start" });
}

function removeManualSection(id) {
  const idx = manualSections.findIndex((s) => s.id === id);
  if (idx === -1) return;
  manualSections.splice(idx, 1);
  // Also remove from shared sections[]
  const sharedIdx = sections.findIndex((s) => s.id === id);
  if (sharedIdx !== -1) sections.splice(sharedIdx, 1);
  // Re-label
  manualNextLabel = 0;
  manualSections.forEach((s, i) => {
    s.label = "Section " + String.fromCharCode(65 + i);
    manualNextLabel = i + 1;
  });
  if (manualSections.length === 0) addManualSection(); // keep at least one
  renderManualSections();
  updateManualSummary();
  renderSectionsPanel();
}

// Update data model + recalculate yield + update sidebar, WITHOUT touching
// the manual card DOM. Safe to call during compass drag / tilt slide.
function updateManualSectionData(id, field, value) {
  const sec = manualSections.find((s) => s.id === id);
  if (!sec) return;
  sec[field] = value;
  const panelWp =
    parseFloat(document.getElementById("panelWp").value) || DEFAULT_PANEL_WP;
  sec.panelWp = panelWp;
  // Only calculate yield if the user has actually entered a panel count
  const count = parseInt(sec.manualPanelCount);
  let y = null;
  if (count && count > 0) {
    y = calcYield(
      count,
      panelWp,
      sec.manualAzimuth,
      sec.manualTilt,
      sec.county,
    );
  }
  sec.result = y
    ? {
        panelCount: count,
        azimuthDeg: sec.manualAzimuth,
        pitchDeg: sec.manualTilt,
        panelWp,
        county: sec.county,
        annualKwh: y.annualKwh,
        annualCo2: y.annualCo2,
        arrayKwp: y.arrayKwp,
        countyEffectPercent: y.countyEffectPercent,
        cardinalDir: CARDINALS[Math.round(sec.manualAzimuth / 22.5) % 16],
        orientationLabel:
          CARDINALS[Math.round(sec.manualAzimuth / 22.5) % 16] + "-facing",
      }
    : null;
  // Update shared sections[] copy
  const shared = sections.find((s) => s.id === id);
  if (shared) {
    shared.result = sec.result;
    shared.panelWp = panelWp;
  }
  updateManualSummary();
  renderSectionsPanel();
}

// Full update: data + DOM re-render. Use for structural changes (add/remove
// sections) or when the card DOM needs to reflect new values.
function updateManualSection(id, field, value) {
  updateManualSectionData(id, field, value);
  renderManualSections();
}

function recalcAllManualSections() {
  const county = document.getElementById("rtManualCounty").value || "Dublin";
  manualSections.forEach((sec) => {
    sec.county = county;
    updateManualSectionData(sec.id, "county", county);
  });
  // County change doesn't need a full re-render (no visual change in cards)
}

function renderManualSections() {
  const wrap = document.getElementById("rtManualSections");
  if (!wrap) return;
  if (manualSections.length === 0) {
    wrap.innerHTML = "";
    return;
  }
  wrap.innerHTML = manualSections
    .map((sec) => {
      const azName = rtFormatAzimuthForDisplay(sec.manualAzimuth);
      const tiltDescriptor = rtTiltDescriptorFromDegrees(sec.manualTilt);
      const panelVal = sec.manualPanelCount != null ? sec.manualPanelCount : "";
      return (
        '<div class="solar-calc-manual-card" data-id="' +
        sec.id +
        '" style="--solar-calc-sec-color:' +
        sec.color +
        ";--solar-calc-sec-soft:" +
        rtHexToRgba(sec.color, 0.1) +
        ';">' +
        '<div class="solar-calc-manual-card__head">' +
        '<span class="solar-calc-manual-card__dot" style="background:' +
        sec.color +
        ';"></span>' +
        '<span class="solar-calc-manual-card__label">' +
        sec.label +
        "</span>" +
        (manualSections.length > 1
          ? '<button type="button" class="solar-calc-manual-card__remove" onclick="removeManualSection(' +
            sec.id +
            ')" title="Remove ' +
            sec.label +
            '"><i class="far fa-times"></i></button>'
          : "") +
        "</div>" +
        '<div class="solar-calc-manual-card__body">' +
        // Panel count stepper
        '<div class="solar-calc-manual-card__field">' +
        '<label class="solar-calc-manual-card__fieldLabel">Number of panels</label>' +
        '<div class="solar-calc-stepper-group">' +
        '<div class="solar-calc-stepper">' +
        '<button type="button" class="solar-calc-stepper__btn" onclick="manualStepValue(' +
        sec.id +
        ',\'manualPanelCount\',-1)"><i class="fas fa-chevron-down"></i></button>' +
        '<input type="number" class="solar-calc-field__input" value="' +
        panelVal +
        '" min="1" max="100" placeholder="e.g. 12" onchange="updateManualSection(' +
        sec.id +
        ",'manualPanelCount',this.value?parseInt(this.value):null)\">" +
        '<button type="button" class="solar-calc-stepper__btn" onclick="manualStepValue(' +
        sec.id +
        ',\'manualPanelCount\',1)"><i class="fas fa-chevron-up"></i></button>' +
        "</div>" +
        "</div>" +
        "</div>" +
        // Azimuth â€” compass dial (shared module)
        '<div class="solar-calc-manual-card__field">' +
        '<label class="solar-calc-manual-card__fieldLabel">Roof direction (azimuth): <strong class="solar-calc-manual-compass-label" id="compass-label-' +
        sec.id +
        '">' +
        azName +
        "</strong></label>" +
        '<div class="solar-calc-manual-compass" id="compass-container-' +
        sec.id +
        '">' +
        rtManualCompassMarkup(sec.manualAzimuth) +
        "</div>" +
        "</div>" +
        // Tilt â€” slider + SVG (shared module)
        '<div class="solar-calc-manual-card__field">' +
        '<label class="solar-calc-manual-card__fieldLabel">Roof pitch: <strong class="solar-calc-manual-tilt-label" id="tilt-label-' +
        sec.id +
        '">' +
        sec.manualTilt +
        '\u00b0</strong> &ndash; <strong class="solar-calc-manual-tilt-label" id="tilt-label-desc-' +
        sec.id +
        '">' +
        tiltDescriptor +
        "</strong></label>" +
        '<div class="solar-calc-manual-tilt" id="tilt-container-' +
        sec.id +
        '">' +
        rtManualTiltMarkup(sec.manualTilt) +
        "</div>" +
        "</div>" +
        "</div>" +
        "</div>"
      );
    })
    .join("");

  // Re-attach stepper init for newly created inputs
  rtInitSteppers();
  // Initialize shared compass + tilt controls in each section
  initManualCompasses();
  initManualTiltSliders();
}

// --- Per-section compass init (uses shared compass-tilt-control.js) -------
function initManualCompasses() {
  manualSections.forEach(function (sec) {
    var container = document.getElementById("compass-container-" + sec.id);
    if (!container) return;
    if (container.dataset.boundCompass === "1") return;
    var compass = bindCompassControl(container, {
      azimuth: sec.manualAzimuth,
      size: 140,
      onChange: function (azimuthDeg) {
        // Update the label above the compass
        var label = document.getElementById("compass-label-" + sec.id);
        var azName = rtFormatAzimuthForDisplay(azimuthDeg);
        if (label) label.textContent = azName;
        // Data-only update â€” does NOT re-render the card DOM
        updateManualSectionData(sec.id, "manualAzimuth", azimuthDeg);
      },
    });
    // Store reference for later use
    sec._compass = compass;
    container.dataset.boundCompass = "1";
  });
}

// --- Per-section tilt init (uses shared compass-tilt-control.js) ----------
function initManualTiltSliders() {
  manualSections.forEach(function (sec) {
    var container = document.getElementById("tilt-container-" + sec.id);
    if (!container) return;
    if (container.dataset.boundTilt === "1") return;
    var tilt = bindTiltSliderControl(container, {
      tilt: sec.manualTilt,
      onChange: function (tiltDeg) {
        // Update the label above the slider
        var label = document.getElementById("tilt-label-" + sec.id);
        var labelDesc = document.getElementById("tilt-label-desc-" + sec.id);
        if (label) label.textContent = tiltDeg + "\u00b0";
        if (labelDesc)
          labelDesc.textContent = rtTiltDescriptorFromDegrees(tiltDeg);
        // Data-only update â€” does NOT re-render the card DOM
        updateManualSectionData(sec.id, "manualTilt", tiltDeg);
      },
    });
    sec._tilt = tilt;
    container.dataset.boundTilt = "1";
  });
}

function azimuthOptions(selected) {
  const dirs = [
    [0, "N (0\u00b0)"],
    [45, "NE (45\u00b0)"],
    [90, "E (90\u00b0)"],
    [135, "SE (135\u00b0)"],
    [180, "S (180\u00b0)"],
    [225, "SW (225\u00b0)"],
    [270, "W (270\u00b0)"],
    [315, "NW (315\u00b0)"],
  ];
  return dirs
    .map(
      (d) =>
        '<option value="' +
        d[0] +
        '"' +
        (d[0] === selected ? " selected" : "") +
        ">" +
        d[1] +
        "</option>",
    )
    .join("");
}

function tiltOptions(selected) {
  let html = "";
  for (let t = 0; t <= 70; t += 5) {
    html +=
      '<option value="' +
      t +
      '"' +
      (t === selected ? " selected" : "") +
      ">" +
      t +
      "\u00b0</option>";
  }
  return html;
}

function manualStepValue(id, field, delta) {
  const sec = manualSections.find((s) => s.id === id);
  if (!sec) return;
  const current = sec[field] != null ? parseInt(sec[field]) : 0;
  const newVal = Math.max(1, Math.min(100, current + delta));
  updateManualSection(id, field, newVal);
}

function updateManualSummary() {
  const el = document.getElementById("rtManualSummary");
  if (!el) return;
  if (manualSections.length === 0) {
    el.style.display = "none";
    return;
  }
  const total = manualSections.reduce(
    (s, sec) => s + (parseInt(sec.manualPanelCount) || 0),
    0,
  );
  el.style.display = "";
  el.textContent =
    total > 0
      ? total +
        " panel" +
        (total !== 1 ? "s" : "") +
        " across " +
        manualSections.length +
        " roof section" +
        (manualSections.length !== 1 ? "s" : "")
      : "Enter your panel counts in the sections above";
}

// ---- Wire up Add-another-roof-section button --------------------------------
document.addEventListener("DOMContentLoaded", function () {
  const addBtn = document.getElementById("btnAddManualSection");
  if (addBtn) addBtn.addEventListener("click", addManualSection);
});

// Shared helper: update sidebar total-panel / kWp / kWh / CO₂ / accordion
// headlines from sections[], without touching the map-specific accordion UI.
function updateSidebarTotalsFromSections() {
  const total = sections.reduce(
    (s, sec) => s + (sec.result ? sec.result.panelCount : 0),
    0,
  );
  const panelWp =
    parseFloat(document.getElementById("panelWp").value) || DEFAULT_PANEL_WP;
  const totalKwp = (total * panelWp) / 1000;

  document.getElementById("totalPanelCount").textContent = total || "\u2026";
  document.getElementById("totalSystemSize").textContent = total
    ? totalKwp.toFixed(2)
    : "\u2026";

  const sectionCountSuffix = document.getElementById("totalSectionCountSuffix");
  if (sectionCountSuffix) {
    const secCount = sections.length;
    sectionCountSuffix.textContent =
      secCount > 1 ? " across " + secCount + " roof sections" : "";
  }

  const totalKwh = sections.reduce(
    (s, sec) =>
      s +
      (sec.result && sec.result.annualKwh != null ? sec.result.annualKwh : 0),
    0,
  );
  const totalCo2 = sections.reduce(
    (s, sec) =>
      s +
      (sec.result && sec.result.annualCo2 != null ? sec.result.annualCo2 : 0),
    0,
  );
  const anyKwh = sections.some(
    (sec) => sec.result && sec.result.annualKwh != null,
  );

  document.getElementById("totalAnnualKwh").textContent = anyKwh
    ? Math.round(totalKwh).toLocaleString() + " kWh/yr"
    : "\u2014";
  document.getElementById("totalAnnualCo2").textContent = anyKwh
    ? Math.round(totalCo2).toLocaleString() + " kg CO\u2082/yr"
    : "\u2014";

  const energySummaryEl = document.getElementById("solar-calc-summaryEnergy");
  const co2SummaryEl = document.getElementById("solar-calc-summaryCo2");
  const energyIntroEl = document.getElementById("solar-calc-energyIntroText");
  const co2IntroEl = document.getElementById("solar-calc-co2IntroText");
  if (energySummaryEl)
    energySummaryEl.textContent = anyKwh
      ? Math.round(totalKwh).toLocaleString() + "\u00a0kWh/yr"
      : "\u2014";
  if (co2SummaryEl)
    co2SummaryEl.textContent = anyKwh
      ? Math.round(totalCo2).toLocaleString() + "\u00a0kg/yr"
      : "\u2014";
  if (energyIntroEl) {
    energyIntroEl.textContent = anyKwh
      ? "Your " +
        total +
        "-panel system is estimated to generate around " +
        Math.round(totalKwh).toLocaleString() +
        "\u00a0kWh per year."
      : "";
  }
  if (co2IntroEl) {
    if (anyKwh) {
      const litresPetrol =
        typeof co2KgPerLitrePetrol !== "undefined" && co2KgPerLitrePetrol > 0
          ? Math.round(totalCo2 / co2KgPerLitrePetrol)
          : 0;
      const trees =
        typeof co2KgAbsorbedPerTreePerYear !== "undefined" &&
        co2KgAbsorbedPerTreePerYear > 0
          ? Math.round(totalCo2 / co2KgAbsorbedPerTreePerYear)
          : 0;
      co2IntroEl.innerHTML =
        "Your system will save an estimated <strong>" +
        Math.round(totalCo2).toLocaleString() +
        "\u00a0kg of CO&#8322;</strong> per year &mdash; the equivalent of " +
        litresPetrol.toLocaleString() +
        " litres of petrol burned, or what " +
        trees.toLocaleString() +
        " mature trees absorb in a year.";
    } else {
      co2IntroEl.textContent = "";
    }
  }

  const roofSectionsHeadline = document.getElementById(
    "solar-calc-summaryRoofSectionsVal",
  );
  if (roofSectionsHeadline) {
    const secCount = sections.length;
    roofSectionsHeadline.textContent =
      secCount === 0
        ? "\u2014"
        : total +
          " panel" +
          (total !== 1 ? "s" : "") +
          " in " +
          secCount +
          " roof section" +
          (secCount !== 1 ? "s" : "");
  }
}

function renderSectionsPanel() {
  const focusSnap = captureAdjustInputFocus();

  // In manual mode, sections are managed by the manual panel UI.
  if (inputMode === "manual") {
    updateSidebarTotalsFromSections();
    runFinancials();
    restoreAdjustInputFocus(focusSnap);
    return;
  }

  const listSec = document.getElementById("sectionListSection");
  const list = document.getElementById("sectionsList");
  if (!listSec || !list) {
    restoreAdjustInputFocus(focusSnap);
    return;
  }

  // Always keep the Roof Sections accordion visible (never hide it).
  // The user controls its open/closed state via click only.
  listSec.style.display = "block";

  if (sections.length === 0) {
    // Show empty-state message inside the accordion body; do NOT hide the accordion.
    list.innerHTML =
      '<p class="solar-calc-acc__note" style="padding:12px 0;">No roof sections added yet. Use the map to trace your roof, or switch to &ldquo;Just enter my requirements&rdquo; above.</p>';

    // Reset all total summary fields
    document.getElementById("totalPanelCount").textContent = "\u2026";
    document.getElementById("totalSystemSize").textContent = "\u2026";
    document.getElementById("totalAnnualKwh").textContent = "\u2014";
    document.getElementById("totalAnnualCo2").textContent = "\u2014";
    document.getElementById("totalAnnualBillSavings").textContent = "\u2014";
    document.getElementById("totalPriceAfterGrant").textContent = "\u2014";
    const totalPriceRangeNote = document.getElementById("totalPriceRangeNote");
    if (totalPriceRangeNote) totalPriceRangeNote.style.display = "none";

    // Reset accordion headline summaries
    const energySummaryEl = document.getElementById("solar-calc-summaryEnergy");
    const co2SummaryEl = document.getElementById("solar-calc-summaryCo2");
    const energyIntroEl = document.getElementById("solar-calc-energyIntroText");
    const co2IntroEl = document.getElementById("solar-calc-co2IntroText");
    const roofSectionsHeadline = document.getElementById("solar-calc-summaryRoofSectionsVal");
    const billSavingsSummaryEl = document.getElementById("solar-calc-summaryBillSavingsVal");
    const priceSummaryEl = document.getElementById("solar-calc-summaryPriceVal");
    if (energySummaryEl) energySummaryEl.textContent = "\u2014";
    if (co2SummaryEl) co2SummaryEl.textContent = "\u2014";
    if (energyIntroEl) energyIntroEl.textContent = "";
    if (co2IntroEl) co2IntroEl.textContent = "";
    if (roofSectionsHeadline) roofSectionsHeadline.textContent = "\u2014";
    if (billSavingsSummaryEl) billSavingsSummaryEl.textContent = "\u2014";
    if (priceSummaryEl) priceSummaryEl.textContent = "\u2014";

    // Update the shared editor for new-drawing state
    updateSharedEditorForNewDrawing();
    renderSelectedFaces();
    runFinancials();
    restoreAdjustInputFocus(focusSnap);
    return;
  }

  // Build or update the section list. Use targeted DOM updates: only rebuild
  // sections that are new or whose data has structurally changed.
  // Strategy: remove sections whose IDs no longer exist, append new ones,
  // update bodies of existing ones.
  const existingDets = list.querySelectorAll(".solar-calc-section");
  const existingIds = new Set();
  existingDets.forEach(function (det) {
    existingIds.add(Number(det.dataset.sid));
  });

  // Remove sections that no longer exist in the data
  existingDets.forEach(function (det) {
    var sid = Number(det.dataset.sid);
    if (!sections.some(function (s) { return s.id === sid; })) {
      det.remove();
    }
  });

  // Add or update each section
  sections.forEach(function (sec) {
    var existingDet = list.querySelector('.solar-calc-section[data-sid="' + sec.id + '"]');
    if (existingDet) {
      // Section already exists in DOM — update its summary + body content in place.
      // Do NOT touch its .open state (browser manages this natively).
      updateSectionSummaryDOM(existingDet, sec);
      updateSectionBodyDOM(existingDet, sec);
    } else {
      // New section — create and append to list
      var det = buildSectionDOM(sec);
      list.appendChild(det);
    }
  });

  // Initialize stepper controls on any newly-created per-section inputs.
  // Safe to call repeatedly — rtInitSteppers() skips already-wrapped inputs.
  rtInitSteppers();

  // Summary total calculations
  var total = sections.reduce(function (s, sec) { return s + (sec.result ? sec.result.panelCount : 0); }, 0);
  document.getElementById("totalPanelCount").textContent = total;

  var panelWp = parseFloat(document.getElementById("panelWp").value) || DEFAULT_PANEL_WP;
  var totalKwp = (total * panelWp) / 1000;
  document.getElementById("totalSystemSize").textContent = totalKwp.toFixed(2);

  var sectionCountSuffix = document.getElementById("totalSectionCountSuffix");
  if (sectionCountSuffix) {
    var secCount = sections.length;
    sectionCountSuffix.textContent = secCount > 1 ? " across " + secCount + " roof sections" : "";
  }

  var totalKwh = sections.reduce(function (s, sec) { return s + (sec.result && sec.result.annualKwh != null ? sec.result.annualKwh : 0); }, 0);
  var totalCo2 = sections.reduce(function (s, sec) { return s + (sec.result && sec.result.annualCo2 != null ? sec.result.annualCo2 : 0); }, 0);
  var anyKwh = sections.some(function (sec) { return sec.result && sec.result.annualKwh != null; });

  document.getElementById("totalAnnualKwh").textContent = anyKwh ? Math.round(totalKwh).toLocaleString() + " kWh/yr" : "\u2014";
  document.getElementById("totalAnnualCo2").textContent = anyKwh ? Math.round(totalCo2).toLocaleString() + " kg CO\u2082/yr" : "\u2014";

  var energySummaryEl = document.getElementById("solar-calc-summaryEnergy");
  var co2SummaryEl = document.getElementById("solar-calc-summaryCo2");
  var energyIntroEl = document.getElementById("solar-calc-energyIntroText");
  var co2IntroEl = document.getElementById("solar-calc-co2IntroText");
  if (energySummaryEl) energySummaryEl.textContent = anyKwh ? Math.round(totalKwh).toLocaleString() + "\u00a0kWh/yr" : "\u2014";
  if (co2SummaryEl) co2SummaryEl.textContent = anyKwh ? Math.round(totalCo2).toLocaleString() + "\u00a0kg/yr" : "\u2014";
  if (energyIntroEl) {
    energyIntroEl.textContent = anyKwh
      ? "Your " + total + "-panel system is estimated to generate around " + Math.round(totalKwh).toLocaleString() + "\u00a0kWh per year."
      : "";
  }
  if (co2IntroEl) {
    if (anyKwh) {
      var litresPetrol = co2KgPerLitrePetrol > 0 ? Math.round(totalCo2 / co2KgPerLitrePetrol) : 0;
      var trees = co2KgAbsorbedPerTreePerYear > 0 ? Math.round(totalCo2 / co2KgAbsorbedPerTreePerYear) : 0;
      co2IntroEl.innerHTML = "Your system will save an estimated <strong>" + Math.round(totalCo2).toLocaleString() + "\u00a0kg of CO&#8322;</strong> per year &mdash; the equivalent of " + litresPetrol.toLocaleString() + " litres of petrol burned, or what " + trees.toLocaleString() + " mature trees absorb in a year.";
    } else {
      co2IntroEl.textContent = "";
    }
  }

  var roofSectionsHeadline = document.getElementById("solar-calc-summaryRoofSectionsVal");
  if (roofSectionsHeadline) {
    var secCount = sections.length;
    roofSectionsHeadline.textContent = secCount === 0 ? "\u2014" : total + " panel" + (total !== 1 ? "s" : "") + " in " + secCount + " roof section" + (secCount !== 1 ? "s" : "");
  }

  // Update the shared editor context for the currently active map section (or new drawing)
  updateSharedEditorContext();

  renderSelectedFaces();
  runFinancials();
  restoreAdjustInputFocus(focusSnap);
}

// ---- Per-section DOM builders --------------------------------------------

// Build a single <details> element for a roof section.
// The accordion body gets its own inline editor content — no shared DOM movement.
function buildSectionDOM(sec) {
  var count = sec.result ? sec.result.panelCount : 0;
  var az = sec.result && sec.result.azimuthDeg != null ? rtFormatAzimuthForDisplay(sec.result.azimuthDeg) : "";
  var isActive = sec.id === editingSectionId;

  var det = document.createElement("details");
  det.className = "solar-calc-section" + (isActive ? " solar-calc-section--active" : "");
  det.dataset.sid = sec.id;
  // Browser manages .open natively — no programmatic override.

  var sum = document.createElement("summary");
  sum.className = "solar-calc-section__summary";
  sum.innerHTML =
    '<span class="solar-calc-section__dot" style="background:' + sec.color + ';"></span>' +
    '<span class="solar-calc-section__info">' +
    '<span class="solar-calc-section__name">' + sec.label + '</span>' +
    (az ? '<span class="solar-calc-section__meta">' + az + '</span>' : '') +
    '</span>';

  var removeBtn = document.createElement("button");
  removeBtn.type = "button";
  removeBtn.className = "solar-calc-section__remove";
  removeBtn.textContent = "Remove";
  removeBtn.setAttribute("aria-label", "Remove " + sec.label);
  removeBtn.title = "Remove " + sec.label;
  removeBtn.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopPropagation();
    deleteSection(sec.id);
  });

  var countEl = document.createElement("span");
  countEl.className = "solar-calc-section__count";
  countEl.textContent = count + " panel" + (count !== 1 ? "s" : "");

  // Clicking the summary selects this section for map editing (separate from expand/collapse).
  // The browser's native <details> handles expand/collapse on its own.
  sum.addEventListener("click", function (event) {
    // Only select for map editing if the click wasn't on the Remove button
    if (event.target === removeBtn || removeBtn.contains(event.target)) return;
    if (sec.id !== editingSectionId) editSection(sec.id);
  });

  det.appendChild(sum);
  sum.appendChild(removeBtn);
  sum.appendChild(countEl);

  var body = document.createElement("div");
  body.className = "solar-calc-section__body";
  body.dataset.body = sec.id;
  // Render the per-section inline editor content
  body.innerHTML = buildSectionBodyHTML(sec);
  det.appendChild(body);

  return det;
}

// Update an existing section's summary bar (label, azimuth, panel count, active state).
function updateSectionSummaryDOM(det, sec) {
  var count = sec.result ? sec.result.panelCount : 0;
  var az = sec.result && sec.result.azimuthDeg != null ? rtFormatAzimuthForDisplay(sec.result.azimuthDeg) : "";
  var isActive = sec.id === editingSectionId;

  // Update class
  det.className = "solar-calc-section" + (isActive ? " solar-calc-section--active" : "");

  // Update summary inner content
  var sum = det.querySelector(".solar-calc-section__summary");
  if (sum) {
    var dot = sum.querySelector(".solar-calc-section__dot");
    var name = sum.querySelector(".solar-calc-section__name");
    var meta = sum.querySelector(".solar-calc-section__meta");
    var countEl = sum.querySelector(".solar-calc-section__count");

    if (dot) dot.style.background = sec.color;
    if (name) name.textContent = sec.label;
    if (meta) {
      if (az) {
        meta.textContent = az;
        meta.style.display = "";
      } else {
        meta.style.display = "none";
      }
    }
    if (countEl) countEl.textContent = count + " panel" + (count !== 1 ? "s" : "");
  }
}

// Update an existing section's body content in place.
// Preserves the open/closed state of internal <details> elements.
function updateSectionBodyDOM(det, sec) {
  var body = det.querySelector('.solar-calc-section__body[data-body="' + sec.id + '"]');
  if (!body) return;

  // Save open states of internal <details> elements
  var internalDetails = body.querySelectorAll("details.solar-calc-item");
  var openStates = {};
  internalDetails.forEach(function (d, i) {
    // Use the label text as a key to identify which detail is which
    var label = d.querySelector(".solar-calc-item__label");
    var key = label ? label.textContent.trim() : "detail-" + i;
    openStates[key] = d.open;
  });

  // Update only the result card + delete button (preserve settings controls)
  var resultCard = body.querySelector(".solar-calc-faceCards");
  var r = sec.result || {};
  var slopedArea = r.slopedArea != null ? r.slopedArea.toFixed(1) + " m\u00b2" : "\u2014";
  var footprintArea = r.footprintArea != null ? r.footprintArea.toFixed(1) + " m\u00b2" : "\u2014";
  var usableArea = r.usableArea != null ? r.usableArea.toFixed(1) + " m\u00b2" : "\u2014";
  var orientationLabel = r.orientationLabel || "\u2014";
  var gridStr = (r.cols != null ? r.cols : 0) + " \u00d7 " + (r.rows != null ? r.rows : 0);
  var az = r.azimuthDeg != null ? rtFormatAzimuthForDisplay(r.azimuthDeg) : "\u2014";
  var county = r.county || "\u2014";
  var kwh = r.annualKwh != null ? Math.round(r.annualKwh).toLocaleString() + " kWh/yr" : (r.azimuthDeg != null ? "N/A (north-facing)" : "\u2014");
  var co2 = r.annualCo2 != null ? Math.round(r.annualCo2).toLocaleString() + " kg CO\u2082/yr" : "\u2014";

  if (resultCard) {
    resultCard.innerHTML =
      '<details class="solar-calc-item">' +
      '<summary class="solar-calc-item__summary">' +
      '<span class="solar-calc-item__label">See roof area details</span>' +
      '<span class="solar-calc-item__value">' + slopedArea + '</span>' +
      '</summary>' +
      '<div class="solar-calc-item__body">' +
      '<div style="margin-top:6px;padding:10px 12px;border:1px solid #f2c8b8;border-left:4px solid #e45f31;border-radius:4px;background:#fff1ea;">' +
      '<div class="solar-calc-line"><span>Footprint area</span><span>' + footprintArea + '</span></div>' +
      '<div class="solar-calc-line"><span>True sloped area</span><span>' + slopedArea + '</span></div>' +
      '<div class="solar-calc-line"><span>Usable (after margin)</span><span>' + usableArea + '</span></div>' +
      '<div class="solar-calc-line"><span>Orientation</span><span>' + orientationLabel + '</span></div>' +
      '<div class="solar-calc-line"><span>Grid (cols \u00d7 rows)</span><span>' + gridStr + '</span></div>' +
      '<div class="solar-calc-line"><span>Panel azimuth</span><span>' + az + '</span></div>' +
      '<div class="solar-calc-line"><span>County</span><span>' + county + '</span></div>' +
      '<div class="solar-calc-line"><span>Annual generation</span><span>' + kwh + '</span></div>' +
      '<div class="solar-calc-line"><span>Annual CO\u2082 saved</span><span>' + co2 + '</span></div>' +
      '</div>' +
      '</div>' +
      '</details>';
  }

  // Update summary count in parent section header
  var count = r.panelCount || 0;
  var countEl = det.querySelector(".solar-calc-section__count");
  if (countEl) countEl.textContent = count + " panel" + (count !== 1 ? "s" : "");
}

// Generate the inline editor HTML for a committed section's accordion body.
// This is a per-section clone of the controls from #sectionEditor, with
// per-section IDs and event handlers so each section is independently editable.
function buildSectionBodyHTML(sec) {
  var r = sec.result || {};
  var pitch = sec.pitch != null ? sec.pitch : DEFAULT_ROOF_PITCH_DEG;
  var margin = sec.margin != null ? sec.margin : DEFAULT_PANEL_MARGIN_M;
  var orientation = sec.orientation || "auto";
  var panelCount = r.panelCount || 0;
  var footprintArea = r.footprintArea != null ? r.footprintArea.toFixed(1) + " m\u00b2" : "\u2014";
  var slopedArea = r.slopedArea != null ? r.slopedArea.toFixed(1) + " m\u00b2" : "\u2014";
  var usableArea = r.usableArea != null ? r.usableArea.toFixed(1) + " m\u00b2" : "\u2014";
  var orientationLabel = r.orientationLabel || "\u2014";
  var gridStr = (r.cols != null ? r.cols : 0) + " \u00d7 " + (r.rows != null ? r.rows : 0);
  var az = r.azimuthDeg != null ? rtFormatAzimuthForDisplay(r.azimuthDeg) : "\u2014";
  var county = r.county || "\u2014";
  var kwh = r.annualKwh != null ? Math.round(r.annualKwh).toLocaleString() + " kWh/yr" : (r.azimuthDeg != null ? "N/A (north-facing)" : "\u2014");
  var co2 = r.annualCo2 != null ? Math.round(r.annualCo2).toLocaleString() + " kg CO\u2082/yr" : "\u2014";
  var azimuthDeg = r.azimuthDeg != null ? r.azimuthDeg : "\u2014";

  var orientationOptions = "";
  var orientationLabels = { "auto": "Auto (best fit)", "portrait": "Portrait (long side up-slope)", "landscape": "Landscape (long side along gutter)" };
  Object.keys(orientationLabels).forEach(function (val) {
    orientationOptions += '<option value="' + val + '"' + (orientation === val ? ' selected' : '') + '>' + orientationLabels[val] + '</option>';
  });

  var sid = sec.id;

  return (
    // Hint line
    '<p class="solar-calc-faceEditor__hint">These settings apply to ' + sec.label.replace("Section ", "section ") + ' only.</p>' +

    // Pitch control — mirrors the original #sectionEditor markup exactly:
    // <input type="number"> with stepper class, wrapped by rtInitSteppers().
    '<details class="solar-calc-item">' +
    '<summary class="solar-calc-item__summary">' +
    '<span class="solar-calc-item__label">Roof pitch</span>' +
    '<span class="solar-calc-item__value" id="sec-pitchValue-' + sid + '">' + pitch + '&deg;</span>' +
    '</summary>' +
    '<div class="solar-calc-item__body">' +
    '<input type="number" id="sec-pitch-' + sid + '" class="solar-calc-field__input solar-calc-field--stepper" value="' + pitch + '" min="0" max="60" step="5" data-step-ui="5" onchange="onSectionSettingChange(' + sid + ',\'pitch\',this.value)">' +
    '<p class="solar-calc-item__note">The angle of your roof slope. Around 30&ndash;35&deg; is near-ideal in Ireland, though anything from flat to fairly steep still generates well. A typical Irish house roof is about 30&ndash;40&deg;.</p>' +
    '</div>' +
    '</details>' +

    // Margin control — mirrors the original #sectionEditor markup.
    '<details class="solar-calc-item">' +
    '<summary class="solar-calc-item__summary">' +
    '<span class="solar-calc-item__label">Keep-out margin</span>' +
    '<span class="solar-calc-item__value" id="sec-marginValue-' + sid + '">' + margin + ' m</span>' +
    '</summary>' +
    '<div class="solar-calc-item__body">' +
    '<input type="number" id="sec-margin-' + sid + '" class="solar-calc-field__input solar-calc-field--stepper" value="' + margin + '" min="0" max="2" step="0.05" data-step-ui="0.05" onchange="onSectionSettingChange(' + sid + ',\'margin\',this.value)">' +
    '<p class="solar-calc-item__note">The clear space left around the roof edges. You need to leave 0.5m at the bottom and side of the roof, and 0.2m from the ridge. If you are semidetached / terraced, you can go right up to your neighbour\'s boundary - you only need to leave a margin by the open edges of the roof.</p>' +
    '</div>' +
    '</details>' +

    // Orientation control — mirrors the original #sectionEditor <select>.
    '<details class="solar-calc-item">' +
    '<summary class="solar-calc-item__summary">' +
    '<span class="solar-calc-item__label">Panel orientation</span>' +
    '<span class="solar-calc-item__value" id="sec-orientationValue-' + sid + '">' + (orientationLabels[orientation] || orientation) + '</span>' +
    '</summary>' +
    '<div class="solar-calc-item__body">' +
    '<select id="sec-orientation-' + sid + '" class="solar-calc-field__input" onchange="onSectionSettingChange(' + sid + ',\'orientation\',this.value)">' + orientationOptions + '</select>' +
    '<p class="solar-calc-item__note">How panels are placed on the roof. &ldquo;Auto&rdquo; tries both layouts and keeps whichever fits the most panels &mdash; usually the best choice.</p>' +
    '</div>' +
    '</details>' +

    // Result card
    '<div class="solar-calc-faceCards">' +
    '<details class="solar-calc-item">' +
    '<summary class="solar-calc-item__summary">' +
    '<span class="solar-calc-item__label">See roof area details</span>' +
    '<span class="solar-calc-item__value">' + slopedArea + '</span>' +
    '</summary>' +
    '<div class="solar-calc-item__body">' +
    '<div style="margin-top:6px;padding:10px 12px;border:1px solid #f2c8b8;border-left:4px solid #e45f31;border-radius:4px;background:#fff1ea;">' +
    '<div class="solar-calc-line"><span>Footprint area</span><span>' + footprintArea + '</span></div>' +
    '<div class="solar-calc-line"><span>True sloped area</span><span>' + slopedArea + '</span></div>' +
    '<div class="solar-calc-line"><span>Usable (after margin)</span><span>' + usableArea + '</span></div>' +
    '<div class="solar-calc-line"><span>Orientation</span><span>' + orientationLabel + '</span></div>' +
    '<div class="solar-calc-line"><span>Grid (cols \u00d7 rows)</span><span>' + gridStr + '</span></div>' +
    '<div class="solar-calc-line"><span>Panel azimuth</span><span>' + az + '</span></div>' +
    '<div class="solar-calc-line"><span>County</span><span>' + county + '</span></div>' +
    '<div class="solar-calc-line"><span>Annual generation</span><span>' + kwh + '</span></div>' +
    '<div class="solar-calc-line"><span>Annual CO\u2082 saved</span><span>' + co2 + '</span></div>' +
    '</div>' +
    '</div>' +
    '</details>' +
    '</div>' +

    // Delete button
    '<button id="sec-btnDelete-' + sid + '" type="button" class="solar-calc-faceEditor__delete" onclick="deleteSection(' + sid + ')">' +
    '<i class="far fa-trash-can" aria-hidden="true"></i> Delete this section' +
    '</button>'
  );
}

// Called when a per-section setting is changed. Updates the section's data,
// re-runs calculation for that section only, and updates its DOM.
function onSectionSettingChange(sectionId, field, value) {
  var sec = sections.find(function (s) { return s.id === sectionId; });
  if (!sec) return;

  // Update the section's stored value
  var numVal = (field === "pitch" || field === "margin") ? parseFloat(value) : value;
  sec[field] = numVal;

  // Update the displayed value in the summary line (e.g. "30°" → "35°")
  var displayMap = { pitch: "sec-pitchValue-", margin: "sec-marginValue-", orientation: "sec-orientationValue-" };
  var suffixMap = { pitch: "\u00b0", margin: " m", orientation: "" };
  var labelMap = { auto: "Auto (best fit)", portrait: "Portrait (long side up-slope)", landscape: "Landscape (long side along gutter)" };
  var displayEl = document.getElementById((displayMap[field] || "") + sectionId);
  if (displayEl) {
    displayEl.textContent = field === "orientation" ? (labelMap[value] || value) : numVal + (suffixMap[field] || "");
  }

  // If this section is the active map section, also sync global inputs
  if (editingSectionId === sectionId) {
    document.getElementById(field).value = value;
    rtSyncAllItemValues();
  }

  // Recalculate this section using its stored geometry + updated settings
  recalcSingleSection(sectionId);
}

// Recalculate a single section's results using its stored geometry and settings.
function recalcSingleSection(sectionId) {
  var sec = sections.find(function (s) { return s.id === sectionId; });
  if (!sec || !sec.clickPoints || sec.clickPoints.length < 3) return;

  // Save current global state
  var savedPitch = document.getElementById("pitch").value;
  var savedMargin = document.getElementById("margin").value;
  var savedPanelW = document.getElementById("panelW").value;
  var savedPanelH = document.getElementById("panelH").value;
  var savedPanelGap = document.getElementById("panelGap").value;
  var savedOrientation = document.getElementById("orientation").value;
  var savedPanelWp = document.getElementById("panelWp").value;
  var savedClickPoints = clickPoints;
  var savedRoofPolygon = roofPolygon;
  var savedPanelRectangles = panelRectangles;
  var savedGutterLine = gutterLine;
  var savedPointMarkers = pointMarkers;
  var savedState = state;

  // Set globals to this section's values
  document.getElementById("pitch").value = sec.pitch;
  document.getElementById("margin").value = sec.margin;
  document.getElementById("panelW").value = sec.panelW;
  document.getElementById("panelH").value = sec.panelH;
  document.getElementById("panelGap").value = sec.panelGap;
  document.getElementById("orientation").value = sec.orientation;
  document.getElementById("panelWp").value = sec.panelWp;
  rtSyncAllItemValues();

  clickPoints = sec.clickPoints.slice();
  state = STATE.CLOSED;

  // Hide the section's existing map panels. clearPanels() only clears the
  // global panelRectangles array, which may not include these if the section
  // is not currently the active drawing. Without this, the old panels remain
  // on the map while the new ones are drawn on top.
  sec.mapObjs.panelRectangles.forEach((p) => p.setMap(null));
  sec.mapObjs.panelRectangles = [];

  // Run calculation
  clearPanels();
  runCalculation();

  // After runCalculation(), panelRectangles is populated with the result.
  // The result is also rendered to legacy stats. We need to capture the result.
  // runCalculation() calls renderResult() which populates legacy stat fields.
  // We read those to build a result object.
  var result = buildResultFromLegacyStats(sec);

  // Restore global state
  document.getElementById("pitch").value = savedPitch;
  document.getElementById("margin").value = savedMargin;
  document.getElementById("panelW").value = savedPanelW;
  document.getElementById("panelH").value = savedPanelH;
  document.getElementById("panelGap").value = savedPanelGap;
  document.getElementById("orientation").value = savedOrientation;
  document.getElementById("panelWp").value = savedPanelWp;
  rtSyncAllItemValues();
  clickPoints = savedClickPoints;
  roofPolygon = savedRoofPolygon;
  panelRectangles = savedPanelRectangles;
  gutterLine = savedGutterLine;
  pointMarkers = savedPointMarkers;
  state = savedState;

  if (result) {
    sec.result = result;
    // Update this section's DOM only
    var det = document.querySelector('.solar-calc-section[data-sid="' + sectionId + '"]');
    if (det) {
      updateSectionSummaryDOM(det, sec);
      updateSectionBodyDOM(det, sec);
    }
    updateSidebarTotalsFromSections();
    updateAllAccordionHeadlines();
    runFinancials();
  }
}

// Build a result object from the legacy stats DOM (populated by runCalculation).
function buildResultFromLegacyStats(sec) {
  var panelCountEl = document.getElementById("panelCount");
  var statFootprint = document.getElementById("statFootprint");
  var statSloped = document.getElementById("statSloped");
  var statUsable = document.getElementById("statUsable");
  var statOrientation = document.getElementById("statOrientation");
  var statGrid = document.getElementById("statGrid");
  var statAzimuth = document.getElementById("statAzimuth");
  var statCounty = document.getElementById("statCounty");
  var statAnnualKwh = document.getElementById("statAnnualKwh");
  var statAnnualCo2 = document.getElementById("statAnnualCo2");

  if (!panelCountEl || panelCountEl.textContent === "\u2014") return null;

  var panelCount = parseInt(panelCountEl.textContent) || 0;
  var footprintArea = parseFloat(statFootprint ? statFootprint.textContent : 0) || null;
  var slopedArea = parseFloat(statSloped ? statSloped.textContent : 0) || null;
  var usableArea = parseFloat(statUsable ? statUsable.textContent : 0) || null;
  var orientationLabel = statOrientation ? statOrientation.textContent : "";
  var gridParts = statGrid ? statGrid.textContent.split("\u00d7") : [];
  var cols = gridParts.length === 2 ? parseInt(gridParts[0]) : null;
  var rows = gridParts.length === 2 ? parseInt(gridParts[1]) : null;
  var azimuthText = statAzimuth ? statAzimuth.textContent : "";
  var azimuthDeg = parseFloat(azimuthText) || null;
  var county = statCounty ? statCounty.textContent : "";
  var annualKwhText = statAnnualKwh ? statAnnualKwh.textContent : "";
  var annualKwh = parseFloat(annualKwhText) || null;
  var annualCo2Text = statAnnualCo2 ? statAnnualCo2.textContent : "";
  var annualCo2 = parseFloat(annualCo2Text) || null;

  return {
    panelCount: panelCount,
    footprintArea: footprintArea,
    slopedArea: slopedArea,
    usableArea: usableArea,
    orientationLabel: orientationLabel,
    cols: cols,
    rows: rows,
    azimuthDeg: azimuthDeg,
    county: county,
    annualKwh: annualKwh,
    annualCo2: annualCo2,
    arrayKwp: panelCount * (sec.panelWp || DEFAULT_PANEL_WP) / 1000,
    panelWp: sec.panelWp || DEFAULT_PANEL_WP,
    pitchDeg: sec.pitch,
    cardinalDir: azimuthDeg != null ? CARDINALS[Math.round(azimuthDeg / 22.5) % 16] : "",
  };
}

// Update shared editor context: show the active section's data in #sectionEditor,
// or show default state when no section is active (new drawing).
function updateSharedEditorContext() {
  var home = document.getElementById("editorHome");
  var delBtn = document.getElementById("btnDeleteSection");
  var hint = document.getElementById("activeSectionHint");

  // #editorHome is always hidden — per-section accordion bodies now contain
  // their own inline editors. The shared inputs remain in the DOM solely as
  // a backing store for captureState() / runCalculation() during new drawings.
  if (home) home.style.display = "none";

  if (editingSectionId !== null) {
    var sec = sections.find(function (s) { return s.id === editingSectionId; });
    if (sec) {
      // Populate shared inputs from the active section (for map display / undo / new-drawing defaults)
      document.getElementById("pitch").value = sec.pitch;
      document.getElementById("margin").value = sec.margin;
      document.getElementById("panelW").value = sec.panelW;
      document.getElementById("panelH").value = sec.panelH;
      document.getElementById("panelGap").value = sec.panelGap;
      document.getElementById("orientation").value = sec.orientation;
      document.getElementById("panelWp").value = sec.panelWp;
      rtSyncAllItemValues();
      if (hint) hint.textContent = "These settings apply to " + sec.label.replace("Section ", "section ") + " only.";
      document.getElementById("panelCountLabel").textContent = sections.length > 1 ? sec.label + " \u2014 Estimated panels" : "Estimated panels";
      if (delBtn) delBtn.style.display = "";
    }
  } else {
    if (delBtn) delBtn.style.display = "none";
    if (hint) hint.textContent = "These settings apply to the section being drawn only.";
    document.getElementById("panelCountLabel").textContent = "Estimated panels";
  }
}

// Update shared editor for new-drawing state (no active section).
// #editorHome stays hidden — shared inputs are a programmatic backing store only.
function updateSharedEditorForNewDrawing() {
  var home = document.getElementById("editorHome");
  var delBtn = document.getElementById("btnDeleteSection");
  var hint = document.getElementById("activeSectionHint");
  if (home) home.style.display = "none";
  if (delBtn) delBtn.style.display = "none";
  if (hint) hint.textContent = "These settings apply to the section being drawn only.";
  document.getElementById("panelCountLabel").textContent = "Estimated panels";
}

// Update all accordion headline values in the Breakdown pane.
function updateAllAccordionHeadlines() {
  var total = sections.reduce(function (s, sec) { return s + (sec.result ? sec.result.panelCount : 0); }, 0);
  var totalKwh = sections.reduce(function (s, sec) { return s + (sec.result && sec.result.annualKwh != null ? sec.result.annualKwh : 0); }, 0);
  var totalCo2 = sections.reduce(function (s, sec) { return s + (sec.result && sec.result.annualCo2 != null ? sec.result.annualCo2 : 0); }, 0);
  var anyKwh = sections.some(function (sec) { return sec.result && sec.result.annualKwh != null; });

  var roofSectionsHeadline = document.getElementById("solar-calc-summaryRoofSectionsVal");
  if (roofSectionsHeadline) {
    var secCount = sections.length;
    roofSectionsHeadline.textContent = secCount === 0 ? "\u2014" : total + " panel" + (total !== 1 ? "s" : "") + " in " + secCount + " roof section" + (secCount !== 1 ? "s" : "");
  }

  var energySummaryEl = document.getElementById("solar-calc-summaryEnergy");
  var co2SummaryEl = document.getElementById("solar-calc-summaryCo2");
  if (energySummaryEl) energySummaryEl.textContent = anyKwh ? Math.round(totalKwh).toLocaleString() + "\u00a0kWh/yr" : "\u2014";
  if (co2SummaryEl) co2SummaryEl.textContent = anyKwh ? Math.round(totalCo2).toLocaleString() + "\u00a0kg/yr" : "\u2014";
}

// Update the active highlight class on all section <details> elements
// to reflect which section is currently being edited on the map.
// Does NOT touch .open state — purely cosmetic class toggle.
function updateAllSectionActiveHighlights() {
  var allDets = document.querySelectorAll(".solar-calc-section");
  allDets.forEach(function (det) {
    var sid = Number(det.dataset.sid);
    if (sid === editingSectionId) {
      det.classList.add("solar-calc-section--active");
    } else {
      det.classList.remove("solar-calc-section--active");
    }
  });
}

// Build one read-only detail card per committed roof section. Driven entirely
// by sections[].result, so all sections stay visible at once.
function renderSelectedFaces() {
  const wrap = document.getElementById("selectedFacesList");
  if (!wrap) return;
  if (sections.length === 0) {
    wrap.innerHTML = "";
    return;
  }

  const activeSection =
    editingSectionId !== null
      ? sections.find((sec) => sec.id === editingSectionId)
      : null;

  if (!activeSection) {
    // No section is being edited on the map — either the user is drawing a new
    // section or idling. Either way, the face card is not relevant; show nothing.
    wrap.innerHTML = "";
    return;
  }

  const line = (label, val) =>
    '<div class="solar-calc-line"><span>' +
    label +
    "</span><span>" +
    val +
    "</span></div>";

  wrap.innerHTML = [activeSection]
    .map((sec) => {
      const r = sec.result || {};
      const az =
        r.azimuthDeg != null
          ? rtFormatAzimuthForDisplay(r.azimuthDeg)
          : "\u2014";
      const slopedHeadline =
        r.slopedArea != null ? r.slopedArea.toFixed(1) + " m\u00b2" : "\u2014";
      const kwh =
        r.annualKwh != null
          ? Math.round(r.annualKwh).toLocaleString() + " kWh/yr"
          : r.azimuthDeg != null
            ? "N/A (north-facing)"
            : "\u2014";
      const co2 =
        r.annualCo2 != null
          ? Math.round(r.annualCo2).toLocaleString() + " kg CO\u2082/yr"
          : "\u2014";
      return (
        '<details class="solar-calc-item">' +
        '<summary class="solar-calc-item__summary">' +
        '<span class="solar-calc-item__label">See roof area details</span>' +
        '<span class="solar-calc-item__value">' +
        slopedHeadline +
        "</span>" +
        "</summary>" +
        '<div class="solar-calc-item__body">' +
        '<div style="margin-top:6px;padding:10px 12px;border:1px solid #f2c8b8;border-left:4px solid #e45f31;border-radius:4px;background:#fff1ea;">' +
        line(
          "Footprint area",
          r.footprintArea != null
            ? r.footprintArea.toFixed(1) + " m\u00b2"
            : "\u2014",
        ) +
        line(
          "True sloped area",
          r.slopedArea != null
            ? r.slopedArea.toFixed(1) + " m\u00b2"
            : "\u2014",
        ) +
        line(
          "Usable (after margin)",
          r.usableArea != null
            ? r.usableArea.toFixed(1) + " m\u00b2"
            : "\u2014",
        ) +
        line("Orientation", r.orientationLabel || "\u2014") +
        line(
          "Grid (cols \u00d7 rows)",
          (r.cols != null ? r.cols : 0) +
            " \u00d7 " +
            (r.rows != null ? r.rows : 0),
        ) +
        line("Panel azimuth", az) +
        line("County", r.county || "\u2014") +
        line("Annual generation", kwh) +
        line("Annual CO\u2082 saved", co2) +
        "</div>" +
        "</div>" +
        "</details>"
      );
    })
    .join("");
}

function deleteSection(id) {
  const idx = sections.findIndex((s) => s.id === id);
  if (idx === -1) return;
  const sec = sections[idx];
  sec.mapObjs.panelRectangles.forEach((p) => p.setMap(null));
  sec.mapObjs.pointMarkers.forEach((m) => m.setMap(null));
  if (sec.mapObjs.roofPolygon) sec.mapObjs.roofPolygon.setMap(null);
  if (sec.mapObjs.gutterLine) sec.mapObjs.gutterLine.setMap(null);

  const wasActive = editingSectionId === id;
  sections.splice(idx, 1);
  sections.forEach((s, i) => {
    s.label = "Section " + String.fromCharCode(65 + i);
  });

  if (wasActive) {
    // Detach globals (objects already removed from map above)
    roofPolygon = null;
    gutterLine = null;
    panelRectangles = [];
    pointMarkers = [];
    if (previewPolyline) {
      previewPolyline.setMap(null);
      previewPolyline = null;
    }
    clickPoints = [];
    editingSectionId = null;
    undoStack = [];
    updateUndoButton();
    clearResultStats();
  }

  // Targeted DOM removal: remove only this section's <details> element
  var det = document.querySelector('.solar-calc-section[data-sid="' + id + '"]');
  if (det) det.remove();

  if (sections.length > 0) {
    // Update remaining section labels in the DOM
    sections.forEach(function (s) {
      var sDet = document.querySelector('.solar-calc-section[data-sid="' + s.id + '"]');
      if (sDet) updateSectionSummaryDOM(sDet, s);
    });
    // Keep the user in context: auto-select an adjacent remaining section
    if (wasActive) {
      const nextSec = sections[Math.min(idx, sections.length - 1)];
      editSection(nextSec.id);
    }
    updateSidebarTotalsFromSections();
    updateAllAccordionHeadlines();
    runFinancials();
  } else {
    // All sections removed — reset to empty state
    state = STATE.IDLE;
    editingSectionId = null;
    document.getElementById("btnAddSection").style.display = "none";
    document.getElementById("panelCountLabel").textContent = "Estimated panels";
    updateActiveSectionHeading();
    updateSharedEditorForNewDrawing();
    map.setOptions({ draggableCursor: "crosshair" });
    updateInstruction();
    renderSectionsPanel();
  }
}

function startNewSection() {
  // Clear any oversized-area warning from a previous attempt
  const pill = document.getElementById("rtPill");
  if (pill) pill.classList.remove("solar-calc-pill--oversized");

  // Committed section's map objects stay on the map; just detach globals.
  roofPolygon = null;
  gutterLine = null;
  panelRectangles = [];
  pointMarkers.forEach((m) => m.setMap(null));
  pointMarkers = [];
  if (previewPolyline) {
    previewPolyline.setMap(null);
    previewPolyline = null;
  }
  if (gutterLabel) {
    gutterLabel.setMap(null);
    gutterLabel = null;
  }
  clickPoints = [];
  editingSectionId = null;
  state = STATE.IDLE;
  undoStack = [];
  document.getElementById("btnAddSection").style.display = "none";
  updateUndoButton();
  clearResultStats();
  updateActiveSectionHeading();
  renderSectionsPanel();
  updateInstruction();
  map.setOptions({
    draggableCursor: "crosshair",
  });
}

document
  .getElementById("btnAddSection")
  .addEventListener("click", function () {
    // Scroll to map when clicking the accordion button (user is in Adjust pane)
    var mapEl = document.getElementById("map");
    if (mapEl) mapEl.scrollIntoView({ behavior: "smooth", block: "start" });
    startNewSection();
  });
document
  .getElementById("btnAddSectionInline")
  .addEventListener("click", startNewSection);
document.getElementById("btnDeleteSection").addEventListener("click", () => {
  if (editingSectionId !== null) deleteSection(editingSectionId);
});

// ---- Edit / view a previously committed section --------------------------
function renderResultFromSection(sec) {
  if (!sec.result) {
    clearResultStats();
    return;
  }
  const r = sec.result;
  document.getElementById("panelCount").innerText = r.panelCount;
  document.getElementById("statFootprint").innerText =
    r.footprintArea.toFixed(1) + " m\u00b2";
  document.getElementById("statSloped").innerText =
    r.slopedArea.toFixed(1) + " m\u00b2";
  document.getElementById("statUsable").innerText =
    r.usableArea.toFixed(1) + " m\u00b2";
  document.getElementById("statOrientation").innerText = r.orientationLabel;
  document.getElementById("statGrid").innerText = r.cols + " \u00d7 " + r.rows;
  document.getElementById("statAzimuth").innerText = rtFormatAzimuthForDisplay(
    r.azimuthDeg,
  );
  document.getElementById("statCounty").innerText = r.county || "\u2014";
  renderYieldStats(r.annualKwh, r.annualCo2);
  document.getElementById("warningBox").innerHTML = "";
}

function editSection(id) {
  const sec = sections.find((s) => s.id === id);
  if (!sec || editingSectionId === id) return;

  // If in the middle of an uncommitted fresh drawing, ask before discarding
  if (editingSectionId === null && clickPoints.length > 0) {
    if (
      !confirm(
        "Discard the section currently being drawn and switch to editing " +
          sec.label +
          "?",
      )
    )
      return;
    if (previewPolyline) {
      previewPolyline.setMap(null);
      previewPolyline = null;
    }
    if (gutterLine) {
      gutterLine.setMap(null);
      gutterLine = null;
    }
    clickPoints = [];
  }

  // Hide ALL section markers (current drawing markers + all committed sections)
  pointMarkers.forEach((m) => m.setMap(null));
  sections.forEach((s) =>
    s.mapObjs.pointMarkers.forEach((m) => m.setMap(null)),
  );

  // Load this section as the active editing context on the map
  clickPoints = sec.clickPoints.slice();
  roofPolygon = sec.mapObjs.roofPolygon;
  gutterLine = sec.mapObjs.gutterLine;
  panelRectangles = sec.mapObjs.panelRectangles.slice();
  pointMarkers = sec.mapObjs.pointMarkers.slice();

  // Show this section's corner markers as a visual cue that it is being edited
  pointMarkers.forEach((m) => m.setMap(map));

  editingSectionId = id;
  state = STATE.CLOSED;
  undoStack = [];

  // Populate shared settings inputs from this section
  document.getElementById("pitch").value = sec.pitch;
  document.getElementById("margin").value = sec.margin;
  document.getElementById("panelW").value = sec.panelW;
  document.getElementById("panelH").value = sec.panelH;
  document.getElementById("panelGap").value = sec.panelGap;
  document.getElementById("orientation").value = sec.orientation;
  if (sec.panelWp != null)
    document.getElementById("panelWp").value = sec.panelWp;
  rtSyncAllItemValues();

  // Show this section's saved stats in legacy stat fields
  renderResultFromSection(sec);
  document.getElementById("panelCountLabel").textContent =
    sections.length > 1
      ? sec.label + " \u2014 Estimated panels"
      : "Estimated panels";
  updateActiveSectionHeading();

  updateUndoButton();
  document.getElementById("btnAddSection").style.display = "block";
  map.setOptions({ draggableCursor: null });
  updateInstruction();

  // Update section list active highlights + shared editor context (no full rebuild)
  updateAllSectionActiveHighlights();
  updateSharedEditorContext();
  renderSelectedFaces();
}
[
  "pitch",
  "margin",
  "panelW",
  "panelH",
  "panelGap",
  "orientation",
  "panelWp",
].forEach((id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const LIVE_RECALC_DEBOUNCE_MS = 250;
  let recalcTimer = null;

  const runRecalculation = () => {
    if (state === STATE.CLOSED) {
      captureState();
      runCalculation();
    }
  };

  const queueRecalculation = () => {
    if (recalcTimer) clearTimeout(recalcTimer);
    recalcTimer = setTimeout(() => {
      recalcTimer = null;
      runRecalculation();
    }, LIVE_RECALC_DEBOUNCE_MS);
  };

  const recalcImmediately = () => {
    if (recalcTimer) {
      clearTimeout(recalcTimer);
      recalcTimer = null;
    }
    runRecalculation();
  };

  // While typing, debounce calculations so multi-digit edits don't break focus.
  el.addEventListener("input", queueRecalculation);
  // On committed changes (e.g. dropdown, blur), run right away.
  el.addEventListener("change", recalcImmediately);
});

// =========================================================================
// CORE GEOMETRY + PACKING
// =========================================================================
function runCalculation() {
  clearPanels();
  document.getElementById("warningBox").innerHTML = "";

  if (clickPoints.length < 3) return;

  const pitchDeg = parseFloat(document.getElementById("pitch").value) || 0;
  const margin = parseFloat(document.getElementById("margin").value) || 0;
  const panelWmm =
    parseFloat(document.getElementById("panelW").value) ||
    DEFAULT_PANEL_WIDTH_MM;
  const panelHmm =
    parseFloat(document.getElementById("panelH").value) ||
    DEFAULT_PANEL_HEIGHT_MM;
  const gapMm =
    parseFloat(document.getElementById("panelGap").value) ||
    DEFAULT_PANEL_GAP_MM;

  // Effective panel footprint in metres (incl. gap) — used for grid stepping
  // and point-in-polygon fit tests so the gap gets clearance too.
  const panelWGrid = (panelWmm + gapMm) / 1000;
  const panelHGrid = (panelHmm + gapMm) / 1000;
  // True panel body in metres (without gap) — used for drawn rectangles so
  // the visible panels don't inflate when the gap setting is changed.
  const panelWBody = panelWmm / 1000;
  const panelHBody = panelHmm / 1000;

  const pitchRad = (pitchDeg * Math.PI) / 180;
  const cosPitch = Math.cos(pitchRad);
  if (cosPitch < 0.01) {
    showWarning("Pitch too steep.");
    return;
  }

  // --- Step 1: project LatLng -> local metric XY aligned to baseline ----
  const origin = clickPoints[0];
  const p2 = clickPoints[1];

  // metres per degree at this latitude (equirectangular local approx)
  const latRad = (origin.lat() * Math.PI) / 180;
  const mPerDegLat = 111320;
  const mPerDegLng = 111320 * Math.cos(latRad);

  // Raw east/north metres relative to origin
  const toEN = (latLng) => ({
    e: (latLng.lng() - origin.lng()) * mPerDegLng,
    n: (latLng.lat() - origin.lat()) * mPerDegLat,
  });
  const fromEN = (e, n) =>
    new google.maps.LatLng(
      origin.lat() + n / mPerDegLat,
      origin.lng() + e / mPerDegLng,
    );

  // Baseline unit vector (in east/north space)
  const p2en = toEN(p2);
  const baselineLen = Math.sqrt(p2en.e * p2en.e + p2en.n * p2en.n);
  if (baselineLen < 0.1) {
    showWarning("Baseline too short.");
    return;
  }
  const ux = p2en.e / baselineLen;
  const uy = p2en.n / baselineLen;
  // Perpendicular (rotated 90Â° CCW): (-uy, ux). This becomes our +Y axis.

  // Rotate east/north -> local (X along baseline, Y perpendicular)
  const toLocal = (latLng) => {
    const { e, n } = toEN(latLng);
    return {
      x: e * ux + n * uy,
      y: -e * uy + n * ux,
    };
  };
  const fromLocal = (x, y) => {
    const e = x * ux - y * uy;
    const n = x * uy + y * ux;
    return fromEN(e, n);
  };

  // Build local polygon
  let local = clickPoints.map(toLocal);

  // Ensure Y is positive (roof should be "above" the baseline).
  // If centroid Y is negative, flip Y so panels pack upward correctly.
  const cy = local.reduce((s, p) => s + p.y, 0) / local.length;
  let yFlipped = false;
  if (cy < 0) {
    local = local.map((p) => ({
      x: p.x,
      y: -p.y,
    }));
    yFlipped = true;
  }

  // Footprint area (2D, top-down) via shoelace
  const footprintArea = polygonArea(local);

  // --- Guard: reject oversized selections before we attempt packing ---
  if (footprintArea > MAX_ROOF_AREA_M2) {
    // Clear everything drawn so the user can try again immediately
    clearPanels();
    if (roofPolygon) {
      roofPolygon.setMap(null);
      roofPolygon = null;
    }
    if (gutterLine) {
      gutterLine.setMap(null);
      gutterLine = null;
    }
    if (gutterLabel) {
      gutterLabel.setMap(null);
      gutterLabel = null;
    }
    pointMarkers.forEach((m) => m.setMap(null));
    pointMarkers = [];
    clickPoints = [];
    state = STATE.IDLE;
    undoStack = [];
    updateUndoButton();
    map.setOptions({
      draggableCursor: "crosshair",
    });

    // Map-surface notification (instruction pill)
    updateInstruction(); // show/hide controls for IDLE state first
    const pill = document.getElementById("rtPill");
    if (pill) pill.classList.add("solar-calc-pill--oversized");
    document.getElementById("instruction").innerHTML =
      "<strong>Sorry, that area is too large.</strong> Please trace a smaller roof section - this tool is designed for estimating panels on individual houses.";

    // Sidebar warning box
    showWarning(
      "The traced area (" +
        Math.round(footprintArea).toLocaleString() +
        " m\u00b2) exceeds the maximum (" +
        MAX_ROOF_AREA_M2.toLocaleString() +
        " m\u00b2). Please trace a smaller roof section.",
    );

    clearResultStats();
    return;
  }

  // --- Step 2: stretch Y to recover true sloped dimensions --------------
  // Slope runs perpendicular to the gutter (i.e. along local Y).
  const sloped = local.map((p) => ({
    x: p.x,
    y: p.y / cosPitch,
  }));
  const slopedArea = polygonArea(sloped);

  // --- Step 3: inset by single margin using metric edge-shift ---------
  // Inset each edge of the sloped polygon inward by `margin` metres.
  // For each edge iâ†’j (CCW), the inward normal is the left-perpendicular
  // of the edge direction. Shift the edge line by margin*normal, then
  // intersect consecutive shifted lines to find new polygon vertices.
  // This is exact in metric space (no Turf, no anisotropy).

  // Ensure CCW winding for BOTH local and sloped (same reorder applied to
  // both so debug edge indices line up).
  const ccwReverse = needsReverseForCCW(sloped);
  const localCCW = ccwReverse ? local.slice().reverse() : local.slice();
  const slopedCCW = ccwReverse ? sloped.slice().reverse() : sloped.slice();

  let insetPoly;
  try {
    insetPoly = insetPolygon(slopedCCW, margin);
  } catch (err) {
    showWarning("Inset failed: " + err.message);
    return;
  }

  if (!insetPoly || insetPoly.length < 3) {
    showWarning("Roof too small for the chosen margin.");
    renderRoofResults(footprintArea, slopedArea, 0, 0, "\u2014", 0, 0, null);
    renderDebug(
      buildDebugInfo({
        clickPoints,
        origin,
        local: localCCW,
        sloped: slopedCCW,
        slopedCCW,
        insetPoly: [],
        pitchDeg,
        margin,
        panelW: panelWGrid,
        panelH: panelHGrid,
        baselineLen,
        yFlipped,
        footprintArea,
        slopedArea,
        usableArea: 0,
        chosen: {
          panels: [],
          cols: 0,
          rows: 0,
        },
        orientationLabel: "n/a",
        portrait: {
          panels: [],
        },
        landscape: {
          panels: [],
        },
      }),
    );
    return;
  }

  const rings_side = [insetPoly]; // single ring
  const usableArea = Math.abs(polygonArea(insetPoly));

  // --- Step 4: grid pack panels above the baseline ---------------------
  const allPts_side = insetPoly;
  const minX = Math.min(...allPts_side.map((p) => p.x));
  const maxX = Math.max(...allPts_side.map((p) => p.x));
  const minY = Math.max(0, Math.min(...allPts_side.map((p) => p.y)));
  const maxY = Math.max(...allPts_side.map((p) => p.y));

  const portrait = packGridSwept(rings_side, minX, maxX, minY, maxY, panelWGrid, panelHGrid, panelWBody, panelHBody);
  const landscape = packGridSwept(
    rings_side,
    minX,
    maxX,
    minY,
    maxY,
    panelHGrid,
    panelWGrid,
    panelHBody,
    panelWBody,
  );

  const orientationChoice = document.getElementById("orientation").value;
  let chosen, orientationLabel;
  if (orientationChoice === "portrait") {
    chosen = portrait;
    orientationLabel = "Portrait";
  } else if (orientationChoice === "landscape") {
    chosen = landscape;
    orientationLabel = "Landscape";
  } else if (portrait.panels.length >= landscape.panels.length) {
    chosen = portrait;
    orientationLabel = "Portrait (auto)";
  } else {
    chosen = landscape;
    orientationLabel = "Landscape (auto)";
  }

  // --- Step 5: project panels back to LatLng and draw ------------------
  chosen.panels.forEach((panel) => {
    const corners = panel.map((c) => {
      // un-stretch Y, un-flip if needed, then back to LatLng
      let y = c.y * cosPitch;
      if (yFlipped) y = -y;
      return fromLocal(c.x, y);
    });
    const rect = new google.maps.Polygon({
      paths: corners,
      map: map,
      strokeColor: "#0066cc",
      strokeWeight: 1,
      strokeOpacity: 0.9,
      fillColor: "#1e90ff",
      fillOpacity: 0.75,
      clickable: false,
      zIndex: 2,
    });
    panelRectangles.push(rect);
  });

  // --- Step 6: compute panel azimuth -----------------------------------
  // Azimuth = compass direction the roof faces (from ridge toward gutter, downhill).
  // Derived from the centroid â†’ gutter-midpoint vector in geographic space.
  const gutterMidLat = (clickPoints[0].lat() + clickPoints[1].lat()) / 2;
  const gutterMidLng = (clickPoints[0].lng() + clickPoints[1].lng()) / 2;
  const centLat =
    clickPoints.reduce((s, p) => s + p.lat(), 0) / clickPoints.length;
  const centLng =
    clickPoints.reduce((s, p) => s + p.lng(), 0) / clickPoints.length;
  const dLat = gutterMidLat - centLat;
  // Scale lng difference by cos(lat) so N/S and E/W distances are comparable
  const dLng = (gutterMidLng - centLng) * Math.cos((centLat * Math.PI) / 180);
  let azimuthDeg = (Math.atan2(dLng, dLat) * 180) / Math.PI;
  if (azimuthDeg < 0) azimuthDeg += 360;
  const CARDINALS = [
    "N",
    "NNE",
    "NE",
    "ENE",
    "E",
    "ESE",
    "SE",
    "SSE",
    "S",
    "SSW",
    "SW",
    "WSW",
    "W",
    "WNW",
    "NW",
    "NNW",
  ];
  const cardinalDir = CARDINALS[Math.round(azimuthDeg / 22.5) % 16];

  const panelWp =
    parseFloat(document.getElementById("panelWp").value) || DEFAULT_PANEL_WP;

  renderRoofResults(
    footprintArea,
    slopedArea,
    usableArea,
    chosen.panels.length,
    orientationLabel,
    chosen.cols,
    chosen.rows,
    azimuthDeg,
    cardinalDir,
  );

  // --- Step 7: commit / update section data (before geocode so id is set) ----
  commitOrUpdateSection({
    panelCount: chosen.panels.length,
    cols: chosen.cols,
    rows: chosen.rows,
    orientationLabel,
    azimuthDeg,
    cardinalDir,
    footprintArea,
    slopedArea,
    usableArea,
    pitchDeg,
    panelWp,
    county: null,
    annualKwh: null,
    annualCo2: null,
  });

  // --- Step 8: reverse geocode centroid for county + yield -------------
  const sectionIdAtCalcTime = editingSectionId; // captured after commit so id is valid
  geocoder.geocode(
    {
      location: {
        lat: centLat,
        lng: centLng,
      },
    },
    (results, status) => {
      let county = "Unknown";
      if (status === "OK" && results[0]) {
        const countyComp = results[0].address_components.find((c) =>
          c.types.includes("administrative_area_level_1"),
        );
        county = countyComp
          ? countyComp.long_name.replace(/^County\s+/i, "")
          : "Unknown";
      }
      // Persist county + computed yield into the section result
      const sec = sections.find((s) => s.id === sectionIdAtCalcTime);
      if (sec && sec.result) {
        sec.result.county = county;
        const yr = calcYield(
          sec.result.panelCount,
          sec.result.panelWp,
          sec.result.azimuthDeg,
          sec.result.pitchDeg,
          county,
        );
        sec.result.annualKwh = yr ? yr.annualKwh : null;
        sec.result.annualCo2 = yr ? yr.annualCo2 : null;
      }
      // Update DOM if this section is still the one being shown
      if (sectionIdAtCalcTime === editingSectionId) {
        document.getElementById("statCounty").innerText = county;
        renderYieldStats(
          sec && sec.result ? sec.result.annualKwh : null,
          sec && sec.result ? sec.result.annualCo2 : null,
        );
      }
      // Always refresh totals row (county/yield may have just become available)
      renderSectionsPanel();
    },
  );

  // --- Step 9: dump debug info -----------------------------------------
  renderDebug(
    buildDebugInfo({
      clickPoints,
      origin,
      local: localCCW,
      sloped: slopedCCW,
      slopedCCW,
      insetPoly,
      pitchDeg,
      margin,
      panelW: panelWGrid,
      panelH: panelHGrid,
      baselineLen,
      yFlipped,
      footprintArea,
      slopedArea,
      usableArea,
      chosen,
      orientationLabel,
      portrait,
      landscape,
      azimuthDeg,
      cardinalDir,
    }),
  );
}

// --- Helpers --------------------------------------------------------------

// Shoelace polygon area (absolute, square metres)
function polygonArea(pts) {
  let a = 0;
  for (let i = 0, n = pts.length; i < n; i++) {
    const p1 = pts[i],
      p2 = pts[(i + 1) % n];
    a += p1.x * p2.y - p2.x * p1.y;
  }
  return Math.abs(a) / 2;
}

function closeRing(pts) {
  const first = pts[0],
    last = pts[pts.length - 1];
  if (first.x !== last.x || first.y !== last.y) return [...pts, first];
  return pts;
}

// Convert metric XY (relative to origin lat) to a fake [lng, lat] for Turf
// We treat 1m as 1/mPerDeg degrees so Turf's meter-buffer math works correctly.
function metricToFakeLngLat(p, originLat) {
  const mPerDegLat = 111320;
  const mPerDegLng = 111320 * Math.cos((originLat * Math.PI) / 180);
  return [p.x / mPerDegLng, p.y / mPerDegLat];
}

function fakeLngLatToMetric(c, originLat) {
  const mPerDegLat = 111320;
  const mPerDegLng = 111320 * Math.cos((originLat * Math.PI) / 180);
  return {
    x: c[0] * mPerDegLng,
    y: c[1] * mPerDegLat,
  };
}

// Extract outer rings from a Turf Polygon or MultiPolygon feature
function extractRings(feature) {
  const g = feature.geometry;
  if (!g) return [];
  if (g.type === "Polygon") return [g.coordinates[0]];
  if (g.type === "MultiPolygon") return g.coordinates.map((poly) => poly[0]);
  return [];
}

// Test if a point lies inside ANY of the buffered rings (point-in-polygon)
function pointInRings(x, y, rings) {
  for (const ring of rings) {
    if (pointInPoly(x, y, ring)) return true;
  }
  return false;
}

function pointInPoly(x, y, poly) {
  let inside = false;
  for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
    const xi = poly[i].x,
      yi = poly[i].y;
    const xj = poly[j].x,
      yj = poly[j].y;
    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi + 1e-12) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}

// Grid-pack rectangles inside the inset polygon (rings = [ring]).
//   pwGrid × phGrid  — cell step including inter-panel gap (spacing only)
//   pwDraw × phDraw  — visible panel body without gap
// Panels sit flush at the top-left of each grid cell. The gap between them is
// purely visual (created by the grid stepping) — a panel body can fit right up
// against the inset margin; the gap does not need polygon clearance because it
// is empty space. The vertical gap is naturally foreshortened downstream by the
// cos(pitch) projection (same as panel height).
// Returns { panels: [...], cols, rows } where each panel is [4 corners {x,y}].
function packGrid(rings, minX, maxX, minY, maxY, pwGrid, phGrid, pwDraw, phDraw) {
  const panels = [];
  const attempts = []; // per-cell trace for debug
  const colsSet = new Set();
  const rowsSet = new Set();
  // Shrink the test points by EPS so we never sit exactly on a polygon
  // vertex/edge. Floating-point inset vertices can be off by ~1e-15;
  // 1e-9 m (1 nanometre) is far below any physical precision and well
  // above FP noise.
  const EPS = 1e-9;
  let rowIdx = 0;
  for (let y = minY; y + phGrid <= maxY + 1e-6; y += phGrid, rowIdx++) {
    let colIdx = 0;
    for (let x = minX; x + pwGrid <= maxX + 1e-6; x += pwGrid, colIdx++) {
      // Point-in-polygon test: the panel body only (gap is empty space and
      // does not need boundary clearance; the inset margin already handles
      // regulatory edge setback). This avoids wasting a full gap's worth of
      // space on the perimeter of the array.
      const test = [
        { x: x + EPS,           y: y + EPS },
        { x: x + pwDraw - EPS,  y: y + EPS },
        { x: x + pwDraw - EPS,  y: y + phDraw - EPS },
        { x: x + EPS,           y: y + phDraw - EPS },
      ];
      const centre = {
        x: x + pwDraw / 2,
        y: y + phDraw / 2,
      };
      const cornerIn = test.map((c) => pointInRings(c.x, c.y, rings));
      const centreIn = pointInRings(centre.x, centre.y, rings);
      const allIn = cornerIn.every(Boolean) && centreIn;
      attempts.push({
        rowIdx,
        colIdx,
        x,
        y,
        cornerIn,
        centreIn,
        allIn,
      });
      if (allIn) {
        // Drawn rectangle: true panel size, flush top-left in grid cell
        panels.push([
          { x: x,            y: y },
          { x: x + pwDraw,   y: y },
          { x: x + pwDraw,   y: y + phDraw },
          { x: x,            y: y + phDraw },
        ]);
        colsSet.add(colIdx);
        rowsSet.add(rowIdx);
      }
    }
  }
  return {
    panels,
    attempts,
    cols: colsSet.size,
    rows: rowsSet.size,
  };
}

// Grid-pack with a horizontal phase sweep.
// packGrid() pins the column grid to the polygon's leftmost vertex (minX) and
// then steps by whole panel widths, so any horizontal remainder is always dumped
// as dead space on one side. Here we slide the grid origin across one full panel
// width and keep whichever offset fits the most panels. Ties break toward the
// most horizontally-centred layout (nicer for the customer). Rows stay anchored
// at the gutter (minY is unchanged), so panels still start low at the baseline.
function packGridSwept(rings, minX, maxX, minY, maxY, pwGrid, phGrid, pwDraw, phDraw) {
  // If less than one column fits, there is no phase to search.
  if (maxX - minX < pwGrid) {
    return packGrid(rings, minX, maxX, minY, maxY, pwGrid, phGrid, pwDraw, phDraw);
  }
  const SWEEP_STEPS = 20; // resolution of the horizontal phase search
  const step = pwGrid / SWEEP_STEPS;
  const roofCentreX = (minX + maxX) / 2;
  let best = null;
  let bestCentreErr = Infinity;
  for (let i = 0; i < SWEEP_STEPS; i++) {
    // Shift the grid origin left by a fraction of a panel. Columns that fall
    // left of the polygon are rejected by the point-in-polygon test; the inner
    // loop fills rightward to maxX, so shifting can expose room for an extra
    // column on the right. Shifting left over one period covers every phase.
    const startX = minX - i * step;
    const result = packGrid(rings, startX, maxX, minY, maxY, pwGrid, phGrid, pwDraw, phDraw);
    if (result.panels.length === 0) continue;
    // Horizontal centre of the placed block (leftmost to rightmost corner).
    let lo = Infinity,
      hi = -Infinity;
    result.panels.forEach((panel) => {
      panel.forEach((c) => {
        if (c.x < lo) lo = c.x;
        if (c.x > hi) hi = c.x;
      });
    });
    const centreErr = Math.abs((lo + hi) / 2 - roofCentreX);
    if (
      !best ||
      result.panels.length > best.panels.length ||
      (result.panels.length === best.panels.length && centreErr < bestCentreErr)
    ) {
      best = result;
      bestCentreErr = centreErr;
    }
  }
  return best || packGrid(rings, minX, maxX, minY, maxY, pwGrid, phGrid, pwDraw, phDraw);
}

// Ensure polygon vertices are in CCW order (positive signed area)
function ensureCCW(pts) {
  return needsReverseForCCW(pts) ? pts.slice().reverse() : pts.slice();
}

// Returns true if the polygon needs to be reversed to become CCW (positive
// signed area in Y-up convention).
function needsReverseForCCW(pts) {
  let sum = 0;
  for (let i = 0, n = pts.length; i < n; i++) {
    const a = pts[i],
      b = pts[(i + 1) % n];
    sum += (b.x - a.x) * (b.y + a.y);
  }
  // In Y-up shoelace, sum > 0 => CW, so reverse needed.
  return sum > 0;
}

// Inset a CCW polygon inward by `d` metres by shifting each edge along its
// inward normal and intersecting consecutive shifted lines.
// Works correctly for convex polygons; acceptable approximation for slightly
// concave ones. Returns [] if inset collapses the polygon.
function insetPolygon(pts, d) {
  const n = pts.length;
  if (n < 3 || d <= 0) return pts.slice();

  // For each edge i â†’ i+1, compute shifted line (point + direction)
  const lines = [];
  for (let i = 0; i < n; i++) {
    const a = pts[i],
      b = pts[(i + 1) % n];
    const dx = b.x - a.x,
      dy = b.y - a.y;
    const len = Math.hypot(dx, dy);
    if (len < 1e-9) continue;
    // Unit direction
    const ux = dx / len,
      uy = dy / len;
    // Inward normal for CCW polygon = (-uy, ux) rotated... actually for
    // CCW with Y-up, inward normal is (-uy, ux) -- wait let me re-derive.
    // CCW means vertices go counter-clockwise. For an edge going "right",
    // the interior is "above". Edge direction (1,0), interior is (0,1).
    // Left-perpendicular of (ux,uy) is (-uy, ux). That points to interior
    // for CCW. âœ“
    const nx = -uy,
      ny = ux;
    // Shifted line passes through (a + d*n)
    lines.push({
      px: a.x + d * nx,
      py: a.y + d * ny,
      ux: ux,
      uy: uy,
    });
  }

  // Intersect consecutive lines to get new vertices
  const out = [];
  for (let i = 0; i < lines.length; i++) {
    const L1 = lines[(i - 1 + lines.length) % lines.length];
    const L2 = lines[i];
    const p = intersectLines(L1, L2);
    if (!p) return []; // parallel â†’ degenerate
    out.push(p);
  }

  // Validate: must still be a simple polygon with positive area in same orientation
  const signedArea = signedPolygonArea(out);
  if (signedArea <= 0) return []; // collapsed/inverted

  return out;
}

// Intersect two lines given as point + unit direction
function intersectLines(L1, L2) {
  // Line 1: (px,py) + t*(ux,uy)
  // Line 2: (px,py) + s*(ux,uy)
  // Solve: L1.px + t*L1.ux = L2.px + s*L2.ux
  //        L1.py + t*L1.uy = L2.py + s*L2.uy
  const denom = L1.ux * L2.uy - L1.uy * L2.ux;
  if (Math.abs(denom) < 1e-9) return null;
  const dx = L2.px - L1.px,
    dy = L2.py - L1.py;
  const t = (dx * L2.uy - dy * L2.ux) / denom;
  return {
    x: L1.px + t * L1.ux,
    y: L1.py + t * L1.uy,
  };
}

// Signed polygon area (positive for CCW with Y-up)
function signedPolygonArea(pts) {
  let a = 0;
  for (let i = 0, n = pts.length; i < n; i++) {
    const p1 = pts[i],
      p2 = pts[(i + 1) % n];
    a += p1.x * p2.y - p2.x * p1.y;
  }
  return a / 2;
}

// =========================================================================
// YIELD + CARBON CALCULATION
// =========================================================================
// All yield/CO₂ maths is delegated to the shared single-source-of-truth formulas
// in includes/scripts/solar-calculator-formulas.js (the same engine the site's
// solar calculators use). The azimuth/tilt yield grid, the county-vs-Dublin
// correction and the CO₂ factor all come from sitewide-variables.php globals
// (azimuthTiltData, countyKwhPerKwp, co2SavingPerkWh), so "how many units a panel
// at a given angle in a given county produces" is identical across every calculator.

function calcYield(panelCount, panelWp, azimuthDeg, pitchDeg, county) {
  if (!panelCount || !panelWp) return null;

  const arrayKwp = calculateArrayKwp(panelWp, panelCount);
  const countyEffectPercent = getCountyCorrectionVsDublin(county);

  // Pass null for the inverter so no domestic-inverter clipping is applied here â€”
  // the roof tool reports panel-level yield for arrays of any size, matching the
  // tool's previous (unclipped) behaviour.
  const annualKwh = calculateAnnualGeneration(
    arrayKwp,
    azimuthDeg,
    pitchDeg,
    countyEffectPercent,
    null,
  );
  if (annualKwh == null) return null;

  const annualCo2 = calculateAnnualCo2Saved(annualKwh, CO2_SAVING_PER_KWH);

  return {
    annualKwh,
    annualCo2,
    arrayKwp,
    countyEffectPercent,
  };
}

function renderYieldStats(annualKwh, annualCo2) {
  document.getElementById("statAnnualKwh").innerText =
    annualKwh != null
      ? Math.round(annualKwh).toLocaleString() + " kWh/yr"
      : "N/A (north-facing)";
  document.getElementById("statAnnualCo2").innerText =
    annualCo2 != null
      ? Math.round(annualCo2).toLocaleString() + " kg CO\u2082/yr"
      : "\u2014";
}

function renderRoofResults(
  footprint,
  sloped,
  usable,
  count,
  orientation,
  cols,
  rows,
  azimuthDeg,
  cardinalDir,
) {
  document.getElementById("statFootprint").innerText =
    footprint.toFixed(1) + " m\u00b2";
  document.getElementById("statSloped").innerText =
    sloped.toFixed(1) + " m\u00b2";
  document.getElementById("statUsable").innerText =
    usable.toFixed(1) + " m\u00b2";
  document.getElementById("statOrientation").innerText = orientation;
  document.getElementById("statGrid").innerText =
    (cols || 0) + " \u00d7 " + (rows || 0);
  document.getElementById("panelCount").innerText = count;
  if (azimuthDeg != null) {
    document.getElementById("statAzimuth").innerText =
      rtFormatAzimuthForDisplay(azimuthDeg);
  }
}

function showWarning(msg) {
  document.getElementById("warningBox").innerHTML =
    '<div class="warning">' + msg + "</div>";
}

// =========================================================================
// DEBUG OUTPUT
// =========================================================================
function renderDebug(text) {
  document.getElementById("debugPanel").textContent = text;
  var btn = document.getElementById("btnCopyDebug");
  if (btn) {
    var hasContent = text && text !== "(no calculation yet)";
    btn.style.display = hasContent ? "" : "none";
  }
}

function copyDebugToClipboard(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  var text = document.getElementById("debugPanel").textContent;
  if (!text || text === "(no calculation yet)") return;
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(text)
      .then(function () {
        setCopiedState(true);
      })
      .catch(function () {
        fallbackCopyDebug(text);
      });
  } else {
    fallbackCopyDebug(text);
  }
}

function fallbackCopyDebug(text) {
  var ta = document.createElement("textarea");
  ta.value = text;
  ta.style.position = "fixed";
  ta.style.left = "-9999px";
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand("copy");
  } catch (e) {}
  document.body.removeChild(ta);
  setCopiedState(true);
}

function setCopiedState(isCopied) {
  var btn = document.getElementById("btnCopyDebug");
  if (!btn) return;
  var copyText = btn.querySelector(".solar-calc-debug__copyText");
  var icon = btn.querySelector("i");
  if (isCopied) {
    btn.classList.add("is-copied");
    if (copyText) copyText.textContent = "Copied";
    if (icon) {
      icon.classList.remove("fa-copy");
      icon.classList.add("fa-check");
    }
    if (btn._copyResetTimer) clearTimeout(btn._copyResetTimer);
    btn._copyResetTimer = setTimeout(function () {
      setCopiedState(false);
    }, 2000);
  } else {
    btn.classList.remove("is-copied");
    if (copyText) copyText.textContent = "Copy";
    if (icon) {
      icon.classList.remove("fa-check");
      icon.classList.add("fa-copy");
    }
  }
}

function buildDebugInfo(d) {
  const lines = [];
  const f = (n, dp = 3) => (n == null ? "n/a" : Number(n).toFixed(dp));

  // --- All-sections summary (always shown when â‰¥1 section exists) ------
  if (sections.length > 0) {
    lines.push("=== ALL ROOF SECTIONS SUMMARY ===");
    let totalPanels = 0,
      totalFootprint = 0,
      totalSloped = 0,
      totalUsable = 0;
    sections.forEach((sec, idx) => {
      const r = sec.result || {};
      const panels = r.panelCount || 0;
      const footprint = r.footprintArea || 0;
      const sloped = r.slopedArea || 0;
      const usable = r.usableArea || 0;
      const marker = sec.id === editingSectionId ? " â—„ active" : "";
      lines.push("  [" + (idx + 1) + "] " + sec.label + marker);
      lines.push(
        "      Footprint: " +
          f(footprint, 2) +
          " mÂ²  |  Sloped: " +
          f(sloped, 2) +
          " mÂ²  |  Usable: " +
          f(usable, 2) +
          " mÂ²",
      );
      lines.push(
        "      Panels: " +
          panels +
          "  |  Pitch: " +
          f(sec.pitch, 1) +
          "Â°  |  Margin: " +
          f(sec.margin, 2) +
          " m  |  " +
          (r.orientationLabel || "â€”"),
      );
      if (r.azimuthDeg != null) {
        lines.push(
          "      Azimuth: " +
            f(r.azimuthDeg, 1) +
            "Â°" +
            (r.cardinalDir ? " (" + r.cardinalDir + ")" : "") +
            (r.county ? "  |  County: " + r.county : ""),
        );
      }
      if (r.annualKwh != null) {
        lines.push(
          "      Annual gen: " +
            Math.round(r.annualKwh).toLocaleString() +
            " kWh/yr  |  CO₂ saved: " +
            Math.round(r.annualCo2).toLocaleString() +
            " kg/yr",
        );
      }
      totalPanels += panels;
      totalFootprint += footprint;
      totalSloped += sloped;
      totalUsable += usable;
    });
    lines.push(
      "  â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€",
    );
    lines.push(
      "  TOTAL  Footprint: " +
        f(totalFootprint, 2) +
        " mÂ²  |  Sloped: " +
        f(totalSloped, 2) +
        " mÂ²  |  Usable: " +
        f(totalUsable, 2) +
        " mÂ²",
    );
    lines.push("  TOTAL  Panels: " + totalPanels);
    lines.push("");
  }

  lines.push("=== INPUTS ===");
  lines.push(
    "Pitch:            " +
      f(d.pitchDeg, 1) +
      "Â°  (cos=" +
      f(Math.cos((d.pitchDeg * Math.PI) / 180), 4) +
      ")",
  );
  lines.push(
    "Margin:           " + f(d.margin, 2) + " m  (uniform on all edges)",
  );
  lines.push(
    "Panel W Ã— H + gap: " + f(d.panelW, 3) + " Ã— " + f(d.panelH, 3) + " m",
  );
  lines.push(
    "Y-flipped:        " +
      (d.yFlipped ? "yes (drew CW / below baseline)" : "no"),
  );
  lines.push("");

  lines.push("=== CLICK POINTS (lat / lng) ===");
  d.clickPoints.forEach((p, i) => {
    lines.push(
      "  #" + (i + 1) + ": " + p.lat().toFixed(7) + ", " + p.lng().toFixed(7),
    );
  });
  lines.push("Origin (#1) lat:  " + d.origin.lat().toFixed(7));
  lines.push("");

  lines.push("=== LOCAL METRIC XY (origin=#1, X along baseline) ===");
  d.local.forEach((p, i) => {
    lines.push("  #" + (i + 1) + ": x=" + f(p.x) + " m, y=" + f(p.y) + " m");
  });
  lines.push("Baseline (#1â†’#2) length: " + f(d.baselineLen) + " m");
  lines.push("");

  lines.push("=== SLOPED POLYGON (Y stretched by 1/cos(pitch)) ===");
  d.sloped.forEach((p, i) => {
    lines.push("  #" + (i + 1) + ": x=" + f(p.x) + " m, y=" + f(p.y) + " m");
  });
  lines.push("");

  lines.push("=== EDGES (footprint vs sloped length) ===");
  const n = d.local.length;
  for (let i = 0; i < n; i++) {
    const a = d.local[i],
      b = d.local[(i + 1) % n];
    const fa = d.sloped[i],
      fb = d.sloped[(i + 1) % n];
    const footLen = Math.hypot(b.x - a.x, b.y - a.y);
    const slopedLen = Math.hypot(fb.x - fa.x, fb.y - fa.y);
    const dx = b.x - a.x,
      dy = b.y - a.y;
    const angleDeg = (Math.atan2(dy, dx) * 180) / Math.PI;
    let kind = "side";
    if (i === 0) kind = "GUTTER (baseline #1â†’#2)";
    else if (Math.abs(dy) < 0.05) kind = "horizontal (likely RIDGE)";
    lines.push(
      "  edge #" +
        (i + 1) +
        "â†’#" +
        (((i + 1) % n) + 1) +
        " : footprint=" +
        f(footLen) +
        " m" +
        ", sloped=" +
        f(slopedLen) +
        " m" +
        ", angle=" +
        f(angleDeg, 1) +
        "Â°" +
        " [" +
        kind +
        "]",
    );
  }
  lines.push("");

  lines.push(
    "=== INSET POLYGON (after edge-shift by " + f(d.margin, 2) + " m) ===",
  );
  if (d.insetPoly.length === 0) {
    lines.push("  (empty â€” inset collapsed the polygon)");
  } else {
    d.insetPoly.forEach((p, i) => {
      lines.push("  v" + (i + 1) + ": x=" + f(p.x) + " m, y=" + f(p.y) + " m");
    });
    const ixs = d.insetPoly.map((p) => p.x),
      iys = d.insetPoly.map((p) => p.y);
    lines.push(
      "  X range: " +
        f(Math.min(...ixs)) +
        " to " +
        f(Math.max(...ixs)) +
        "  (width " +
        f(Math.max(...ixs) - Math.min(...ixs)) +
        " m)",
    );
    lines.push(
      "  Y range: " +
        f(Math.min(...iys)) +
        " to " +
        f(Math.max(...iys)) +
        "  (height " +
        f(Math.max(...iys) - Math.min(...iys)) +
        " m)",
    );
  }
  lines.push("");

  lines.push("=== AREAS ===");
  lines.push("Footprint (top-down):     " + f(d.footprintArea, 2) + " mÂ²");
  lines.push("True sloped:              " + f(d.slopedArea, 2) + " mÂ²");
  lines.push("Usable (after inset):     " + f(d.usableArea, 2) + " mÂ²");
  lines.push(
    "Sloped/footprint ratio:   " +
      f(d.slopedArea / Math.max(d.footprintArea, 1e-9), 4) +
      "  (expected 1/cos(pitch) = " +
      f(1 / Math.cos((d.pitchDeg * Math.PI) / 180), 4) +
      ")",
  );
  lines.push("");

  lines.push("=== PACKING ===");
  lines.push(
    "Portrait  (pw=" +
      f(d.panelW) +
      " Ã— ph=" +
      f(d.panelH) +
      "): " +
      d.portrait.panels.length +
      " panels",
  );
  lines.push(
    "Landscape (pw=" +
      f(d.panelH) +
      " Ã— ph=" +
      f(d.panelW) +
      "): " +
      d.landscape.panels.length +
      " panels",
  );
  lines.push(
    "Chosen:                   " +
      d.orientationLabel +
      " â†’ " +
      d.chosen.panels.length +
      " panels" +
      " (" +
      d.chosen.cols +
      " cols Ã— " +
      d.chosen.rows +
      " rows)",
  );
  if (d.azimuthDeg != null) {
    lines.push(
      "Azimuth:                  " +
        f(d.azimuthDeg, 1) +
        "Â° (" +
        d.cardinalDir +
        ")",
    );
  }

  // Per-cell trace for the chosen orientation
  if (d.chosen && d.chosen.attempts) {
    lines.push("");
    lines.push(
      "=== CHOSEN PACKER ATTEMPTS (row, col): corners NW NE SE SW + centre ===",
    );
    lines.push("(legend: 1 = inside polygon, 0 = outside)");
    for (const a of d.chosen.attempts) {
      const c = a.cornerIn.map((b) => (b ? "1" : "0")).join("");
      const ce = a.centreIn ? "1" : "0";
      const tag = a.allIn ? "PLACED" : "reject";
      lines.push(
        "  r" +
          a.rowIdx +
          " c" +
          a.colIdx +
          "  x=" +
          f(a.x) +
          " y=" +
          f(a.y) +
          "  corners=" +
          c +
          " centre=" +
          ce +
          "  " +
          tag,
      );
    }
  }

  return lines.join("\n");
}

// =========================================================================
// FULL CALCULATION BREAKDOWN (comprehensive debug output for the
// Calculation breakdown accordion in the Breakdown pane).
// Called from runFinancials() with all intermediate values.
// =========================================================================
function buildFullCalculationBreakdown(fd) {
  var lines = [];
  var f2 = function (n) {
    return n == null ? "n/a" : Number(n).toFixed(2);
  };
  var f3 = function (n) {
    return n == null ? "n/a" : Number(n).toFixed(3);
  };
  var f4 = function (n) {
    return n == null ? "n/a" : Number(n).toFixed(4);
  };
  var fm = function (n) {
    return n == null ? "n/a" : Math.round(n).toLocaleString();
  };
  var fp = function (n) {
    return n == null ? "n/a" : "\u20ac" + Math.round(n).toLocaleString();
  };
  var fpct = function (n) {
    return n == null ? "n/a" : n.toFixed(1) + "%";
  };

  var sep = "\u2500".repeat(60);

  lines.push(sep);
  lines.push("  DOMESTIC SOLAR CALCULATOR — purevolt.ie");
  lines.push("  Designed for domestic solar installations in Ireland.");
  lines.push("  Not applicable to commercial or large-scale systems.");
  lines.push(sep);
  lines.push("");

  // --- 1. ROOF GEOMETRY (per section) ---
  lines.push(
    "\u2500\u2500\u2500 1. ROOF GEOMETRY (per section) \u2500\u2500\u2500",
  );
  lines.push("");
  if (fd.sections && fd.sections.length > 0) {
    fd.sections.forEach(function (sec, idx) {
      lines.push("  \u25aa " + sec.label);
      // Lat/long of traced points (only for geometry-traced sections)
      if (sec.clickPoints && sec.clickPoints.length > 0) {
        var pts = sec.clickPoints;
        for (var i = 0; i < pts.length; i++) {
          var lat =
            typeof pts[i].lat === "function" ? pts[i].lat() : pts[i].lat;
          var lng =
            typeof pts[i].lng === "function" ? pts[i].lng() : pts[i].lng;
          var gutter = i === 0 || i === 1 ? " (gutter)" : "        ";
          lines.push(
            "    Point " +
              (i + 1) +
              gutter +
              ": " +
              lat.toFixed(6) +
              ", " +
              lng.toFixed(6),
          );
        }
      }
      if (sec.result) {
        var r = sec.result;
        lines.push("    Panels:       " + (r.panelCount || 0));
        lines.push(
          "    Pitch:        " +
            f2(sec.pitch || fd.defaultPitch) +
            "\u00b0  (cos=" +
            f4(Math.cos(((sec.pitch || fd.defaultPitch) * Math.PI) / 180)) +
            ")",
        );
        lines.push(
          "    Margin:       " +
            f2(sec.margin != null ? sec.margin : fd.defaultMargin) +
            " m",
        );
        if (r.footprintArea != null) {
          lines.push("    Footprint:    " + f2(r.footprintArea) + " m\u00b2");
          lines.push("    Sloped:       " + f2(r.slopedArea) + " m\u00b2");
          lines.push("    Usable:       " + f2(r.usableArea) + " m\u00b2");
          lines.push(
            "    Sloped/print: " +
              f4(r.slopedArea / Math.max(r.footprintArea, 0.001)),
          );
        }
        lines.push("    Orientation:  " + (r.orientationLabel || "manual"));
        if (r.azimuthDeg != null) {
          lines.push(
            "    Azimuth:      " +
              f2(r.azimuthDeg) +
              "\u00b0" +
              (r.cardinalDir ? " (" + r.cardinalDir + ")" : ""),
          );
        }
        lines.push("    County:       " + (r.county || "(pending geocode)"));
        if (r.panelWp != null) {
          lines.push("    Panel Wp:     " + r.panelWp + " Wp");
        }
        lines.push(
          "    Grid:         " +
            (r.cols || 0) +
            " cols \u00d7 " +
            (r.rows || 0) +
            " rows",
        );
      }
      lines.push("");
    });
  } else {
    lines.push(
      "  (no roof sections \u2014 manual mode or no geometry traced yet)",
    );
    lines.push("");
  }

  // --- 2. PER-SECTION YIELD ---
  lines.push("\u2500\u2500\u2500 2. PER-SECTION YIELD \u2500\u2500\u2500");
  lines.push("");
  if (fd.sections && fd.sections.length > 0) {
    fd.sections.forEach(function (sec, idx) {
      var r = sec.result || {};
      var panelCount = r.panelCount || 0;
      var panelWp =
        (r.panelWp != null ? r.panelWp : sec.panelWp) || fd.defaultPanelWp;
      var azimuth = r.azimuthDeg;
      var pitch = sec.pitch || fd.defaultPitch;
      var county = r.county;

      lines.push("  \u25aa " + sec.label);
      lines.push("");
      lines.push("    2a. Array kWp");
      lines.push("        panelWp \u00d7 count \u00f7 1000");
      lines.push(
        "        = " + panelWp + " \u00d7 " + panelCount + " \u00f7 1000",
      );
      lines.push("        = " + f3((panelWp * panelCount) / 1000) + " kWp");
      lines.push("");

      var genPerKwp = null;
      if (azimuth != null) {
        var azNorm = ((azimuth % 360) + 360) % 360;
        var tilt = Math.max(0, Math.min(90, pitch));
        var AZ_STEP = 15,
          TILT_STEP = 5;
        var az0 = Math.floor(azNorm / AZ_STEP) * AZ_STEP;
        var az1 = (az0 + AZ_STEP) % 360;
        var t0 = Math.floor(tilt / TILT_STEP) * TILT_STEP;
        var t1 = Math.min(90, t0 + TILT_STEP);
        var ta = (azNorm - az0) / AZ_STEP;
        var tt = t0 === t1 ? 0 : (tilt - t0) / TILT_STEP;

        lines.push("    2b. PVGIS bilinear interpolation");
        lines.push(
          "        Source: PVGIS API v5.3, SARAH3 dataset, Dublin reference \u2014 includes 14% system losses",
        );
        lines.push(
          "        azimuth=" +
            f2(azNorm) +
            "\u00b0, tilt=" +
            f2(tilt) +
            "\u00b0",
        );
        lines.push(
          "        grid cell: az [" +
            az0 +
            "\u00b0, " +
            az1 +
            "\u00b0], tilt [" +
            t0 +
            "\u00b0, " +
            t1 +
            "\u00b0]",
        );
        lines.push(
          "        az weight = " + f3(ta) + ", tilt weight = " + f3(tt),
        );

        var idx = getAnnualGenerationPerKwp._index;
        var v00 = idx ? idx[az0 + "_" + t0] : null;
        var v10 = idx ? idx[az1 + "_" + t0] : null;
        var v01 = idx ? idx[az0 + "_" + t1] : null;
        var v11 = idx ? idx[az1 + "_" + t1] : null;

        if (v00 != null && v10 != null && v01 != null && v11 != null) {
          lines.push(
            "        v(" +
              az0 +
              "," +
              t0 +
              ")=" +
              f3(v00) +
              "  v(" +
              az1 +
              "," +
              t0 +
              ")=" +
              f3(v10),
          );
          lines.push(
            "        v(" +
              az0 +
              "," +
              t1 +
              ")=" +
              f3(v01) +
              "  v(" +
              az1 +
              "," +
              t1 +
              ")=" +
              f3(v11),
          );
          var row0 = v00 * (1 - ta) + v10 * ta;
          var row1 = v01 * (1 - ta) + v11 * ta;
          genPerKwp = row0 * (1 - tt) + row1 * tt;
          lines.push(
            "        row0 = " +
              f3(v00) +
              "\u00d7(1-" +
              f3(ta) +
              ") + " +
              f3(v10) +
              "\u00d7" +
              f3(ta) +
              " = " +
              f3(row0),
          );
          lines.push(
            "        row1 = " +
              f3(v01) +
              "\u00d7(1-" +
              f3(ta) +
              ") + " +
              f3(v11) +
              "\u00d7" +
              f3(ta) +
              " = " +
              f3(row1),
          );
          lines.push(
            "        genPerKwp = " +
              f3(row0) +
              "\u00d7(1-" +
              f3(tt) +
              ") + " +
              f3(row1) +
              "\u00d7" +
              f3(tt) +
              " = " +
              f3(genPerKwp) +
              " kWh/kWp",
          );
        } else {
          genPerKwp = getAnnualGenerationPerKwp(azNorm, tilt);
          lines.push(
            "        genPerKwp = " +
              (genPerKwp != null ? f3(genPerKwp) : "null (out of bounds)") +
              " kWh/kWp",
          );
        }
      } else {
        lines.push("    2b. PVGIS interpolation skipped (no azimuth yet)");
      }
      lines.push("");

      var countyEffect = 0;
      if (county && county !== "Unknown") {
        countyEffect = getCountyCorrectionVsDublin(county);
        lines.push("    2c. County correction vs Dublin");
        lines.push(
          "        Source: PVGIS per-county irradiance (same dataset as \u00a72b)",
        );
        lines.push("        county = " + county);
        var dublinVal =
          typeof countyKwhPerKwp !== "undefined" && countyKwhPerKwp["Dublin"]
            ? countyKwhPerKwp["Dublin"]
            : "?";
        var countyVal =
          typeof countyKwhPerKwp !== "undefined" &&
          countyKwhPerKwp[county] != null
            ? countyKwhPerKwp[county]
            : "?";
        lines.push("        Dublin baseline = " + dublinVal + " kWh/kWp");
        lines.push("        " + county + " = " + countyVal + " kWh/kWp");
        lines.push(
          "        correction = (" +
            county +
            " \u2212 Dublin) \u00f7 Dublin \u00d7 100",
        );
        lines.push("        = " + fpct(countyEffect) + " vs Dublin");
      } else {
        lines.push("    2c. County correction: N/A (county unknown)");
      }
      lines.push("");

      var arrayKwp = (panelWp * panelCount) / 1000;
      var clippingLoss = calculateInverterClippingLossPercent(
        arrayKwp,
        defaultInverterKwAC,
      );
      lines.push(
        "    2d. Inverter clipping (domestic " +
          f2(defaultInverterKwAC) +
          " kW AC)",
      );
      lines.push(
        "        ILR = arrayKwp \u00f7 inverterKwAC = " +
          f3(arrayKwp) +
          " \u00f7 " +
          f2(defaultInverterKwAC) +
          " = " +
          f3(arrayKwp / defaultInverterKwAC),
      );
      lines.push("        clipping loss = " + fpct(clippingLoss));
      lines.push("");

      var annualKwh = null;
      if (genPerKwp != null) {
        annualKwh =
          arrayKwp *
          genPerKwp *
          (1 + countyEffect / 100) *
          (1 - clippingLoss / 100);
        lines.push("    2e. Annual generation");
        lines.push(
          "        = arrayKwp \u00d7 genPerKwp \u00d7 (1 + county%) \u00d7 (1 \u2212 clipping%)",
        );
        lines.push(
          "        = " +
            f3(arrayKwp) +
            " \u00d7 " +
            f3(genPerKwp) +
            " \u00d7 " +
            f4(1 + countyEffect / 100) +
            " \u00d7 " +
            f4(1 - clippingLoss / 100),
        );
        lines.push("        = " + fm(annualKwh) + " kWh/yr");
      } else {
        lines.push("    2e. Annual generation: skipped (no PVGIS data)");
      }
      lines.push("");

      if (annualKwh != null) {
        var annualCo2 = annualKwh * CO2_SAVING_PER_KWH;
        lines.push("    2f. CO\u2082 saved");
        lines.push(
          "        = " +
            fm(annualKwh) +
            " \u00d7 " +
            f4(CO2_SAVING_PER_KWH) +
            " kg/kWh",
        );
        lines.push("        = " + fm(annualCo2) + " kg/yr");
      } else {
        lines.push("    2f. CO\u2082 saved: skipped (no generation data)");
      }
      lines.push("");
    });
  } else {
    lines.push("  (no roof sections)");
    lines.push("");
  }

  // --- 3. SYSTEM TOTALS ---
  lines.push("\u2500\u2500\u2500 3. SYSTEM TOTALS \u2500\u2500\u2500");
  lines.push("");
  lines.push("  3a. Total panels:    " + fd.totalPanels);
  lines.push("      Total kWp:       " + f3(fd.totalKwp) + " kWp");
  lines.push("  3b. Total annual generation: " + fm(fd.totalKwh) + " kWh/yr");
  lines.push(
    "      Total CO\u2082 saved:        " + fm(fd.totalCo2) + " kg/yr",
  );
  lines.push(
    "  3c. Generation-weighted mean azimuth: " +
      f2(fd.weightedAzimuth) +
      "\u00b0",
  );
  lines.push("");

  // --- 4. SELF-CONSUMPTION (MCS MGD-003) ---
  lines.push(
    "\u2500\u2500\u2500 4. SELF-CONSUMPTION (MCS MGD-003) \u2500\u2500\u2500",
  );
  lines.push("");
  if (fd.totalKwh > 0) {
    var genForLookup = Math.min(fd.totalKwh, 9500);
    var battForLookup = Math.max(0, Math.min(15, fd.batteryKwh));
    var demForLookup = Math.max(1500, Math.min(8000, fd.annualUsage));

    var di = mcsSelfConsumptionFractionalIndex(
      demForLookup,
      mcsSelfConsumptionLookupDemandBands,
      true,
    );
    var gi = mcsSelfConsumptionFractionalIndex(
      genForLookup,
      mcsSelfConsumptionLookupPvRows,
      true,
    );
    var bi = mcsSelfConsumptionFractionalIndex(
      battForLookup,
      mcsSelfConsumptionLookupBatteryCols,
      false,
    );

    lines.push("  4a. MCS trilinear interpolation");
    lines.push(
      "      Source: MCS MGD-003 Issue 2.0, in_half_day occupancy archetype",
    );
    lines.push(
      "      demand=" +
        fm(demForLookup) +
        " kWh, generation=" +
        fm(genForLookup) +
        " kWh, battery=" +
        f2(battForLookup) +
        " kWh",
    );
    lines.push(
      "      demand idx=" +
        di[0] +
        " (w=" +
        f3(di[1]) +
        "), gen idx=" +
        gi[0] +
        " (w=" +
        f3(gi[1]) +
        "), battery idx=" +
        bi[0] +
        " (w=" +
        f3(bi[1]) +
        ")",
    );

    var dIdx = di[0],
      dW = di[1];
    var gIdx = gi[0],
      gW = gi[1];
    var bIdx = bi[0],
      bW = bi[1];
    var dNext = Math.min(
      dIdx + 1,
      mcsSelfConsumptionLookupDemandBands.length - 1,
    );
    var gNext = Math.min(gIdx + 1, mcsSelfConsumptionLookupPvRows.length - 1);
    var bNext = Math.min(
      bIdx + 1,
      mcsSelfConsumptionLookupBatteryCols.length - 1,
    );
    var tbl = mcsSelfConsumptionLookup["in_half_day"];
    var dLow = mcsSelfConsumptionLookupDemandBands[dIdx];
    var dHigh = mcsSelfConsumptionLookupDemandBands[dNext];

    if (tbl && tbl[dLow] && tbl[dHigh]) {
      var c000 = tbl[dLow][gIdx][bIdx],
        c001 = tbl[dLow][gIdx][bNext];
      var c010 = tbl[dLow][gNext][bIdx],
        c011 = tbl[dLow][gNext][bNext];
      var c100 = tbl[dHigh][gIdx][bIdx],
        c101 = tbl[dHigh][gIdx][bNext];
      var c110 = tbl[dHigh][gNext][bIdx],
        c111 = tbl[dHigh][gNext][bNext];

      lines.push(
        "      demand band: " +
          dLow +
          "\u2013" +
          dHigh +
          " kWh, gen band: " +
          mcsSelfConsumptionLookupPvRows[gIdx] +
          "\u2013" +
          mcsSelfConsumptionLookupPvRows[gNext] +
          " kWh, batt band: " +
          mcsSelfConsumptionLookupBatteryCols[bIdx] +
          "\u2013" +
          mcsSelfConsumptionLookupBatteryCols[bNext] +
          " kWh",
      );
      lines.push(
        "      c000=" +
          fpct(c000) +
          "  c001=" +
          fpct(c001) +
          "  c010=" +
          fpct(c010) +
          "  c011=" +
          fpct(c011),
      );
      lines.push(
        "      c100=" +
          fpct(c100) +
          "  c101=" +
          fpct(c101) +
          "  c110=" +
          fpct(c110) +
          "  c111=" +
          fpct(c111),
      );
    }

    var rawScPct = calculateMcsSelfConsumptionPercent(
      genForLookup,
      demForLookup,
      battForLookup,
    );
    lines.push("      trilinear blend \u2192 raw SC = " + fpct(rawScPct));
    lines.push("");

    lines.push("  4b. Seasonal minimum import floor");
    lines.push(
      "      Source: PVGIS monthly generation shapes (same dataset as \u00a72b)",
    );
    var nearAz = fd.weightedAzimuth;
    var shape = nearestAzimuthMonthlyShape(nearAz);
    if (shape && shape.length) {
      var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      var annualPerKwp = 0;
      for (var mi = 0; mi < shape.length; mi++) {
        annualPerKwp += shape[mi].dailyOutputPerKwp * daysInMonth[mi];
      }
      var totalDays = 365;
      var dailyDemand = fd.annualUsage / totalDays;
      lines.push("      nearest azimuth shape: " + f2(nearAz) + "\u00b0 bin");
      lines.push(
        "      daily demand = " +
          fm(fd.annualUsage) +
          " \u00f7 " +
          totalDays +
          " = " +
          f3(dailyDemand) +
          " kWh/day",
      );
      lines.push(
        "      annual per-kWp from shape = " + f3(annualPerKwp) + " kWh",
      );
      lines.push("");
      lines.push(
        "      Month  Days  dailyOut/kWp  dailyGen   demand    residual",
      );

      var totalMinImport = 0;
      var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      for (var mi = 0; mi < shape.length; mi++) {
        var dailyGen =
          (fd.totalKwh * shape[mi].dailyOutputPerKwp) / annualPerKwp;
        var residual = Math.max(0, dailyDemand - dailyGen) * daysInMonth[mi];
        totalMinImport += residual;
        var summerFlag = residual === 0 && dailyGen > dailyDemand ? " *" : "";
        lines.push(
          "      " +
            monthNames[mi] +
            "     " +
            String(daysInMonth[mi]).padStart(3) +
            "  " +
            String(shape[mi].dailyOutputPerKwp.toFixed(2)).padStart(7) +
            "       " +
            String(f3(dailyGen)).padStart(7) +
            "  " +
            String(f3(dailyDemand)).padStart(7) +
            "  " +
            String(fm(residual)).padStart(8) +
            summerFlag,
        );
      }
      lines.push(
        "                                              \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500",
      );
      lines.push(
        "      TOTAL seasonal minimum import = " +
          fm(totalMinImport) +
          " kWh/yr",
      );
      lines.push(
        "      (* summer months: generation > demand \u2192 zero residual import)",
      );
    } else {
      lines.push("      (no monthly shape available)");
    }
    lines.push("");

    lines.push("  4c. Bounded self-consumed solar");
    var mcsSelfConsumed = (rawScPct / 100) * genForLookup;
    var seasonalMinImport = calculateSeasonalMinimumGridImportKwh(
      fd.totalKwh,
      fd.annualUsage,
      nearAz,
    );
    var maxSelfConsumable = Math.max(0, fd.annualUsage - seasonalMinImport);
    lines.push(
      "      MCS self-consumed = " +
        fpct(rawScPct) +
        " \u00d7 " +
        fm(genForLookup) +
        " = " +
        fm(mcsSelfConsumed) +
        " kWh",
    );
    lines.push(
      "      max self-consumable = " +
        fm(fd.annualUsage) +
        " demand \u2212 " +
        fm(seasonalMinImport) +
        " minImport = " +
        fm(maxSelfConsumable) +
        " kWh",
    );
    lines.push(
      "      \u2192 self-consumed = min(" +
        fm(mcsSelfConsumed) +
        ", " +
        fm(maxSelfConsumable) +
        ")",
    );
    lines.push(
      "      = " +
        fm(fd.kwhUsedNoBattery) +
        " kWh/yr  (" +
        fpct(fd.baselineSC) +
        ")",
    );
    if (fd.batteryKwh > 0) {
      lines.push(
        "      with " +
          f2(fd.batteryKwh) +
          " kWh battery: " +
          fm(fd.kwhUsedWithBattery) +
          " kWh/yr  (" +
          fpct(fd.effectiveSC) +
          ")",
      );
    }
    lines.push("");
  } else {
    lines.push("  (no generation data yet)");
    lines.push("");
  }

  // --- 5. BATTERY ECONOMICS ---
  lines.push("\u2500\u2500\u2500 5. BATTERY ECONOMICS \u2500\u2500\u2500");
  lines.push("");
  if (fd.batteryKwh > 0 && fd.totalKwh > 0) {
    lines.push("  5a. Solar uplift from battery");
    lines.push(
      "      SC with 0 kWh battery = " + fm(fd.kwhUsedNoBattery) + " kWh",
    );
    lines.push(
      "      SC with " +
        f2(fd.batteryKwh) +
        " kWh battery = " +
        fm(fd.kwhUsedWithBattery) +
        " kWh",
    );
    lines.push("      \u2192 uplift = " + fm(fd.upliftKwh) + " kWh/yr");
    lines.push("");

    lines.push("  5b. Night arbitrage \u2014 monthly allocation");
    var rteFraction = batteryRoundTripEfficiencyPercent / 100;
    var storedPerCycle = (fd.batteryKwh * batteryDepthOfDischargePercent) / 100;
    var deliveredPerCycle = storedPerCycle * rteFraction;
    var nightDeliveredKwh = deliveredPerCycle * batteryNightChargesPerYearFull;
    lines.push(
      "      battery " +
        f2(fd.batteryKwh) +
        " kWh \u00d7 " +
        batteryDepthOfDischargePercent +
        "% DoD \u00d7 " +
        batteryRoundTripEfficiencyPercent +
        "% RTE",
    );
    lines.push(
      "      = " +
        f3(storedPerCycle) +
        " kWh stored/cycle, " +
        f3(deliveredPerCycle) +
        " kWh delivered/cycle",
    );
    lines.push(
      "      \u00d7 " +
        batteryNightChargesPerYearFull +
        " night cycles/yr = " +
        fm(nightDeliveredKwh) +
        " kWh delivered/yr",
    );
    // Explain the two-bucket model before the table so AI tools (and humans)
    // reading this breakdown understand that Bucket B is about export revenue,
    // not household consumption. See §5 in the methodology for full details.
    lines.push(
      "      Night-charged energy goes into one of two 'buckets' each month:",
    );
    lines.push(
      "        Bucket A = displaces day-rate grid import (avoided cost, high value)",
    );
    lines.push(
      "        Bucket B = battery full → solar overflows to grid export (export revenue, lower value)",
    );
    lines.push(
      "      Both are profitable as long as night rate < export rate.",
    );
    lines.push("");

    var monthly = calculateMonthlyResidualImportKwh(
      fd.totalKwh,
      fd.annualUsage,
      fd.weightedAzimuth,
    );
    if (monthly && monthly.length) {
      lines.push(
        "      Monthly allocation (" +
          fm(nightDeliveredKwh) +
          " \u00f7 " +
          monthly[0].totalDays +
          " \u00d7 daysInMonth):",
      );
      lines.push(
        "      Month  Days  Night kWh  Residual   A:Displace  B:Overflow",
      );
      var totalA = 0,
        totalBstored = 0,
        totalBdelivered = 0;
      var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      for (var mi = 0; mi < monthly.length; mi++) {
        var monthNightDelivered =
          (nightDeliveredKwh * monthly[mi].days) / monthly[mi].totalDays;
        var bucketA = Math.min(monthNightDelivered, monthly[mi].residual);
        var bucketBDelivered = Math.max(0, monthNightDelivered - bucketA);
        totalA += bucketA;
        totalBdelivered += bucketBDelivered;
        lines.push(
          "      " +
            monthNames[mi] +
            "     " +
            String(monthly[mi].days).padStart(3) +
            "  " +
            String(fm(monthNightDelivered)).padStart(8) +
            "  " +
            String(fm(monthly[mi].residual)).padStart(8) +
            "  " +
            String(fm(bucketA)).padStart(9) +
            "  " +
            String(fm(bucketBDelivered)).padStart(9),
        );
      }

      var selfConsumedKwh = fd.kwhUsedWithBattery;
      var exportedSolarKwh = Math.max(0, fd.totalKwh - selfConsumedKwh);
      totalBstored = Math.min(
        rteFraction > 0 ? totalBdelivered / rteFraction : 0,
        exportedSolarKwh,
      );
      lines.push(
        "                                           \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500  \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500",
      );
      lines.push(
        "      TOTALS                                " +
          String(fm(totalA)).padStart(9) +
          "  " +
          String(fm(totalBdelivered)).padStart(9),
      );
      lines.push("");
      lines.push(
        "      ─── Bucket A: displaces day-rate grid import ───",
      );
      lines.push(
        "      " + fm(totalA) + " kWh of night-charged energy avoids buying expensive daytime electricity",
      );
      lines.push(
        "      ─── Bucket B: solar displaced to grid export ───",
      );
      lines.push(
        "      " +
          fm(totalBdelivered) +
          " kWh delivered (" +
          fm(totalBstored) +
          " kWh stored in battery)",
      );
      lines.push(
        "      Battery already full from night charging when solar starts",
      );
      lines.push(
        "      → solar that would have charged the battery overflows to grid instead",
      );
      lines.push(
        "      Bounded by solar actually exported: " +
          fm(exportedSolarKwh) +
          " kWh available",
      );
      lines.push("");
      lines.push(
        "      Bucket A benefit (avoided day-rate consumption):",
      );
      lines.push(
        "        " +
          fm(totalA) +
          " kWh × (" +
          f2(fd.daytimeRate) +
          "c day − " +
          f2(fd.nightRate) +
          "c night ÷ " +
          f3(rteFraction) +
          " RTE) ÷ 100",
      );
      var benefitA = Math.max(
        0,
        fd.daytimeRate -
          (rteFraction > 0 ? fd.nightRate / rteFraction : Infinity),
      );
      lines.push(
        "        = " +
          fm(totalA) +
          " × " +
          f2(benefitA) +
          "c ÷ 100 = " +
          fp((totalA * benefitA) / 100),
      );
      lines.push(
        "      Bucket B benefit (export revenue minus night charging cost):",
      );
      lines.push(
        "        " +
          fm(totalBstored) +
          " kWh stored × (" +
          f2(fd.feedinRate) +
          "c export − " +
          f2(fd.nightRate) +
          "c night) ÷ 100",
      );
      lines.push(
        "        You bought night energy at " +
          f2(fd.nightRate) +
          "c → solar overflows → sold at " +
          f2(fd.feedinRate) +
          "c → " +
          f2(Math.max(0, fd.feedinRate - fd.nightRate)) +
          "c/kWh spread",
      );
      var benefitB = Math.max(0, fd.feedinRate - fd.nightRate);
      lines.push(
        "        = " +
          fm(totalBstored) +
          " × " +
          f2(benefitB) +
          "c ÷ 100 = " +
          fp((totalBstored * benefitB) / 100),
      );
      lines.push(
        "      \u2192 Total night arbitrage = " +
          fp(fd.batteryNightSavings) +
          "/yr",
      );
    } else {
      lines.push(
        "      (no monthly shape available \u2014 using annual fallback)",
      );
      lines.push(
        "      \u2192 Total night arbitrage = " +
          fp(fd.batteryNightSavings) +
          "/yr",
      );
    }
    lines.push("");
  } else if (fd.batteryKwh > 0 && fd.totalKwh === 0) {
    lines.push("  (no generation data yet \u2014 battery economics pending)");
    lines.push("");
  } else {
    lines.push("  (no battery selected)");
    lines.push("");
  }

  // --- 6. FINANCIAL SAVINGS ---
  lines.push("\u2500\u2500\u2500 6. FINANCIAL SAVINGS \u2500\u2500\u2500");
  lines.push("");
  lines.push("  Electricity rates:");
  lines.push("    Day rate:    " + f2(fd.daytimeRate) + " c/kWh");
  lines.push("    Night rate:  " + f2(fd.nightRate) + " c/kWh");
  lines.push("    Feed-in:     " + f2(fd.feedinRate) + " c/kWh");
  lines.push("    Annual usage:" + fm(fd.annualUsage) + " kWh");
  lines.push("");

  if (fd.totalKwh > 0) {
    lines.push("  6a. Direct solar use");
    lines.push("      = kwhUsedNoBattery \u00d7 dayRate \u00f7 100");
    lines.push(
      "      = " +
        fm(fd.kwhUsedNoBattery) +
        " \u00d7 " +
        f2(fd.daytimeRate) +
        " \u00f7 100",
    );
    lines.push("      = " + fp(fd.solarImportSavings));
    lines.push("");

    if (fd.batteryKwh > 0) {
      lines.push("  6b. Battery solar storage");
      lines.push("      = upliftKwh \u00d7 dayRate \u00f7 100");
      lines.push(
        "      = " +
          fm(fd.upliftKwh) +
          " \u00d7 " +
          f2(fd.daytimeRate) +
          " \u00f7 100",
      );
      lines.push("      = " + fp(fd.batterySolarSavings));
      lines.push("");

      lines.push("  6c. Battery night charging");
      lines.push("      (see \u00a75b for monthly breakdown)");
      lines.push("      = " + fp(fd.batteryNightSavings));
      lines.push("");
    }

    lines.push("  6d. Export income");
    lines.push("      = kwhExportedReal \u00d7 feedinRate \u00f7 100");
    lines.push(
      "      = " +
        fm(fd.kwhExportedReal) +
        " \u00d7 " +
        f2(fd.feedinRate) +
        " \u00f7 100",
    );
    lines.push("      = " + fp(fd.solarExportIncome));
    lines.push("");

    lines.push("  6e. TOTAL annual savings");
    lines.push(
      "      = " +
        fp(fd.solarImportSavings) +
        " + " +
        fp(fd.batterySolarSavings) +
        " + " +
        fp(fd.batteryNightSavings) +
        " + " +
        fp(fd.solarExportIncome),
    );
    lines.push("      = " + fp(fd.totalSavings));
    lines.push("");

    if (fd.batteryKwh > 0) {
      lines.push("  6f. Battery net effect");
      lines.push(
        "      = uplift \u00d7 (dayRate \u2212 feedinRate) \u00f7 100 + nightSavings",
      );
      lines.push(
        "      = " +
          fm(fd.upliftKwh) +
          " \u00d7 " +
          f2(Math.max(0, fd.daytimeRate - fd.feedinRate)) +
          " \u00f7 100 + " +
          fp(fd.batteryNightSavings),
      );
      lines.push("      = " + fp(fd.batteryNetEffect) + "/yr");
      lines.push(
        "      (less than solar+night battery lines because storing solar",
      );
      lines.push(
        "       reduces export income; night saving is pure extra on top)",
      );
      lines.push("");
    }
  } else {
    lines.push("  (no generation data yet)");
    lines.push("");
  }

  // --- 7. PRICE ---
  lines.push("\u2500\u2500\u2500 7. PRICE \u2500\u2500\u2500");
  lines.push("");
  lines.push("  7a. SEAI grant");
  if (fd.grantApplying) {
    lines.push("      grant applying: yes");
    lines.push("      system size: " + f3(fd.totalKwp) + " kWp");
    lines.push("      tiered calculation (2026 rates):");
    lines.push(
      "        first 2 kWp \u00d7 \u20ac" +
        domesticGrantTiers.rate0to2 +
        "/kWp = \u20ac" +
        fm(Math.min(fd.totalKwp, 2) * domesticGrantTiers.rate0to2),
    );
    if (fd.totalKwp > 2) {
      lines.push(
        "        next " +
          f3(Math.min(fd.totalKwp - 2, 2)) +
          " kWp \u00d7 \u20ac" +
          domesticGrantTiers.rate2to4 +
          "/kWp = \u20ac" +
          fm(
            Math.min(Math.max(fd.totalKwp - 2, 0), 2) *
              domesticGrantTiers.rate2to4,
          ),
      );
    }
    if (fd.totalKwp > 4) {
      lines.push(
        "        capped at max grant: \u20ac" + fm(domesticGrantTiers.maxGrant),
      );
    }
    lines.push("      \u2192 grant = " + fp(fd.grantValue));
  } else {
    lines.push("      grant applying: no \u2192 \u20ac0");
  }
  lines.push("");

  lines.push("  7b. Solar installation (price table)");
  lines.push("      Source: /includes/data/product-package-prices.json");
  if (fd.solarInstallPrice != null) {
    lines.push(
      "      panel count: " +
        fd.totalPanels +
        " \u2192 " +
        fp(fd.solarInstallPrice),
    );
  } else {
    lines.push(
      "      " +
        (rtPriceData
          ? "outside guide range (8\u201322 panels)"
          : "price data not yet loaded"),
    );
  }
  lines.push("");

  if (fd.batteryKwh > 0) {
    lines.push("  7c. Battery add-on");
    lines.push(
      "      " + f2(fd.batteryKwh) + " kWh \u2192 " + fp(fd.batteryUplift || 0),
    );
    lines.push("");
  } else {
    lines.push("  7c. Battery add-on: N/A (no battery)");
    lines.push("");
  }

  lines.push("  7d. NET PRICE");
  if (fd.solarInstallPrice != null) {
    var gp =
      fd.grossPrice != null
        ? fd.grossPrice
        : fd.solarInstallPrice + (fd.batteryUplift || 0);
    var np = fd.netPrice != null ? fd.netPrice : gp - (fd.grantValue || 0);
    lines.push("      solar install:  " + fp(fd.solarInstallPrice));
    if (fd.batteryKwh > 0) {
      lines.push("      battery add-on: " + fp(fd.batteryUplift || 0));
    }
    lines.push("      gross price:    " + fp(gp));
    if (fd.grantApplying && fd.grantValue > 0) {
      lines.push("      less grant:    \u2212" + fp(fd.grantValue));
    }
    lines.push(
      "      \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500",
    );
    lines.push(
      "      NET PRICE:      " +
        fp(np) +
        (fd.showGrant ? " (after grant)" : ""),
    );
  } else {
    lines.push("      (price data unavailable for this panel count)");
  }
  lines.push("");

  lines.push(sep);
  lines.push("  © purevolt.ie — Domestic Solar Calculator");
  lines.push("  https://www.purevolt.ie");
  lines.push(sep);

  return lines.join("\n");
}

// =========================================================================
// FINANCIALS — sections 5-8 (battery, grant, savings, prices)
// =========================================================================

var rtPriceData = null;

function rtFetchPriceData() {
  fetch("/includes/data/product-package-prices.json")
    .then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    })
    .then(function (packages) {
      var primary = {};
      var addon = null;
      packages.forEach(function (pkg) {
        if (pkg.typeName === "PrimarySystem") {
          var n = pkg.panelsNo;
          if (!primary[n]) primary[n] = {};
          if (!pkg.batteryKw) {
            primary[n].withoutBattery = pkg.currentPriceDomesticIncVat;
          } else {
            primary[n].withFirstBattery = pkg.currentPriceDomesticIncVat;
            primary[n].firstBatteryKwh = pkg.batteryKw;
          }
        } else if (
          pkg.productPackageId === defaultAddonBatteryProductPackageId
        ) {
          addon = {
            kWh: pkg.batteryKw,
            price: pkg.currentPriceDomesticIncVat,
          };
        }
      });
      rtPriceData = {
        primarySystems: primary,
        addonBattery: addon,
      };
      runFinancials();
    })
    .catch(function (err) {
      console.warn("Roof tool: price fetch failed", err);
    });
}

function rtSetBattery(kwh) {
  document
    .querySelectorAll("#solar-calc-section-battery .solar-calc-opt-btn")
    .forEach(function (b) {
      b.classList.toggle(
        "solar-calc-opt-selected",
        parseFloat(b.dataset.batteryKwh) === kwh,
      );
    });
  document.getElementById("solar-calc-batteryKwh").value = kwh;
  // Update summary span
  const summarySpan = document.getElementById("summaryBatteryValue");
  if (summarySpan) {
    summarySpan.textContent = kwh === 0 ? "None" : kwh + " kWh";
  }
  runFinancials();
}

function rtSetGrant(applying) {
  document
    .querySelectorAll("#solar-calc-section-grant .solar-calc-opt-btn")
    .forEach(function (b) {
      b.classList.toggle(
        "solar-calc-opt-selected",
        b.dataset.grantApplying === applying,
      );
    });
  document.getElementById("solar-calc-grantApplying").value = applying;
  const note = document.getElementById("solar-calc-grantEligibilityNote");
  if (note) note.style.display = applying === "yes" ? "" : "none";
  // Update summary span â€” will show actual grant amount once calculated
  const summarySpan = document.getElementById("summaryGrantValue");
  if (summarySpan) {
    summarySpan.textContent =
      applying === "yes" ? "Calculating..." : "Not applied";
  }
  runFinancials();
}

function runFinancials() {
  if (sections.length === 0) {
    // Reset all financial displays when no sections exist
    document.getElementById("solar-calc-domesticGrant").textContent = "\u2014";
    document.getElementById("solar-calc-annualSolarImportSavings").textContent =
      "\u2014";
    document.getElementById("solar-calc-annualSolarExportIncome").textContent =
      "\u2014";
    document.getElementById(
      "solar-calc-annualBatterySolarSavings",
    ).textContent = "\u2014";
    document.getElementById(
      "solar-calc-annualBatteryNightSavings",
    ).textContent = "\u2014";
    document.getElementById("solar-calc-annualBillSavings").textContent =
      "\u2014";
    const totalSavingsEl = document.getElementById("totalAnnualBillSavings");
    if (totalSavingsEl) totalSavingsEl.textContent = "\u2014";
    const totalPriceEl = document.getElementById("totalPriceAfterGrant");
    if (totalPriceEl) totalPriceEl.textContent = "\u2014";
    const summaryGrantSpan = document.getElementById("summaryGrantValue");
    if (summaryGrantSpan) summaryGrantSpan.textContent = "\u2014";
    const summaryBatterySpan = document.getElementById("summaryBatteryValue");
    if (summaryBatterySpan) summaryBatterySpan.textContent = "None";

    // Reset self-consumption bar and labels
    const scBarFill = document.getElementById("solar-calc-scBarFill");
    const scUsedLabel = document.getElementById("solar-calc-scUsedLabel");
    const scExportLabel = document.getElementById("solar-calc-scExportLabel");
    if (scBarFill) scBarFill.style.width = "0%";
    if (scUsedLabel) scUsedLabel.textContent = "Used at home \u2014 0%";
    if (scExportLabel) scExportLabel.textContent = "Exported \u2014 0%";

    // Reset energy sub-lines
    const energyUsedEl = document.getElementById("solar-calc-energyUsedHome");
    const energyExpEl = document.getElementById("solar-calc-energyExported");
    const energyIncEl = document.getElementById(
      "solar-calc-energyExportIncome",
    );
    if (energyUsedEl) energyUsedEl.textContent = "\u2014";
    if (energyExpEl) energyExpEl.textContent = "\u2014";
    if (energyIncEl) energyIncEl.textContent = "\u2014";

    // Hide battery rows
    const battSolarRow = document.getElementById(
      "solar-calc-row-battery-solar",
    );
    const battNightRow = document.getElementById(
      "solar-calc-row-battery-night",
    );
    const battNetWrap = document.getElementById("solar-calc-batteryNetEffect");
    if (battSolarRow) battSolarRow.style.display = "none";
    if (battNightRow) battNightRow.style.display = "none";
    if (battNetWrap) battNetWrap.style.display = "none";

    // Reset price display elements
    const solarInstallEl = document.getElementById(
      "solar-calc-priceSolarInstall",
    );
    const batteryAddonRowEl = document.getElementById(
      "solar-calc-priceBatteryAddonRow",
    );
    const batteryAddonEl = document.getElementById(
      "solar-calc-priceBatteryAddon",
    );
    const grantRowEl = document.getElementById("solar-calc-priceGrantRow");
    const grantEl = document.getElementById("solar-calc-priceGrant");
    const netEl = document.getElementById("solar-calc-priceNet");
    if (solarInstallEl) solarInstallEl.textContent = "\u2014";
    if (batteryAddonRowEl) batteryAddonRowEl.style.display = "none";
    if (batteryAddonEl) batteryAddonEl.textContent = "\u2014";
    if (grantRowEl) grantRowEl.style.display = "none";
    if (grantEl) grantEl.textContent = "\u2014";
    if (netEl) netEl.textContent = "\u2014";

    // Hide price range note
    const rangeNote = document.getElementById("totalPriceRangeNote");
    if (rangeNote) rangeNote.style.display = "none";

    // Reset bill savings and price accordion headlines
    const billSavingsSummaryEl = document.getElementById(
      "solar-calc-summaryBillSavingsVal",
    );
    const priceSummaryEl = document.getElementById(
      "solar-calc-summaryPriceVal",
    );
    if (billSavingsSummaryEl) billSavingsSummaryEl.textContent = "\u2014";
    if (priceSummaryEl) priceSummaryEl.textContent = "\u2014";

    return;
  }

  // Aggregate across all committed sections
  const totalPanels = sections.reduce(
    (s, sec) => s + (sec.result ? sec.result.panelCount : 0),
    0,
  );
  const totalKwp = sections.reduce((s, sec) => {
    if (!sec.result) return s;
    const wp =
      (sec.result.panelWp != null ? sec.result.panelWp : sec.panelWp) ||
      examplePanelWp;
    return s + (sec.result.panelCount * wp) / 1000;
  }, 0);
  const totalKwh = sections.reduce(
    (s, sec) =>
      s +
      (sec.result && sec.result.annualKwh != null ? sec.result.annualKwh : 0),
    0,
  );
  const anyYield = sections.some(
    (sec) => sec.result && sec.result.annualKwh != null,
  );

  // Generation-weighted mean panel azimuth (circular mean) â€” drives the
  // seasonal import floor. Sections facing different ways are blended by how
  // much each generates, then snapped to the nearest of 8 compass shapes.
  let rtAzSumX = 0,
    rtAzSumY = 0;
  sections.forEach((sec) => {
    if (
      !sec.result ||
      sec.result.annualKwh == null ||
      sec.result.azimuthDeg == null
    )
      return;
    const w = sec.result.annualKwh;
    const rad = (sec.result.azimuthDeg * Math.PI) / 180;
    rtAzSumX += w * Math.cos(rad);
    rtAzSumY += w * Math.sin(rad);
  });
  let weightedAzimuth = 180; // default south
  if (rtAzSumX !== 0 || rtAzSumY !== 0) {
    weightedAzimuth =
      ((((Math.atan2(rtAzSumY, rtAzSumX) * 180) / Math.PI) % 360) + 360) % 360;
  }

  if (totalPanels === 0) return;

  // Read financial inputs
  const batteryKwh =
    parseFloat(document.getElementById("solar-calc-batteryKwh").value) || 0;
  const grantApplying =
    document.getElementById("solar-calc-grantApplying").value === "yes";
  const daytimeRate =
    parseFloat(document.getElementById("solar-calc-daytimeRate").value) ||
    electricIrelandDaytimeRate;
  const nightRate =
    parseFloat(document.getElementById("solar-calc-nightRate").value) ||
    electricIrelandNightRate;
  const feedinRate =
    parseFloat(document.getElementById("solar-calc-feedinTariff").value) ||
    feedInDomesticElectricIreland;
  const annualUsage =
    parseFloat(document.getElementById("solar-calc-annualUsage").value) ||
    averageHouseholdAnnualElectricityConsumption;

  // Financial variables (function-scoped so debug can read them)
  var kwhUsedNoBattery = 0,
    kwhUsedWithBattery = 0;
  var batterySolarSavings = 0,
    batteryNightSavings = 0;
  var baselineSC = 0,
    effectiveSC = 0;
  var upliftKwh = 0,
    kwhExportedReal = 0;
  var solarImportSavings = 0,
    solarExportIncome = 0;
  var totalSavings = 0,
    batteryNetEffect = 0;

  // Grant
  const grantValue = grantApplying ? calculateDomesticGrantValue(totalKwp) : 0;
  const grantText = grantApplying
    ? "\u20ac" + Math.round(grantValue).toLocaleString()
    : "\u2014";
  document.getElementById("solar-calc-domesticGrant").textContent = grantText;
  // Also update the summary span
  const summaryGrantSpan = document.getElementById("summaryGrantValue");
  if (summaryGrantSpan) {
    summaryGrantSpan.textContent = grantText;
  }

  // Update Total Results highlights (wait for price data)
  if (rtPriceData && rtPriceData.primarySystems[totalPanels]) {
    const totalEl = document.getElementById("totalPriceAfterGrant");
    if (totalEl) totalEl.textContent = "\u2014"; // will be updated below in rtUpdatePriceDisplay
  }

  // Savings (skip until yield data is available from geocode)
  if (!anyYield || totalKwh === 0) {
    document.getElementById("solar-calc-annualSolarImportSavings").textContent =
      "\u2014";
    document.getElementById("solar-calc-annualSolarExportIncome").textContent =
      "\u2014";
    document.getElementById(
      "solar-calc-annualBatterySolarSavings",
    ).textContent = "\u2014";
    document.getElementById(
      "solar-calc-annualBatteryNightSavings",
    ).textContent = "\u2014";
    document.getElementById("solar-calc-annualBillSavings").textContent =
      "\u2014";
    const totalSavingsEl = document.getElementById("totalAnnualBillSavings");
    if (totalSavingsEl) totalSavingsEl.textContent = "\u2014";
  } else {
    // --- Daytime solar self-consumption, demand-bounded --------------------
    // Self-consumed solar is derived from the MCS lookup but capped at annual
    // usage (you can never self-consume more solar than you use in a year).
    kwhUsedNoBattery = calculateSelfConsumedSolarKwh(
      totalKwh,
      annualUsage,
      0,
      weightedAzimuth,
    );

    kwhUsedWithBattery = kwhUsedNoBattery;
    batterySolarSavings = 0;
    batteryNightSavings = 0;

    if (batteryKwh > 0) {
      kwhUsedWithBattery = calculateSelfConsumedSolarKwh(
        totalKwh,
        annualUsage,
        batteryKwh,
        weightedAzimuth,
      );

      // Night-rate arbitrage: charged every night, value split between
      // displacing day imports (â‰ˆ30c) and freeing solar for export (â‰ˆ10c).
      batteryNightSavings = calculateBatterySavingsFromNightArbitragePerYear(
        totalKwh,
        annualUsage,
        batteryKwh,
        daytimeRate,
        nightRate,
        feedinRate,
        batteryNightChargesPerYearFull,
        batteryDepthOfDischargePercent,
        batteryRoundTripEfficiencyPercent,
        weightedAzimuth,
      );
    }

    // Self-consumption %, derived from the bounded kWh (never exceeds demand).
    // effectiveSC drives the breakdown display below.
    baselineSC = totalKwh > 0 ? (kwhUsedNoBattery / totalKwh) * 100 : 0;
    effectiveSC = totalKwh > 0 ? (kwhUsedWithBattery / totalKwh) * 100 : 0;

    // --- Honest, real-figure savings split ---------------------------------
    // Each kWh is counted once at its real value. The battery's extra solar
    // self-consumption (uplift) is moved out of export and credited to the
    // battery line at its full day-rate value; the export line then shows the
    // REAL (lower) amount actually sold once the battery has taken its share.
    upliftKwh = Math.max(0, kwhUsedWithBattery - kwhUsedNoBattery);
    kwhExportedReal = totalKwh - kwhUsedWithBattery;
    solarImportSavings = kwhUsedNoBattery * (daytimeRate / 100);
    solarExportIncome = kwhExportedReal * (feedinRate / 100);
    // Battery storing excess solar â€” full home-use value of the captured solar.
    if (batteryKwh > 0) {
      batterySolarSavings = upliftKwh * (daytimeRate / 100);
    }
    totalSavings =
      solarImportSavings +
      solarExportIncome +
      batterySolarSavings +
      batteryNightSavings;

    // Net effect of the battery = what the battery actually adds to the total
    // over a no-battery system. It is NOT batterySolarSavings + batteryNightSavings:
    // capturing solar in the battery reduces export income by (uplift Ã— feedin),
    // so the storing-solar line overstates the marginal gain by that amount.
    //   netBattery = uplift Ã— (dayRate âˆ’ feedin) + nightSavings
    batteryNetEffect =
      batteryKwh > 0
        ? (upliftKwh * Math.max(0, daytimeRate - feedinRate)) / 100 +
          batteryNightSavings
        : 0;

    document.getElementById("solar-calc-annualSolarImportSavings").textContent =
      "\u20ac" + Math.round(solarImportSavings).toLocaleString();
    document.getElementById("solar-calc-annualSolarExportIncome").textContent =
      "\u20ac" + Math.round(solarExportIncome).toLocaleString();
    document.getElementById("solar-calc-annualBillSavings").textContent =
      "\u20ac" + Math.round(totalSavings).toLocaleString();
    // Self-consumption split labels + bar (shown within Energy generated)
    const scBarFill = document.getElementById("solar-calc-scBarFill");
    const scUsedLabel = document.getElementById("solar-calc-scUsedLabel");
    const scExportLabel = document.getElementById("solar-calc-scExportLabel");
    const scPct = Math.round(effectiveSC);
    if (scBarFill) scBarFill.style.width = scPct + "%";
    if (scUsedLabel)
      scUsedLabel.textContent = "Used at home \u2014 " + scPct + "%";
    if (scExportLabel)
      scExportLabel.textContent = "Exported \u2014 " + (100 - scPct) + "%";

    // Energy sub-lines: used at home vs exported
    const kwhUsed = totalKwh * (effectiveSC / 100);
    const kwhExported = totalKwh - kwhUsed;
    const exportIncome = kwhExported * (feedinRate / 100);
    const energyUsedEl = document.getElementById("solar-calc-energyUsedHome");
    const energyExpEl = document.getElementById("solar-calc-energyExported");
    const energyIncEl = document.getElementById(
      "solar-calc-energyExportIncome",
    );
    if (energyUsedEl)
      energyUsedEl.textContent =
        Math.round(kwhUsed).toLocaleString() + "\u00a0kWh";
    if (energyExpEl)
      energyExpEl.textContent =
        Math.round(kwhExported).toLocaleString() + "\u00a0kWh";
    if (energyIncEl)
      energyIncEl.textContent =
        "\u20ac" + Math.round(exportIncome).toLocaleString();

    // Bill savings accordion headline
    const billSavingsSummaryEl = document.getElementById(
      "solar-calc-summaryBillSavingsVal",
    );
    if (billSavingsSummaryEl)
      billSavingsSummaryEl.textContent =
        "\u20ac" + Math.round(totalSavings).toLocaleString() + "/yr";

    // Update Total Results highlight
    const totalSavingsEl = document.getElementById("totalAnnualBillSavings");
    if (totalSavingsEl)
      totalSavingsEl.textContent =
        "\u20ac" + Math.round(totalSavings).toLocaleString();

    const battActive = batteryKwh > 0;
    document.getElementById("solar-calc-row-battery-solar").style.display =
      battActive ? "" : "none";
    document.getElementById("solar-calc-row-battery-night").style.display =
      battActive ? "" : "none";
    if (battActive) {
      document.getElementById(
        "solar-calc-annualBatterySolarSavings",
      ).textContent =
        "\u20ac" + Math.round(batterySolarSavings).toLocaleString();
      document.getElementById(
        "solar-calc-annualBatteryNightSavings",
      ).textContent =
        "\u20ac" + Math.round(batteryNightSavings).toLocaleString();
    } else {
      document.getElementById(
        "solar-calc-annualBatterySolarSavings",
      ).textContent = "\u2014";
      document.getElementById(
        "solar-calc-annualBatteryNightSavings",
      ).textContent = "\u2014";
    }

    // Net effect of the battery (shown only when a battery is fitted).
    const netEffectWrap = document.getElementById(
      "solar-calc-batteryNetEffect",
    );
    const netEffectVal = document.getElementById(
      "solar-calc-batteryNetEffectVal",
    );
    if (netEffectWrap) netEffectWrap.style.display = battActive ? "" : "none";
    if (battActive && netEffectVal) {
      netEffectVal.textContent =
        "\u20ac" + Math.round(batteryNetEffect).toLocaleString() + "/yr";
    }
  }

  rtUpdatePriceDisplay(totalPanels, batteryKwh, grantValue);

  // --- Full calculation breakdown for debug panel ---
  var totalCo2 = totalKwh * CO2_SAVING_PER_KWH;
  var pricesForCount = rtPriceData
    ? rtPriceData.primarySystems[totalPanels]
    : null;
  var solarInstallPrice =
    pricesForCount && pricesForCount.withoutBattery != null
      ? pricesForCount.withoutBattery
      : null;
  var battUpliftPrice = 0;
  if (
    batteryKwh > 0 &&
    pricesForCount &&
    pricesForCount.withFirstBattery != null
  ) {
    battUpliftPrice =
      pricesForCount.withFirstBattery - pricesForCount.withoutBattery;
    var firstKwh = pricesForCount.firstBatteryKwh || 0;
    var addon = rtPriceData.addonBattery;
    if (addon && addon.kWh > 0 && batteryKwh > firstKwh) {
      battUpliftPrice +=
        Math.max(0, Math.round((batteryKwh - firstKwh) / addon.kWh)) *
        addon.price;
    }
  }
  var grossPrice =
    solarInstallPrice != null ? solarInstallPrice + battUpliftPrice : null;
  var netPrice = grossPrice != null ? grossPrice - grantValue : null;
  var showGrantFlag = grantValue > 0;

  var finData = {
    sections: sections,
    defaultPanelWp: DEFAULT_PANEL_WP,
    defaultPitch: window.SC_CONFIG ? window.SC_CONFIG.defaultRoofPitchDeg : 35,
    defaultMargin: window.SC_CONFIG
      ? window.SC_CONFIG.defaultPanelMarginM
      : 0.5,
    totalPanels: totalPanels,
    totalKwp: totalKwp,
    totalKwh: totalKwh,
    totalCo2: totalCo2,
    weightedAzimuth: weightedAzimuth,
    batteryKwh: batteryKwh,
    grantApplying: grantApplying,
    daytimeRate: daytimeRate,
    nightRate: nightRate,
    feedinRate: feedinRate,
    annualUsage: annualUsage,
    grantValue: grantValue,
    kwhUsedNoBattery: kwhUsedNoBattery,
    kwhUsedWithBattery: kwhUsedWithBattery,
    baselineSC: baselineSC,
    effectiveSC: effectiveSC,
    upliftKwh: upliftKwh,
    batterySolarSavings: batterySolarSavings,
    batteryNightSavings: batteryNightSavings,
    kwhExportedReal: kwhExportedReal,
    solarImportSavings: solarImportSavings,
    solarExportIncome: solarExportIncome,
    totalSavings: totalSavings,
    batteryNetEffect: batteryNetEffect,
    solarInstallPrice: solarInstallPrice,
    batteryUplift: battUpliftPrice,
    grossPrice: grossPrice,
    netPrice: netPrice,
    showGrant: showGrantFlag,
  };
  renderDebug(buildFullCalculationBreakdown(finData));
}

function rtUpdatePriceDisplay(totalPanels, batteryKwh, grantValue) {
  const solarInstallEl = document.getElementById(
    "solar-calc-priceSolarInstall",
  );
  const batteryAddonRowEl = document.getElementById(
    "solar-calc-priceBatteryAddonRow",
  );
  const batteryAddonEl = document.getElementById(
    "solar-calc-priceBatteryAddon",
  );
  const grantRowEl = document.getElementById("solar-calc-priceGrantRow");
  const grantEl = document.getElementById("solar-calc-priceGrant");
  const netEl = document.getElementById("solar-calc-priceNet");

  if (!rtPriceData) {
    if (batteryAddonRowEl) batteryAddonRowEl.style.display = "";
    [solarInstallEl, batteryAddonEl, grantEl, netEl].forEach((el) => {
      if (el) el.textContent = "Loading\u2026";
    });
    return;
  }
  const pricesForCount = rtPriceData.primarySystems[totalPanels];
  if (!pricesForCount || pricesForCount.withoutBattery == null) {
    const unavail = '<a href="/contact">Contact us for a quote</a>';
    if (batteryAddonRowEl) batteryAddonRowEl.style.display = "";
    [solarInstallEl, batteryAddonEl, grantEl, netEl].forEach((el) => {
      if (el) el.innerHTML = unavail;
    });
    if (grantRowEl) grantRowEl.style.display = "";

    // Keep summary and breakdown headline in sync when outside guide range.
    const totalPriceEl = document.getElementById("totalPriceAfterGrant");
    if (totalPriceEl) totalPriceEl.innerHTML = unavail;
    const priceSummaryEl = document.getElementById(
      "solar-calc-summaryPriceVal",
    );
    if (priceSummaryEl) priceSummaryEl.textContent = "Custom quote";

    // Show range note in Total Results
    const rangeNote = document.getElementById("totalPriceRangeNote");
    if (rangeNote) rangeNote.style.display = "";

    return;
  }
  let batteryUplift = 0;
  if (batteryKwh > 0 && pricesForCount.withFirstBattery != null) {
    batteryUplift =
      pricesForCount.withFirstBattery - pricesForCount.withoutBattery;
    const firstKwh = pricesForCount.firstBatteryKwh || 0;
    const addon = rtPriceData.addonBattery;
    if (addon && addon.kWh > 0 && batteryKwh > firstKwh) {
      batteryUplift +=
        Math.max(0, Math.round((batteryKwh - firstKwh) / addon.kWh)) *
        addon.price;
    }
  }
  const grossPrice = pricesForCount.withoutBattery + batteryUplift;
  const netPrice = grossPrice - grantValue;
  const showGrant = grantValue > 0;

  if (solarInstallEl) {
    solarInstallEl.textContent =
      "\u20ac" + Math.round(pricesForCount.withoutBattery).toLocaleString();
  }
  if (batteryAddonEl) {
    batteryAddonEl.textContent =
      "\u20ac" + Math.round(batteryUplift).toLocaleString();
  }
  if (batteryAddonRowEl)
    batteryAddonRowEl.style.display = batteryUplift > 0 ? "" : "none";
  if (grantRowEl) grantRowEl.style.display = showGrant ? "" : "none";
  grantEl.textContent = showGrant
    ? "-\u20ac" + Math.round(grantValue).toLocaleString()
    : "\u2014";
  netEl.textContent =
    "\u20ac" + Math.round(showGrant ? netPrice : grossPrice).toLocaleString();

  // Update Total Results highlight
  const totalPriceEl = document.getElementById("totalPriceAfterGrant");
  if (totalPriceEl)
    totalPriceEl.textContent =
      "\u20ac" + Math.round(showGrant ? netPrice : grossPrice).toLocaleString();

  // Update Price breakdown accordion headline
  const priceSummaryEl = document.getElementById("solar-calc-summaryPriceVal");
  if (priceSummaryEl) {
    priceSummaryEl.textContent = showGrant
      ? "\u20ac" + Math.round(netPrice).toLocaleString() + " after grant"
      : "\u20ac" + Math.round(grossPrice).toLocaleString();
  }

  // Hide range note when price is available
  const rangeNote = document.getElementById("totalPriceRangeNote");
  if (rangeNote) rangeNote.style.display = "none";
}

// Kick off price-data fetch for financial sections
rtFetchPriceData();

// =========================================================================
// SHARE FEATURE — compress full calculator state into a shareable URL hash
// =========================================================================

var _pendingShareState = null; // set before map init if hash contains state

// ---- Serialize current state --------------------------------------------
function captureShareState() {
  var s = {
    v: 1,
    mode: inputMode,
    mapCenter: map ? { lat: parseFloat(map.getCenter().lat().toFixed(7)), lng: parseFloat(map.getCenter().lng().toFixed(7)) } : { lat: 53.4129, lng: -8.2439 },
    mapZoom: map ? map.getZoom() : 7,
    basemap: currentBasemap,
    hasLocated: hasLocated,
    addressLabel: currentAddressLabel,
    eircode: currentEircode,
    addressOnly: currentAddressOnly,
    panelSpec: {
      wp: parseFloat(document.getElementById("panelWp").value) || DEFAULT_PANEL_WP,
      wMm: parseFloat(document.getElementById("panelW").value) || DEFAULT_PANEL_WIDTH_MM,
      hMm: parseFloat(document.getElementById("panelH").value) || DEFAULT_PANEL_HEIGHT_MM,
      gapMm: parseFloat(document.getElementById("panelGap").value) || DEFAULT_PANEL_GAP_MM
    },
    batteryKwh: parseFloat(document.getElementById("solar-calc-batteryKwh").value) || 0,
    grantApplying: document.getElementById("solar-calc-grantApplying").value || "yes",
    rates: {
      annualUsage: parseFloat(document.getElementById("solar-calc-annualUsage").value) || 4200,
      daytimeRate: parseFloat(document.getElementById("solar-calc-daytimeRate").value) || 0.31,
      nightRate: parseFloat(document.getElementById("solar-calc-nightRate").value) || 0.15,
      feedinTariff: parseFloat(document.getElementById("solar-calc-feedinTariff").value) || 0.21
    },
    editingSectionId: editingSectionId,
    sections: sections.map(function (sec) {
      var base = {
        id: sec.id,
        label: sec.label,
        color: sec.color,
        source: sec.source || "map",
        pitch: sec.pitch,
        margin: sec.margin,
        panelW: sec.panelW,
        panelH: sec.panelH,
        panelGap: sec.panelGap,
        orientation: sec.orientation,
        panelWp: sec.panelWp,
        result: sec.result || null
      };
      if (sec.source === "manual") {
        base.manualPanelCount = sec.manualPanelCount;
        base.manualAzimuth = sec.manualAzimuth;
        base.manualTilt = sec.manualTilt;
        base.county = sec.county;
      } else {
        // Save clickPoints as plain lat/lng objects, rounded to ~1 cm precision
        base.clickPoints = (sec.clickPoints || []).map(function (p) {
          return { lat: parseFloat(p.lat().toFixed(7)), lng: parseFloat(p.lng().toFixed(7)) };
        });
        // Save panel rectangle paths so they can be redrawn instantly
        if (sec.mapObjs && sec.mapObjs.panelRectangles) {
          base.panelPaths = sec.mapObjs.panelRectangles.map(function (rect) {
            return rect.getPath().getArray().map(function (latLng) {
              return { lat: parseFloat(latLng.lat().toFixed(7)), lng: parseFloat(latLng.lng().toFixed(7)) };
            });
          });
        }
      }
      return base;
    }),
    manualCounty: inputMode === "manual" ? (document.getElementById("rtManualCounty").value || "Dublin") : "Dublin",
    manualNextLabel: manualNextLabel
  };
  return s;
}

// ---- Compress / decompress via lz-string ------------------------------
function _shareEncode(obj) {
  return LZString.compressToEncodedURIComponent(JSON.stringify(obj));
}

function _shareDecode(str) {
  return JSON.parse(LZString.decompressFromEncodedURIComponent(str));
}

// ---- Build share URL ---------------------------------------------------
function buildShareUrl() {
  var state = captureShareState();
  var encoded = _shareEncode(state);
  return window.location.origin + window.location.pathname + "#state=" + encoded;
}

var _shareCopyResetTimer = null;
var _sharePopoverOpen = false;

function _copyTextToClipboard(text, onSuccess) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(function () {
      if (typeof onSuccess === "function") onSuccess();
    })["catch"](function () {
      _fallbackCopy(text, onSuccess);
    });
    return;
  }

  _fallbackCopy(text, onSuccess);
}

function _fallbackCopy(text, onSuccess) {
  var textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  try {
    document.execCommand("copy");
    if (typeof onSuccess === "function") onSuccess();
  } catch (e) {
    alert("Copy this link to share:\n\n" + text);
  }
  document.body.removeChild(textarea);
}

function copyShareLink(onSuccess) {
  var url = buildShareUrl();
  _copyTextToClipboard(url, function () {
    if (typeof onSuccess === "function") onSuccess(url);
  });
}

function _syncShareLinkInput(url) {
  var input = document.getElementById("rtShareLinkInput");
  if (input) {
    input.value = url;
  }
}

function _setShareCopyButtonState(label, isCopied) {
  var copyBtn = document.getElementById("rtShareCopyBtn");
  if (!copyBtn) return;
  copyBtn.textContent = label;
  if (isCopied) {
    copyBtn.classList.add("is-copied");
  } else {
    copyBtn.classList.remove("is-copied");
  }
}

function _resetShareCopyButtonState() {
  var copyBtn = document.getElementById("rtShareCopyBtn");
  if (!copyBtn) return;
  _setShareCopyButtonState(copyBtn.getAttribute("data-default-label") || "Copy Link", false);
}

function _markShareCopied() {
  if (_shareCopyResetTimer) {
    clearTimeout(_shareCopyResetTimer);
    _shareCopyResetTimer = null;
  }

  var copyBtn = document.getElementById("rtShareCopyBtn");
  if (copyBtn) {
    copyBtn.innerHTML = '<i class="fas fa-check" aria-hidden="true"></i> Copied';
    copyBtn.classList.add("is-copied");
  }
  _shareCopyResetTimer = setTimeout(function () {
    _resetShareCopyButtonState();
    _shareCopyResetTimer = null;
  }, 2500);
}

function openSharePopover() {
  var popover = document.getElementById("rtSharePopover");
  var shareBtn = document.getElementById("rtShareBtn");
  if (!popover || !shareBtn) return;

  var url = buildShareUrl();
  _syncShareLinkInput(url);
  _resetShareCopyButtonState();

  popover.hidden = false;
  _sharePopoverOpen = true;
  shareBtn.setAttribute("aria-expanded", "true");
}

function closeSharePopover(returnFocusToTrigger) {
  var popover = document.getElementById("rtSharePopover");
  var shareBtn = document.getElementById("rtShareBtn");
  if (!popover || !shareBtn) return;

  popover.hidden = true;
  _sharePopoverOpen = false;
  shareBtn.setAttribute("aria-expanded", "false");

  if (returnFocusToTrigger) {
    shareBtn.focus();
  }
}

function toggleSharePopover() {
  if (_sharePopoverOpen) {
    closeSharePopover(false);
  } else {
    openSharePopover();
  }
}

// ---- Check hash for shared state on page load --------------------------
function checkForSharedState() {
  var hash = window.location.hash;
  if (!hash || hash.indexOf("#state=") !== 0) return null;
  try {
    var encoded = hash.substring(7); // remove "#state="
    return _shareDecode(encoded);
  } catch (e) {
    console.warn("Share: failed to parse shared state", e);
    return null;
  }
}

// ---- Restore full calculator state from a share-state object -----------
function restoreFromShareState(state) {
  if (!state || state.v !== 1) return;

  // 1. Set global form values that don't trigger runFinancials
  //    (panel spec, electricity rates — safe to set before sections exist)
  document.getElementById("panelWp").value = state.panelSpec.wp;
  document.getElementById("panelW").value = state.panelSpec.wMm;
  document.getElementById("panelH").value = state.panelSpec.hMm;
  document.getElementById("panelGap").value = state.panelSpec.gapMm;
  rtSyncAllItemValues();

  document.getElementById("solar-calc-annualUsage").value = state.rates.annualUsage;
  document.getElementById("solar-calc-daytimeRate").value = state.rates.daytimeRate;
  document.getElementById("solar-calc-nightRate").value = state.rates.nightRate;
  document.getElementById("solar-calc-feedinTariff").value = state.rates.feedinTariff;
  // Sync rate summary labels
  var el;
  el = document.getElementById("solar-calc-annualUsageValue"); if (el) el.textContent = state.rates.annualUsage + " kWh/yr";
  el = document.getElementById("solar-calc-daytimeRateValue"); if (el) el.textContent = state.rates.daytimeRate.toFixed(2) + " c/kWh";
  el = document.getElementById("solar-calc-nightRateValue"); if (el) el.textContent = state.rates.nightRate.toFixed(2) + " c/kWh";
  el = document.getElementById("solar-calc-feedinTariffValue"); if (el) el.textContent = state.rates.feedinTariff.toFixed(2) + " c/kWh";

  // 2. Switch to correct mode (clears sections for the other mode)
  switchMode(state.mode);

  // 3. Set map center, zoom, basemap
  if (map && state.mapCenter) {
    map.setCenter(state.mapCenter);
    map.setZoom(state.mapZoom);
  }
  if (state.basemap && state.basemap !== currentBasemap) {
    setBasemap(state.basemap);
  }

  // 4. Restore address display
  hasLocated = state.hasLocated;
  currentAddressLabel = state.addressLabel || "";
  currentEircode = state.eircode || "";
  currentAddressOnly = state.addressOnly || "";
  updateInstruction();
  if (hasLocated && currentAddressLabel) {
    var addrVal = document.getElementById("rtCurrentAddressText");
    if (addrVal) addrVal.textContent = currentAddressLabel;
    var addrWrap = document.getElementById("rtCurrentAddress");
    if (addrWrap) addrWrap.style.display = "";
  }

  // 5. Restore sections (populates sections[] so runFinancials has data)
  if (state.mode === "map") {
    restoreMapSections(state);
  } else {
    restoreManualSections(state);
  }

  // 6. Set battery & grant LAST — they call runFinancials() internally,
  //    which needs sections[] populated to avoid resetting summary labels.
  rtSetBattery(state.batteryKwh);
  rtSetGrant(state.grantApplying);
}

// ---- Restore map-drawn sections from share state -----------------------
function restoreMapSections(shareState) {
  var savedSections = shareState.sections.filter(function (s) { return s.source !== "manual"; });
  if (savedSections.length === 0) return;

  // Clear any existing drawing state
  sections = [];
  editingSectionId = null;
  undoStack = [];
  if (previewPolyline) { previewPolyline.setMap(null); previewPolyline = null; }
  pointMarkers.forEach(function (m) { m.setMap(null); });
  pointMarkers = [];
  clearPanels();
  if (roofPolygon) { roofPolygon.setMap(null); roofPolygon = null; }
  if (gutterLine) { gutterLine.setMap(null); gutterLine = null; }
  if (gutterLabel) { gutterLabel.setMap(null); gutterLabel = null; }

  // Build a map from old IDs → new sections (for editingSectionId lookup)
  var idMap = {};

  savedSections.forEach(function (secData) {
    editingSectionId = null;
    clickPoints = secData.clickPoints.map(function (p) {
      return new google.maps.LatLng(p.lat, p.lng);
    });

    // Set form values to this section's settings
    document.getElementById("pitch").value = secData.pitch;
    document.getElementById("margin").value = secData.margin;
    document.getElementById("panelW").value = secData.panelW;
    document.getElementById("panelH").value = secData.panelH;
    document.getElementById("panelGap").value = secData.panelGap;
    document.getElementById("orientation").value = secData.orientation;
    document.getElementById("panelWp").value = secData.panelWp;
    rtSyncAllItemValues();

    // Create roof polygon
    roofPolygon = new google.maps.Polygon({
      paths: clickPoints,
      map: map,
      strokeColor: secData.color,
      strokeWeight: 2,
      fillColor: secData.color,
      fillOpacity: 0.25,
      clickable: false,
      zIndex: 1
    });

    // Create gutter line
    if (clickPoints.length >= 2) {
      gutterLine = new google.maps.Polyline({
        path: [clickPoints[0], clickPoints[1]],
        map: map,
        strokeColor: "#333333",
        strokeWeight: 4,
        strokeOpacity: 1,
        zIndex: 10
      });
    }

    // Create point markers (hidden initially — editSection will show the active ones)
    pointMarkers = [];
    clickPoints.forEach(function (pt, i) {
      addPointMarker(pt, i + 1);
    });

    // Recreate panel rectangles from saved paths
    var panelRects = [];
    if (secData.panelPaths) {
      secData.panelPaths.forEach(function (path) {
        var rect = new google.maps.Polygon({
          paths: path,
          map: map,
          strokeColor: "#0066cc",
          strokeWeight: 1,
          strokeOpacity: 0.9,
          fillColor: "#1e90ff",
          fillOpacity: 0.75,
          clickable: false,
          zIndex: 2
        });
        panelRects.push(rect);
      });
    }
    // Set globals so commitOrUpdateSection can read them (but we push manually)
    panelRectangles = panelRects;
    state = STATE.CLOSED;

    // Push directly to sections array (bypass commitOrUpdateSection to avoid
    // async geocoding; we already have the saved result).
    var newId = Date.now() + savedSections.indexOf(secData);
    sections.push({
      id: newId,
      label: secData.label,
      color: secData.color,
      source: "map",
      clickPoints: clickPoints.slice(),
      pitch: secData.pitch,
      margin: secData.margin,
      panelW: secData.panelW,
      panelH: secData.panelH,
      panelGap: secData.panelGap,
      orientation: secData.orientation,
      panelWp: secData.panelWp,
      result: secData.result,
      mapObjs: {
        roofPolygon: roofPolygon,
        pointMarkers: pointMarkers.slice(),
        panelRectangles: panelRects.slice(),
        gutterLine: gutterLine
      }
    });
    idMap[secData.id] = newId;
    editingSectionId = newId;

    // Null out globals ready for next section
    roofPolygon = null;
    gutterLine = null;
    panelRectangles = [];
    pointMarkers = [];
  });

  // Restore the last-edited section as active
  if (shareState.editingSectionId && idMap[shareState.editingSectionId]) {
    editSection(idMap[shareState.editingSectionId]);
  } else if (sections.length > 0) {
    editSection(sections[0].id);
  }

  updateUndoButton();
  renderSectionsPanel();
  document.getElementById("btnAddSection").style.display = "block";
  // Re-run financials with restored state
  runFinancials();
  // Ensure the instruction pill reflects the restored state (not the
  // stale IDLE message that updateInstruction() may have shown earlier).
  updateInstruction();
}

// ---- Restore manual sections from share state --------------------------
function restoreManualSections(shareState) {
  manualSections = [];
  manualNextLabel = 0;
  // Remove any existing manual sections from shared array
  sections = sections.filter(function (s) { return s.source !== "manual"; });

  var savedSections = shareState.sections.filter(function (s) { return s.source === "manual"; });
  if (savedSections.length === 0) {
    addManualSection();
    return;
  }

  // Set county dropdown
  var countySelect = document.getElementById("rtManualCounty");
  if (countySelect && shareState.manualCounty) {
    countySelect.value = shareState.manualCounty;
    populateCountyDropdown(); // ensure dropdown is populated
  }

  savedSections.forEach(function (secData, i) {
    var id = Date.now() + i;
    var panelWp = secData.panelWp || parseFloat(document.getElementById("panelWp").value) || DEFAULT_PANEL_WP;
    var county = secData.county || shareState.manualCounty || "Dublin";
    var sec = {
      id: id,
      label: "Section " + String.fromCharCode(65 + i),
      source: "manual",
      manualPanelCount: secData.manualPanelCount,
      manualAzimuth: secData.manualAzimuth,
      manualTilt: secData.manualTilt,
      county: county,
      panelWp: panelWp,
      color: SECTION_COLORS[i % SECTION_COLORS.length],
      result: null
    };

    // Calculate yield if panel count provided
    var count = parseInt(sec.manualPanelCount);
    if (count && count > 0) {
      var y = calcYield(count, panelWp, sec.manualAzimuth, sec.manualTilt, county);
      sec.result = y ? {
        panelCount: count,
        azimuthDeg: sec.manualAzimuth,
        pitchDeg: sec.manualTilt,
        panelWp: panelWp,
        county: county,
        annualKwh: y.annualKwh,
        annualCo2: y.annualCo2,
        arrayKwp: y.arrayKwp,
        countyEffectPercent: y.countyEffectPercent,
        cardinalDir: CARDINALS[Math.round(sec.manualAzimuth / 22.5) % 16],
        orientationLabel: CARDINALS[Math.round(sec.manualAzimuth / 22.5) % 16] + "-facing"
      } : null;
    }

    manualSections.push(sec);
    sections.push(sec);
    manualNextLabel = i + 1;
  });

  renderManualSections();
  updateManualSummary();
  renderSectionsPanel();
  runFinancials();
}

// ---- Wire up share button + check hash on load -------------------------
var _shareBtn = document.getElementById("rtShareBtn");
var _sharePopover = document.getElementById("rtSharePopover");
var _shareCloseBtn = document.getElementById("rtShareCloseBtn");
var _shareCopyBtn = document.getElementById("rtShareCopyBtn");

if (_shareBtn && _sharePopover) {
  _shareBtn.addEventListener("click", function (event) {
    event.preventDefault();
    toggleSharePopover();
  });

  document.addEventListener("click", function (event) {
    if (!_sharePopoverOpen) return;
    var target = event.target;
    if (_sharePopover.contains(target) || _shareBtn.contains(target)) return;
    closeSharePopover(false);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && _sharePopoverOpen) {
      event.preventDefault();
      closeSharePopover(true);
    }
  });
}

if (_shareCloseBtn) {
  _shareCloseBtn.addEventListener("click", function () {
    closeSharePopover(true);
  });
}

if (_shareCopyBtn) {
  _shareCopyBtn.addEventListener("click", function () {
    copyShareLink(function (url) {
      _syncShareLinkInput(url);
      _markShareCopied();
    });
  });
}

_pendingShareState = checkForSharedState();

// Hook into initMap to restore state after the map is ready.
// We wrap the original initMap so we don't have to edit its internals.
(function () {
  var _origInitMap = initMap;
  window.initMap = function () {
    // Call original (may be async, but we handle both sync and async returns)
    var result = _origInitMap.apply(this, arguments);

    // If the original returned a Promise, wait for it; otherwise schedule restore
    function doRestore() {
      if (_pendingShareState) {
        setTimeout(function () {
          restoreFromShareState(_pendingShareState);
          _pendingShareState = null;
        }, 400); // small delay to let tiles + basemap settle
      }
    }

    if (result && typeof result.then === "function") {
      result.then(doRestore);
    } else {
      doRestore();
    }

    return result;
  };
})();

// expose initMap to the global scope for the Maps callback
window.initMap = window.initMap; // already set by the wrapper above

// ---- Site Survey CTA: toggle, eircode pre-pop, share-link injection ----
(function () {
  var banner = document.getElementById('rtSurveyBanner');
  var formWrap = document.getElementById('rtSurveyFormWrap');
  var btnOpen = document.getElementById('btnOpenSurvey');
  var btnCancel = document.getElementById('btnCancelSurvey');
  var eircodeField = document.getElementById('scs_eircode');
  var addressField = document.getElementById('scs_address');
  var shareLinkField = document.getElementById('scs_share_link');
  var surveyForm = document.getElementById('SolarCalcSurveyForm');

  if (!banner || !formWrap) return;

  // Toggle: open form
  if (btnOpen) {
    btnOpen.addEventListener('click', function () {
      banner.style.display = 'none';
      formWrap.style.display = '';

      // Pre-populate eircode and address from map search
      if (eircodeField && typeof currentEircode !== 'undefined' && currentEircode) {
        eircodeField.value = currentEircode;
      }
      if (addressField && typeof currentAddressOnly !== 'undefined' && currentAddressOnly) {
        addressField.value = currentAddressOnly;
      }
    });
  }

  // Toggle: cancel back to banner
  if (btnCancel) {
    btnCancel.addEventListener('click', function () {
      banner.style.display = '';
      formWrap.style.display = 'none';
    });
  }

  // Inject share link before form submit
  if (surveyForm && shareLinkField) {
    surveyForm.addEventListener('submit', function () {
      if (typeof buildShareUrl === 'function') {
        shareLinkField.value = buildShareUrl();
      }
    });
  }

  // Panel power warning: show if changed from default
  (function () {
    var panelWpInput = document.getElementById('panelWp');
    var panelWpWarning = document.getElementById('panelWpWarning');
    var defaultWp = window.SC_CONFIG.defaultPanelWp;
    if (!panelWpInput || !panelWpWarning) return;

    function checkPanelWp() {
      panelWpWarning.style.display = (parseInt(panelWpInput.value, 10) !== defaultWp) ? '' : 'none';
    }
    panelWpInput.addEventListener('input', checkPanelWp);
    // Also check on page load (in case share-link restores a non-default value)
    checkPanelWp();
  })();
})();
 /**
 * Solar Calculator Feedback Widget
 * Collects qualitative feedback via Google Apps Script backend.
 */
(function () {
  "use strict";

  // =========================================================================
  // CONFIGURATION
  // =========================================================================
  var GAS_WEBAPP_URL = "https://script.google.com/macros/s/AKfycby-6sV_qPm70YILGZcJ9CyVw6B2-4DWWTr5hEHeiL-bmTHDO5vI0HeYoU3or4OifLjI/exec";

  // Placeholder text per sentiment
  var PLACEHOLDERS = {
    "I-love-it": "Great! What did you like most, or what could we add?",
    okay: "What would have made it more useful for you?",
    "not-helpful": "Sorry to hear that. What could we improve?"
  };

  // Spam trigger words — silently fail if any appear in feedback text
  // Mirrors the server-side list in _commonlibraries/antispam/AntiSpamValidator.php
  var SPAM_TRIGGER_WORDS = [
    // Pharma
    "viagra", "cialis", "pharmacy online", "prescription drugs",
    // Gambling
    "casino", "poker online", "gambling",
    // Crypto/Finance
    "bitcoin", "ethereum", "blockchain", "forex", "cryptocurrency",
    // SEO/Marketing spam
    "backlink", "link building", "guest post", "rank your website", "seo services",
    // Adult
    "dating site",
    // Scam patterns
    "lottery winner", "inheritance fund", "urgent reply", "kindly respond",
    "beneficiary", "western union", "wire transfer",
    "make money fast", "work from home opportunity", "million dollars",
    // Suspicious URLs / injection
    "t.me/", "bit.ly/", "tinyurl.com", "goo.gl/", "ow.ly/",
    "[url=", "[link="
  ];

  // =========================================================================
  // DOM REFS
  // =========================================================================
  var widget = document.getElementById("rtFeedback");
  if (!widget) return; // Not on a calculator page — bail

  var promptEl = document.getElementById("rtFeedbackPrompt");
  var formEl = document.getElementById("rtFeedbackForm");
  var thanksEl = document.getElementById("rtFeedbackThanks");
  var errorEl = document.getElementById("rtFeedbackError");
  var textarea = document.getElementById("rtFeedbackText");
  var honeypot = document.getElementById("rtFeedbackHoneypot");
  var submitBtn = document.getElementById("rtFeedbackSubmit");
  var cancelBtn = document.getElementById("rtFeedbackCancel");
  var resubmitBtn = document.getElementById("rtFeedbackResubmit");
  var closeBtn = document.getElementById("rtFeedbackClose");
  var sentimentBtns = widget.querySelectorAll(".solar-calc-feedback__btn");

  var selectedSentiment = null;
  var hasSubmitted = false;

  // =========================================================================
  // EVENT HANDLERS
  // =========================================================================

  // Sentiment button click
  sentimentBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (hasSubmitted) return;

      // Visual selection
      sentimentBtns.forEach(function (b) { b.classList.remove("is-selected"); });
      btn.classList.add("is-selected");

      selectedSentiment = btn.getAttribute("data-sentiment");
      textarea.placeholder = PLACEHOLDERS[selectedSentiment] || "";

      // Show the form
      formEl.style.display = "";
      errorEl.style.display = "none";
    });
  });

  // Cancel button — collapse back to initial state
  if (cancelBtn) {
    cancelBtn.addEventListener("click", function () {
      formEl.style.display = "none";
      errorEl.style.display = "none";
      sentimentBtns.forEach(function (b) { b.classList.remove("is-selected"); });
      selectedSentiment = null;
      textarea.value = "";
    });
  }

  // Submit
  if (submitBtn) {
    submitBtn.addEventListener("click", function () {
      if (hasSubmitted) return;

      // ---- Honeypot check (Level 1) ----
      if (honeypot && honeypot.value.trim() !== "") {
        // Bot detected — pretend success silently
        fakeSuccess();
        return;
      }

      var feedbackText = textarea.value.trim();
      var feedbackTextLower = feedbackText.toLowerCase();

      // ---- Spam trigger-word check (Level 2) ----
      for (var i = 0; i < SPAM_TRIGGER_WORDS.length; i++) {
        if (feedbackTextLower.indexOf(SPAM_TRIGGER_WORDS[i]) !== -1) {
          fakeSuccess();
          return;
        }
      }

      // ---- URL count check (Level 3) ----
      // Count complete URLs (http://, https://, or www.) — 1 URL is fine (e.g. a reference link),
      // but 2+ is spam. Email addresses (user@example.com) are NOT counted.
      var urlMatches = feedbackTextLower.match(/(https?:\/\/[^\s]+|www\.[^\s]+)/gi);
      var urlCount = urlMatches ? urlMatches.length : 0;
      if (urlCount >= 2) {
        fakeSuccess();
        return;
      }

      // Always generate the share URL so we can see their exact calculator state
      var shareUrl = (typeof buildShareUrl === "function") ? buildShareUrl() : "";

      // Allow empty text (just sentiment is fine), but still ship it
      var payload = {
        sentiment: selectedSentiment || "none",
        feedback_text: feedbackText,
        share_url: shareUrl,
        client_js: true   // server-side honeypot — proves submission came via real JS form
      };

      submitBtn.disabled = true;
      submitBtn.innerHTML = '<i class="far fa-spinner fa-pulse" aria-hidden="true"></i> Sending...';

      fetch(GAS_WEBAPP_URL, {
        method: "POST",
        mode: "no-cors", // GAS Web App redirects; no-cors avoids opaque-response issues
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      })
        .then(function () {
          // no-cors means we can't read the response — assume success
          markSubmitted();
          showThanks();
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.innerHTML = '<i class="far fa-paper-plane" aria-hidden="true"></i> Send Feedback';
          errorEl.style.display = "";
        });
    });
  }

  // Close (dismiss) — hide widget for current page session only
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      widget.style.display = "none";
    });
  }

  // Resubmit — reset to initial state so they can send more feedback
  if (resubmitBtn) {
    resubmitBtn.addEventListener("click", function () {
      hasSubmitted = false;

      thanksEl.style.display = "none";
      promptEl.style.display = "";
      formEl.style.display = "none";
      errorEl.style.display = "none";

      sentimentBtns.forEach(function (b) { b.classList.remove("is-selected"); });
      selectedSentiment = null;
      textarea.value = "";
      submitBtn.disabled = false;
      submitBtn.innerHTML = '<i class="far fa-paper-plane" aria-hidden="true"></i> Send Feedback';
    });
  }

  // =========================================================================
  // HELPERS
  // =========================================================================
  function showThanks() {
    promptEl.style.display = "none";
    formEl.style.display = "none";
    errorEl.style.display = "none";
    thanksEl.style.display = "";
  }

  function markSubmitted() {
    hasSubmitted = true;
  }

  function fakeSuccess() {
    // Pretend success for bots that filled the honeypot
    hasSubmitted = true;
    showThanks();
  }
})();
